export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
};

export type Account = {
  _id?: Maybe<Scalars['ID']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  last_active?: Maybe<Scalars['String']>;
  verificationToken?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['String']>;
  passwordReset?: Maybe<Scalars['String']>;
  resetToken?: Maybe<ResetToken>;
  user_infos?: Maybe<CompanyUser>;
  passwordHash?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Maybe<Country>>>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type Action = {
  /** Identtify element  */
  _id?: Maybe<Scalars['ID']>;
  /** Is deleted */
  isDeleted: Scalars['Boolean'];
  /** Created at */
  createdAt: Scalars['String'];
  /** Updated at */
  updatedAt: Scalars['String'];
  /** User who created the record */
  createdBy: EditedBy;
  /** User who changed the record */
  editedBy: EditedBy;
  /** Course uid */
  uid: Scalars['String'];
  /** Action execution Date */
  executionDate?: Maybe<Scalars['String']>;
  /** Action execution time */
  executionTime?: Maybe<Scalars['String']>;
  /** Action start Date */
  startDate?: Maybe<Scalars['String']>;
  /** Action start Time */
  startTime?: Maybe<Scalars['String']>;
  /** Action end Date */
  endDate?: Maybe<Scalars['String']>;
  /** Action end Time */
  endTime?: Maybe<Scalars['String']>;
  /** Action course reference */
  reference: Scalars['String'];
  /** status of the action  */
  status: ActionStatus;
  /** type of the action (pickup or delivery) */
  type: ActionType;
  /** Action address! */
  address?: Maybe<Address>;
  /** Action items */
  items?: Maybe<Array<IActionItem>>;
  /** Action remittance info */
  remittanceInfo?: Maybe<IRemittanceInfo>;
  /** Course of the action! */
  course?: Maybe<Scalars['String']>;
  /** Course clients */
  client?: Maybe<Client>;
  /** Course individuals clients */
  individualClient?: Maybe<Individualsclient>;
  /** Action finish reason */
  reason?: Maybe<Scalars['String']>;
  /** Action receiver */
  receiver?: Maybe<ContactInput>;
};

/** Status of the action! */
export enum ActionStatus {
  Default = 'DEFAULT',
  NotStarted = 'NOT_STARTED',
  Paused = 'PAUSED',
  Done = 'DONE'
}

/** drivers card types! */
export enum ActionType {
  Pickup = 'PICKUP',
  Delivery = 'DELIVERY'
}

export type ActionUpdatedItem = {
  _id?: Maybe<Scalars['ID']>;
  templateStopId: Scalars['ID'];
  action: EActionType;
  dateRange?: Maybe<Array<Maybe<Scalars['String']>>>;
  pickupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  hubId?: Maybe<Scalars['ID']>;
};

export type ActivateAccountInput = {
  clientId: Scalars['ID'];
};

export type ActivateAccountResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['ID']>;
};

export type Activity = {
  _id?: Maybe<Scalars['ID']>;
  activity_date?: Maybe<Scalars['String']>;
  activity_trigger_action?: Maybe<ActivityTriggerActionEnum>;
  activity_trigger_action_previous_data?: Maybe<Scalars['String']>;
  activity_trigger_action_next_data?: Maybe<Scalars['String']>;
  activity_trigger_action_data?: Maybe<Scalars['String']>;
  activity_trigger_action_data_reason?: Maybe<Scalars['String']>;
  activity_updated_by?: Maybe<UserCreatedBy>;
  activity_trigger_by_user_type?: Maybe<ActivityTriggerUserTypeEnum>;
  activity_trigger_by_user_id?: Maybe<Scalars['String']>;
  activity_trigger_source?: Maybe<Scalars['String']>;
  activity_source_UID?: Maybe<Scalars['String']>;
  activity_source_context?: Maybe<Scalars['String']>;
};

export enum ActivityTriggerActionEnum {
  Creation = 'CREATION',
  Updated = 'UPDATED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  EditedParcelValue = 'EDITED_PARCEL_VALUE',
  EditedParcelAmountToCollect = 'EDITED_PARCEL_AMOUNT_TO_COLLECT',
  EditedOrderAddress = 'EDITED_ORDER_ADDRESS',
  Edited = 'EDITED',
  StatusUpdated = 'STATUS_UPDATED',
  Archived = 'ARCHIVED',
  TagUpdated = 'TAG_UPDATED',
  Unassigned = 'UNASSIGNED',
  ParcelAdded = 'PARCEL_ADDED',
  ParcelDeleted = 'PARCEL_DELETED',
  Assigned = 'ASSIGNED',
  Reassigned = 'REASSIGNED',
  HandedOver = 'HANDED_OVER',
  Transfered = 'TRANSFERED',
  Reconciled = 'RECONCILED',
  NotReceived = 'NOT_RECEIVED',
  NotCollected = 'NOT_COLLECTED',
  ReceivedAtRelay = 'RECEIVED_AT_RELAY',
  CancelledAtRelay = 'CANCELLED_AT_RELAY',
  GivenToReceiver = 'GIVEN_TO_RECEIVER',
  OnReturnToHub = 'ON_RETURN_TO_HUB',
  ActionRelayOpened = 'ACTION_RELAY_OPENED',
  ConfirmationCodeToRemitFromRelay = 'CONFIRMATION_CODE_TO_REMIT_FROM_RELAY',
  ReceivedByClient = 'RECEIVED_BY_CLIENT',
  NotReceivedByClient = 'NOT_RECEIVED_BY_CLIENT',
  ResendByOps = 'RESEND_BY_OPS',
  OutOfZoneCheck = 'OUT_OF_ZONE_CHECK',
  EarlyCheck = 'EARLY_CHECK',
  LateCheck = 'LATE_CHECK',
  CheckCompleted = 'CHECK_COMPLETED',
  MadMissionSuspended = 'MAD_MISSION_SUSPENDED',
  MadMissionCompleted = 'MAD_MISSION_COMPLETED',
  TaskAlert = 'TASK_ALERT',
  CheckCompletedByAgent = 'CHECK_COMPLETED_BY_AGENT',
  MissionCompletedByAgent = 'MISSION_COMPLETED_BY_AGENT',
  AdvantageUse = 'ADVANTAGE_USE',
  ActivateProgram = 'ACTIVATE_PROGRAM',
  DeactivateProgram = 'DEACTIVATE_PROGRAM',
  ApplyReduction = 'APPLY_REDUCTION',
  TaskUnassignation = 'TASK_UNASSIGNATION',
  Blocked = 'BLOCKED',
  Unblocked = 'UNBLOCKED',
  AddedInRemittance = 'ADDED_IN_REMITTANCE',
  Started = 'STARTED',
  Finished = 'FINISHED'
}

export enum ActivityTriggerUserTypeEnum {
  Ops = 'OPS',
  Client = 'CLIENT',
  Papser = 'PAPSER',
  Conveyor = 'CONVEYOR'
}

export type Actor = {
  Client?: Maybe<Slots>;
  WH?: Maybe<Slots>;
  Receiver?: Maybe<Slots>;
};

/** Add BillingAccount INPUT INFO */
export type AddBillingAccount = {
  billing_account_department: Scalars['String'];
  billing_account_contact_firstname: Scalars['String'];
  billing_account_contact_lastname: Scalars['String'];
  billing_account_contact_job: Scalars['String'];
  billing_account_contact_phone_number: Scalars['String'];
  billing_account_contact_email: Scalars['String'];
};

/** Add BillingAccount INPUT */
export type AddBillingAccountInput = {
  billingAccount: AddBillingAccount;
  clientID: Scalars['ID'];
};

/** Add BillingAccount RESPONSE */
export type AddBillingAccountsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<BillingAccount>;
};

/** ADDCLIENT INPUT */
export type AddClientInput = {
  client_company_name: Scalars['String'];
  client_activity: Scalars['String'];
  client_phone_number: Scalars['String'];
  client_email?: Maybe<Scalars['String']>;
  client_website?: Maybe<Scalars['String']>;
  client_address: AddressCreationInput;
  client_trade_register_url?: Maybe<Scalars['String']>;
  client_ninea_url?: Maybe<Scalars['String']>;
  client_ninea_number?: Maybe<Scalars['String']>;
  client_contact_firstname: Scalars['String'];
  client_contact_lastname: Scalars['String'];
  client_contact_job: Scalars['String'];
  client_contact_phone_number: Scalars['String'];
  client_contact_email: Scalars['String'];
  client_contract_is_signed: Scalars['Boolean'];
  client_contract_start_date?: Maybe<Scalars['String']>;
  client_contract_end_date?: Maybe<Scalars['String']>;
  client_billing?: Maybe<Billing_Type>;
  client_payment_mode?: Maybe<Payment_Mode>;
  client_payment_frequency?: Maybe<Payment_Frequency>;
  client_options_contracts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  client_picture_url?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Maybe<CountryInput>>>;
  deniedSMSType?: Maybe<Array<Maybe<DeniedSmsType>>>;
  services?: Maybe<Array<Maybe<EService>>>;
  packaging?: Maybe<Scalars['Boolean']>;
};

export type AddClientRequestInput = {
  client_company_name: Scalars['String'];
  client_activity: Scalars['String'];
  client_phone_number: Scalars['String'];
  client_address: AddressCreationInput;
  client_contact_firstname: Scalars['String'];
  client_contact_lastname: Scalars['String'];
  client_contact_job: Scalars['String'];
  client_contact_phone_number: Scalars['String'];
  client_contact_email: Scalars['String'];
};

export type AddIndividualClientAddressInput = {
  /** Individual client id */
  clientID: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  address: Scalars['String'];
  addressName: Scalars['String'];
};

export type AddModuleInput = {
  module: ModuleCreationInput;
  permissions: Array<Maybe<PermissionCreationInput>>;
};

export type AddModuleResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Module>;
};

/** Add addMultipleGift INPUT */
export type AddMultipleGiftInput = {
  gifts: Array<GiftMultipleCreationInput>;
};

/** Add addMultipleGift RESPONSE */
export type AddMultipleGiftResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Gift>>>;
};

export type AddPermissionInput = {
  moduleID: Scalars['ID'];
  permission?: Maybe<PermissionCreationInput>;
};

export type AddPermissionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Permission>;
};

export type AddRequestInput = {
  clientId: Scalars['ID'];
  type: ERequestType;
  status?: Maybe<ERequestStatus>;
  vehicles?: Maybe<Array<Maybe<EVehiclesInput>>>;
  templateStops?: Maybe<Array<Maybe<TemplateStopsInput>>>;
  templateAxes?: Maybe<Array<Maybe<TemplateAxeInput>>>;
  startDate: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  address?: Maybe<AddressCreationInput>;
  productType?: Maybe<Array<Maybe<EProductType>>>;
  additionnalInfos?: Maybe<Scalars['String']>;
  reccurenceType?: Maybe<EReccurenceType>;
  reccurenceOptions?: Maybe<ReccurenceOptionsInput>;
  handler?: Maybe<HandlerInput>;
  dispatcher?: Maybe<DispatcherInput>;
  discount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  pricingType?: Maybe<RequestPricing>;
  packagePrice?: Maybe<Scalars['Int']>;
};

export type AddRoleInput = {
  role: RoleCreationInput;
  permissions: Array<Scalars['ID']>;
};

export type AddRoleResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Role>;
};

export type AddUserInput = {
  user: UserInfosInput;
};

export type AddUserResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataAddUserResponse>;
};

export type Address = {
  _id?: Maybe<Scalars['ID']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  additional_address?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  place_id?: Maybe<Scalars['String']>;
  source_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<Scalars['String']>;
};

/** LOCATION MODULE MUTATIONS */
export type AddressCreationInput = {
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  additional_address?: Maybe<Scalars['String']>;
  formatted_address?: Maybe<Scalars['String']>;
  location?: Maybe<LocationInput>;
};

export type AddressInput = {
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  additional_address?: Maybe<Scalars['String']>;
  location?: Maybe<LocationInput>;
  place_id?: Maybe<Scalars['String']>;
  source_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<Scalars['String']>;
};

export type AddressUpdateInput = {
  additional_address?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
};

export type Advantage = {
  _id: Scalars['ID'];
  service: Service;
  address?: Maybe<Address>;
  quantity: Scalars['Int'];
  maxAmount: Scalars['Float'];
  program?: Maybe<Scalars['ID']>;
  isValidRequest?: Maybe<Scalars['Boolean']>;
  remainQuantity?: Maybe<Scalars['Int']>;
};

export type AdvantageDemand = {
  _id: Scalars['ID'];
  advantage?: Maybe<Advantage>;
  client: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  status?: Maybe<FidelityStatus>;
  updatedAt: Scalars['String'];
};

export type AdvantageDemandResult = {
  services?: Maybe<Array<Maybe<Service>>>;
  clientId: Scalars['ID'];
  client: Client;
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
};

export type AdvantageInput = {
  _id?: Maybe<Scalars['ID']>;
  service: Scalars['ID'];
  address: AddressInput;
  quantity: Scalars['Int'];
  maxAmount: Scalars['Float'];
  program?: Maybe<Scalars['ID']>;
};

export type AdvantageResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<Advantage>>>;
};

export type AdvantageSubscription = {
  advantageId: Scalars['ID'];
  quantity: Scalars['Int'];
};

/** ALL gifts RESPONSE */
export type AllGiftsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataAllGiftsFetchResponse>;
};

export type AllMissionFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  types?: Maybe<Array<Maybe<ERequestType>>>;
  clientId?: Maybe<Scalars['ID']>;
  status?: Maybe<Array<Maybe<MissionStatusType>>>;
  executionDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AllMissionForRunsheetCreationFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  types?: Maybe<Array<Maybe<EMissionType>>>;
  clientId?: Maybe<Scalars['ID']>;
  status?: Maybe<Array<Maybe<MissionStatusType>>>;
  executionDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AllProgramsByClientParams = {
  id: Scalars['ID'];
};

export type AllProgramsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<Program>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  curentPage?: Maybe<Scalars['Int']>;
};

export type ApproveOrDeclineRequestResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type AssignCourseInput = {
  /** Course assigned driver ID! */
  driverId?: Maybe<Scalars['String']>;
  /** Course assigned conveyor ID! */
  conveyorId?: Maybe<Scalars['String']>;
  courses: Array<Scalars['String']>;
  vehicleType?: Maybe<VehicleType>;
};

/** Assign gift INPUT */
export type AssignGiftInput = {
  clients: Array<Scalars['ID']>;
  id: Scalars['ID'];
};

export type AssignGiftResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Gift>;
};

/** ASSIGNMULTIPLETASK RESPONSE */
export type AssignMultipleTaskDataResponse = {
  tasks?: Maybe<Array<Maybe<Task>>>;
  runsheets?: Maybe<Array<Maybe<Runsheet>>>;
};

/** ASSIGNMULTIPLETASK INPUT */
export type AssignMultipleTaskInput = {
  taskIDs: Array<Scalars['ID']>;
  vehicleID: Scalars['ID'];
  driverID: Scalars['ID'];
  conveyorID?: Maybe<Scalars['ID']>;
  vehicle_type: TaskVehicleType;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  taskType: TaskType;
};

export type AssignMultipleTaskResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<AssignMultipleTaskDataResponse>;
};

export type AuthenticateGoogleOpsInput = {
  user: UserLoginOpsInput;
};

export type AuthenticateOtpInput = {
  code: Scalars['String'];
  phone_number: Scalars['String'];
};

export type AuthenticateOtpResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataAuthenticateOtpResponse>;
};

export type AuthenticationOpsInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AuthenticationOpsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataAuthenticationOpsResponse>;
};

export type Axe = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EAxisType>;
  stops?: Maybe<Array<Maybe<Stop>>>;
  tasks?: Maybe<Array<Maybe<TaskMission>>>;
  vehicles?: Maybe<Array<Maybe<Vehicles>>>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  reccurenceType?: Maybe<EReccurenceType>;
  reccurenceOptions?: Maybe<ReccurenceOptions>;
  price?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Int']>;
  refTemplateAxe?: Maybe<Scalars['ID']>;
  dateRange?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AxeInput = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EAxisType>;
  stops?: Maybe<Array<Maybe<StopInput>>>;
  tasks?: Maybe<Array<Maybe<TaskMissionRunsheet>>>;
  vehicles?: Maybe<Array<Maybe<VehiclesInput>>>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  reccurenceType?: Maybe<EReccurenceType>;
  reccurenceOptions?: Maybe<ReccurenceOptionsInput>;
  price?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Int']>;
  refTemplateAxe?: Maybe<Scalars['ID']>;
};

export type AxeUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<AxeUpdated>;
};

export type AxeUpdated = {
  _id: Scalars['ID'];
  templateAxeId: Scalars['ID'];
  slotStart: Scalars['String'];
  slotEnd: Scalars['String'];
  dateRange?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AxeUpdatedInput = {
  templateAxeId: Scalars['ID'];
  slotStart: Scalars['String'];
  slotEnd: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
};

export enum Billing_Type {
  PerRide = 'PER_RIDE',
  Monthly = 'MONTHLY'
}

export type Badge = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Float']>;
};

export type BadgeInput = {
  clientId?: Maybe<Scalars['ID']>;
  countryCodes?: Maybe<Array<Scalars['String']>>;
};

export type BadgeMissionsQueries = {
  badges: Array<BadgeMissionsType>;
  executionDate?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
};

export type BadgeMissionsType = {
  key?: Maybe<Scalars['String']>;
  type?: Maybe<ERequestType>;
};

export type BadgesByStatusResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Badge>>>;
};

export type BillingAccount = {
  _id?: Maybe<Scalars['ID']>;
  billing_account_department?: Maybe<Scalars['String']>;
  billing_account_contact_firstname?: Maybe<Scalars['String']>;
  billing_account_contact_lastname?: Maybe<Scalars['String']>;
  billing_account_contact_job?: Maybe<Scalars['String']>;
  billing_account_contact_phone_number?: Maybe<Scalars['String']>;
  billing_account_contact_email?: Maybe<Scalars['String']>;
  billing_account_clientId?: Maybe<Scalars['String']>;
  billing_account_created_at?: Maybe<Scalars['String']>;
  billing_account_updated_at?: Maybe<Scalars['String']>;
  billing_account_created_by?: Maybe<Created_By>;
  billing_account_updated_by?: Maybe<Created_By>;
};

/** ALL BillingAccount INPUT */
export type BillingAccountQueries = {
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

/** ALL BillingAccount RESPONSE */
export type BillingAccountsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataBillingAccountsResponse>;
};

/** Client billing type! */
export enum BillingType {
  PerRide = 'PerRide',
  Monthly = 'Monthly'
}

export type BlockConveyorInput = {
  id: Scalars['ID'];
  blocked?: Maybe<Scalars['Boolean']>;
  sendReasonAndClientID: SendReasonAndClientInput;
};

/** BLOCKCONVEYOR RESPONSE */
export type BlockConveyorResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Conveyor>;
};

export type BlockOrUnblockDriverInput = {
  id: Scalars['ID'];
  blocked?: Maybe<Scalars['Boolean']>;
  sendReasonAndClientID: SendReasonAndClientInput;
};

/** BLOCKDRIVER RESPONSE */
export type BlockOrUnblockDriverResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Driver>;
};

export enum Card_Type {
  Passport = 'PASSPORT',
  NationalIdentityCard = 'NATIONAL_IDENTITY_CARD'
}

export type CLientAccountRevokeData = {
  message?: Maybe<Scalars['String']>;
};

export enum Contact_Relation_Ship {
  Mother = 'MOTHER',
  Father = 'FATHER',
  Sister = 'SISTER',
  Brother = 'BROTHER',
  Aunt = 'AUNT',
  Uncle = 'UNCLE',
  Cousin = 'COUSIN',
  Grandparent = 'GRANDPARENT',
  Wife = 'WIFE'
}

export type Created_By = {
  user_id?: Maybe<Scalars['ID']>;
  source?: Maybe<Scalars['String']>;
};

export type CancelOrderFromRelayResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

/** drivers card types! */
export enum CardType {
  Passport = 'Passport',
  NationalIdentityCard = 'NationalIdentityCard'
}

/** CASHCOLLECTION RESPONSE */
export type CashCollectionBadges = {
  status?: Maybe<RunsheetStatus>;
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Int']>;
};

export type CashCollectionRecap = {
  countTotal?: Maybe<Scalars['Int']>;
  badges?: Maybe<Array<Maybe<CashCollectionBadges>>>;
  runsheets?: Maybe<Array<Maybe<Runsheet>>>;
};

/** CASHCOLLECTION INPUT */
export type CashCollectionRecapQueries = {
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  status?: Maybe<RunsheetStatus>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
  driver?: Maybe<Scalars['String']>;
  convoyer?: Maybe<Scalars['String']>;
  vehicleType?: Maybe<Array<Maybe<RunsheetVehicleType>>>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
};

export type CashCollectionRecapResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CashCollectionRecap>;
};

export type CategorieFetchResponse = {
  statusCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Category>;
};

export type CategoriesFetchDataResponse = {
  categories?: Maybe<Array<Maybe<Category>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type CategoriesFetchQueries = {
  lang?: Maybe<Array<Maybe<Lang>>>;
};

export type CategoriesFetchResponse = {
  statusCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CategoriesFetchDataResponse>;
};

export type Category = {
  _id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Translation>>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<CreatedBy>;
  updatedBy?: Maybe<CreatedBy>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CategoryCreationInput = {
  translations: Array<TranslationInput>;
};

export type CategoryCreationResponse = {
  statusCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Category>;
};

export type CategoryProductTemplateStop = {
  _id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Translation>>>;
};

export type CategoryProductTemplateStopInput = {
  _id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<TranslationInput>>>;
};

export type ChangePasswordOpsInput = {
  password: Scalars['String'];
  newPassword: Scalars['String'];
};

export type ChangePasswordOpsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type CheckClientInput = {
  client_company_name: Scalars['String'];
  client_phone_number: Scalars['String'];
};

export type CheckParelStatusFetchQueries = {
  parcel_UID: Scalars['String'];
  status?: Maybe<Array<ParcelStatus>>;
};

/** client type */
export type Client = {
  _id?: Maybe<Scalars['ID']>;
  client_UID?: Maybe<Scalars['String']>;
  client_company_name?: Maybe<Scalars['String']>;
  client_activity?: Maybe<Scalars['String']>;
  client_phone_number?: Maybe<Scalars['String']>;
  client_email?: Maybe<Scalars['String']>;
  client_website?: Maybe<Scalars['String']>;
  client_address?: Maybe<Address>;
  client_default_address?: Maybe<ClientRefsAddress>;
  client_trade_register_url?: Maybe<Scalars['String']>;
  client_ninea_url?: Maybe<Scalars['String']>;
  client_ninea_number?: Maybe<Scalars['String']>;
  client_contact_firstname?: Maybe<Scalars['String']>;
  client_contact_lastname?: Maybe<Scalars['String']>;
  client_contact_job?: Maybe<Scalars['String']>;
  client_contact_phone_number?: Maybe<Scalars['String']>;
  client_contact_email?: Maybe<Scalars['String']>;
  client_contract_is_signed?: Maybe<Scalars['Boolean']>;
  client_contract_start_date?: Maybe<Scalars['String']>;
  client_contract_end_date?: Maybe<Scalars['String']>;
  client_billing?: Maybe<Billing_Type>;
  client_payment_mode?: Maybe<Payment_Mode>;
  client_payment_frequency?: Maybe<Payment_Frequency>;
  client_options_contracts?: Maybe<Array<Maybe<OptionsContract>>>;
  client_company_users?: Maybe<Array<Maybe<CompanyUser>>>;
  client_billing_accounts?: Maybe<Array<Maybe<BillingAccount>>>;
  client_picture_url?: Maybe<Scalars['String']>;
  client_created_at?: Maybe<Scalars['String']>;
  client_updated_at?: Maybe<Scalars['String']>;
  client_created_by?: Maybe<Created_By>;
  client_updated_by?: Maybe<Created_By>;
  countries?: Maybe<Array<Maybe<Country>>>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  disabledOrActivedAt?: Maybe<Scalars['String']>;
  disabledOrActivedBy?: Maybe<UserStaff>;
  deactivationReason?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  status?: Maybe<RequestClientStatus>;
  requestApprovedBy?: Maybe<UserStaff>;
  requestDeclinedBy?: Maybe<UserStaff>;
  requestApprovedAt?: Maybe<Scalars['String']>;
  requestDeclinedAt?: Maybe<Scalars['String']>;
  declineReason?: Maybe<Scalars['String']>;
  deniedSMSType?: Maybe<Array<Maybe<DeniedSmsType>>>;
  ranking?: Maybe<Scalars['String']>;
  services?: Maybe<Array<Maybe<EService>>>;
  packaging?: Maybe<Scalars['Boolean']>;
};

/** client account forget password INPUT */
export type ClientAccountForgetPasswordInput = {
  email: Scalars['String'];
};

/** client account forget password Response */
export type ClientAccountForgetPasswordResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
};

/** refresh token client account RESPONSE */
export type ClientAccountRefreshData = {
  account?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
};

/** client account token refresh INPUT */
export type ClientAccountRefreshTokenInput = {
  refreshToken: Scalars['String'];
};

/** refresh token client account RESPONSE */
export type ClientAccountRefreshTokenResponse = {
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  data?: Maybe<ClientAccountRefreshData>;
};

/** client account revoke INPUT */
export type ClientAccountRevokeTokenInput = {
  token: Scalars['String'];
};

/** client account revoke Response */
export type ClientAccountRevokeTokenResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CLientAccountRevokeData>;
};

/** client account valid reset password Response */
export type ClientAccountValidResetTokenResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
};

/** client account reset password INPUT */
export type ClientAccountValidateAccountInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

/** client account reset password RESPONSE */
export type ClientAccountValidateAccountResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
};

/** client account valid reset token password INPUT */
export type ClientAccountValidateResetTokenInput = {
  token: Scalars['String'];
};

/** client account verify email INPUT */
export type ClientAccountVerifyAccount = {
  token: Scalars['String'];
};

/** client account verify email RESPONSE */
export type ClientAccountVerifyAccountData = {
  account?: Maybe<Account>;
  token?: Maybe<Scalars['String']>;
};

/** client account verify email RESPONSE */
export type ClientAccountVerifyAccountResponse = {
  code?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<ClientAccountVerifyAccountData>;
};

export type ClientAddressRefParams = {
  id: Scalars['ID'];
};

export type ClientAuthenticateData = {
  token?: Maybe<Scalars['String']>;
  jwToken?: Maybe<ResetToken>;
};

/** Add authenticate INPUT INFO */
export type ClientAuthenticateInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

/** authenticate client account RESPONSE */
export type ClientAuthentificationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<ClientAuthenticateData>;
};

export type ClientChangePasswordInput = {
  password: Scalars['String'];
  newPassword: Scalars['String'];
};

export type ClientChangePasswordResponse = {
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type ClientCheckInput = {
  client: CheckClientInput;
};

export type ClientCheckResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataClientCheckResponse>;
};

export type ClientCreationInput = {
  client: AddClientInput;
};

export type ClientCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneClientCreationResponse>;
};

/** DELETECLIENT INPUT */
export type ClientDeleteParams = {
  id: Scalars['ID'];
};

/** DELETECLIENT INPUT */
export type ClientDeleteResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneClientDeleteResponse>;
};

/** google client connexion INPUT */
export type ClientGoogleLoginInput = {
  token: Scalars['String'];
  user: UserLoginInput;
};

export type ClientIdParams = {
  clientID: Scalars['ID'];
};

export type ClientLogoutResponse = {
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
};

export type ClientRefAddressInput = {
  clientAddress: ClientAddressInput;
  clientID: Scalars['ID'];
};

export type ClientRefAddressResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<ClientRefsAddress>;
};

/** client ref RESPONSE */
export type ClientRefAddressesResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ClientRefsAddress>>>;
};

export type ClientRefsAddress = {
  _id?: Maybe<Scalars['ID']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  client_UID?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Created_By>;
  created_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<Created_By>;
  last_edited_at?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  default?: Maybe<Scalars['Boolean']>;
};

export type ClientResetPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type ClientResetPasswordResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

/** Client type of the course! */
export enum ClientType {
  Individual = 'INDIVIDUAL',
  Enterprise = 'ENTERPRISE'
}

export type ClientUpdateAddressInput = {
  address: AddressCreationInput;
  id: Scalars['ID'];
};

export type ClientUpdateAddressResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneClientUpdateAddressResponse>;
};

/** UPDATECLIENT INPUT */
export type ClientUpdateInput = {
  client?: Maybe<ClientUpdateItems>;
  id: Scalars['ID'];
};

export type ClientUpdateItems = {
  client_company_name?: Maybe<Scalars['String']>;
  client_activity?: Maybe<Scalars['String']>;
  client_phone_number?: Maybe<Scalars['String']>;
  client_email?: Maybe<Scalars['String']>;
  client_website?: Maybe<Scalars['String']>;
  client_address?: Maybe<AddressCreationInput>;
  client_trade_register_url?: Maybe<Scalars['String']>;
  client_ninea_url?: Maybe<Scalars['String']>;
  client_ninea_number?: Maybe<Scalars['String']>;
  client_billing?: Maybe<Scalars['String']>;
  client_payment_mode?: Maybe<Scalars['String']>;
  client_payment_frequency?: Maybe<Scalars['String']>;
  client_picture_url?: Maybe<Scalars['String']>;
  client_contact_firstname?: Maybe<Scalars['String']>;
  client_contact_lastname?: Maybe<Scalars['String']>;
  client_contact_job?: Maybe<Scalars['String']>;
  client_contact_phone_number?: Maybe<Scalars['String']>;
  client_contact_email?: Maybe<Scalars['String']>;
  client_contract_is_signed?: Maybe<Scalars['Boolean']>;
  client_contract_start_date?: Maybe<Scalars['String']>;
  client_contract_end_date?: Maybe<Scalars['String']>;
  client_options_contracts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  countries?: Maybe<Array<Maybe<CountryInput>>>;
  deniedSMSType?: Maybe<Array<Maybe<DeniedSmsType>>>;
  services?: Maybe<Array<Maybe<EService>>>;
  packaging?: Maybe<Scalars['Boolean']>;
};

export type ClientUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneClientUpdateResponse>;
};

/** ALLCLIENTS INPUT */
export type ClientsFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
  status?: Maybe<RequestClientStatus>;
};

/** ALLCLIENTS RESPONSE */
export type ClientsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataClientsFetchResponse>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type CodeOtp = {
  code?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['String']>;
};

export type CompanyUser = {
  _id?: Maybe<Scalars['ID']>;
  company_user_firstname?: Maybe<Scalars['String']>;
  company_user_lastname?: Maybe<Scalars['String']>;
  company_user_email?: Maybe<Scalars['String']>;
  company_user_job?: Maybe<Scalars['String']>;
  company_user_phone_number?: Maybe<Scalars['String']>;
  company_user_profil?: Maybe<Scalars['String']>;
  company_user_clientId?: Maybe<Scalars['String']>;
  compnay_user_client?: Maybe<Client>;
  company_user_picture_url?: Maybe<Scalars['String']>;
  company_user_created_at?: Maybe<Scalars['String']>;
  company_user_updated_at?: Maybe<Scalars['String']>;
  company_user_created_by?: Maybe<Created_By>;
  company_user_updated_by?: Maybe<Created_By>;
  company_user_last_active?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Maybe<Country>>>;
};

/** RESPONSE */
export type CompanyUserByClientDataResponse = {
  companyUsers?: Maybe<Array<Maybe<CompanyUser>>>;
};

export type CompanyUserByClientFetchParams = {
  clientID: Scalars['ID'];
};

/** INPUT */
export type CompanyUserByClientFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['String']>;
};

export type CompanyUserByClientFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CompanyUserByClientDataResponse>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type CompanyUserByIdDataResponse = {
  companyUser?: Maybe<CompanyUser>;
};

export type CompanyUserByIdFetchParams = {
  id: Scalars['ID'];
};

export type CompanyUserByIdFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CompanyUserByIdDataResponse>;
};

export type CompanyUserCreateInput = {
  companyUser: CompanyUserCreateItems;
  clientID: Scalars['ID'];
};

/** MUTATION COMPANY_USER INPUT */
export type CompanyUserCreateItems = {
  company_user_firstname: Scalars['String'];
  company_user_lastname: Scalars['String'];
  company_user_email: Scalars['String'];
  company_user_job?: Maybe<Scalars['String']>;
  company_user_phone_number?: Maybe<Scalars['String']>;
  company_user_profil?: Maybe<Profile_User>;
  company_user_clientId?: Maybe<Scalars['String']>;
  company_user_picture_url?: Maybe<Scalars['String']>;
};

/** ADD COMPANY_USER RESPONSE */
export type CompanyUserCreationDataResponse = {
  companyUserCreated?: Maybe<CompanyUser>;
};

export type CompanyUserCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CompanyUserCreationDataResponse>;
};

export type CompanyUserDeleteInput = {
  id: Scalars['ID'];
  clientID: Scalars['ID'];
};

export type CompanyUserDeleteResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CompanyUserDeletedDataResponse>;
};

export type CompanyUserDeletedDataResponse = {
  companyUserDeleted?: Maybe<CompanyUser>;
};

export type CompanyUserUpdateInput = {
  companyUser: CompanyUserUpdateItems;
  id: Scalars['ID'];
};

export type CompanyUserUpdateItems = {
  company_user_firstname?: Maybe<Scalars['String']>;
  company_user_lastname?: Maybe<Scalars['String']>;
  company_user_job?: Maybe<Scalars['String']>;
  company_user_phone_number?: Maybe<Scalars['String']>;
  company_user_profil?: Maybe<Profile_User>;
  company_user_clientId?: Maybe<Scalars['String']>;
  company_user_picture_url?: Maybe<Scalars['String']>;
};

export type CompanyUserUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CompanyUserUpdatedDataResponse>;
};

export type CompanyUserUpdatedDataResponse = {
  companyUserUpdated?: Maybe<CompanyUser>;
};

export type ConfirmDemandInput = {
  id: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
};

export type ConfirmDemandResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
};

export type ConfirmInput = {
  costs?: Maybe<Scalars['Int']>;
  receiverName: Scalars['String'];
  receiverPhone: Scalars['String'];
  proof?: Maybe<Array<Maybe<Scalars['String']>>>;
  finalAmount?: Maybe<Scalars['Int']>;
  isReceptionConfirmed?: Maybe<Scalars['Boolean']>;
  badge?: Maybe<RemittanceBadge>;
  declineReceptionReason?: Maybe<Scalars['String']>;
};

export type ContactInput = {
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  secondPhoneNumber?: Maybe<Scalars['String']>;
  address: Address;
};

/** driver emergency contact's relationship! */
export enum ContactRelationShip {
  Mother = 'Mother',
  Father = 'Father',
  Sister = 'Sister',
  Brother = 'Brother',
  Aunt = 'Aunt',
  Uncle = 'Uncle',
  Cousin = 'Cousin',
  GrandParent = 'GrandParent',
  Wife = 'Wife'
}

export type Conveyor = {
  _id?: Maybe<Scalars['ID']>;
  conveyor_UID?: Maybe<Scalars['String']>;
  conveyor_firstname?: Maybe<Scalars['String']>;
  conveyor_lastname?: Maybe<Scalars['String']>;
  conveyor_email?: Maybe<Scalars['String']>;
  conveyor_phone_number?: Maybe<Scalars['String']>;
  conveyor_username?: Maybe<Scalars['String']>;
  conveyor_password?: Maybe<Scalars['String']>;
  conveyor_address?: Maybe<Address>;
  conveyor_profile_picture?: Maybe<Scalars['String']>;
  conveyor_id_card?: Maybe<Scalars['String']>;
  conveyor_id_card_type?: Maybe<Card_Type>;
  conveyor_criminal_record?: Maybe<Scalars['String']>;
  conveyor_proof_of_address?: Maybe<Scalars['String']>;
  conveyor_emergency_contact_firstname?: Maybe<Scalars['String']>;
  conveyor_emergency_contact_lastname?: Maybe<Scalars['String']>;
  conveyor_emergency_contact_phone_number?: Maybe<Scalars['String']>;
  conveyor_emergency_contact_relationship?: Maybe<Contact_Relation_Ship>;
  conveyor_payment_mode?: Maybe<Scalars['String']>;
  conveyor_contract_end?: Maybe<Scalars['String']>;
  conveyor_contract_start?: Maybe<Scalars['String']>;
  conveyor_is_trained?: Maybe<Scalars['Boolean']>;
  conveyor_created_at?: Maybe<Scalars['String']>;
  conveyor_created_by?: Maybe<Created_By>;
  conveyor_updated_by?: Maybe<Created_By>;
  conveyor_deleted?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  conveyor_activities?: Maybe<Array<Maybe<Activity>>>;
};

/** ADDCONVEYOR INPUT */
export type ConveyorCreationInput = {
  conveyor: ConveyorItemsInput;
};

/** ADDCONVEYOR RESPONSE */
export type ConveyorCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataConveyorCreatedResponse>;
};

export type ConveyorItemsInput = {
  conveyor_firstname: Scalars['String'];
  conveyor_lastname: Scalars['String'];
  conveyor_email?: Maybe<Scalars['String']>;
  conveyor_phone_number: Scalars['String'];
  conveyor_username?: Maybe<Scalars['String']>;
  conveyor_password?: Maybe<Scalars['String']>;
  conveyor_address: AddressCreationInput;
  conveyor_profile_picture: Scalars['String'];
  conveyor_id_card: Scalars['String'];
  conveyor_id_card_type: Card_Type;
  conveyor_criminal_record: Scalars['String'];
  conveyor_proof_of_address: Scalars['String'];
  conveyor_emergency_contact_firstname: Scalars['String'];
  conveyor_emergency_contact_lastname: Scalars['String'];
  conveyor_emergency_contact_phone_number: Scalars['String'];
  conveyor_emergency_contact_relationship: Contact_Relation_Ship;
  conveyor_payment_mode: Scalars['String'];
  conveyor_contract_end: Scalars['String'];
  conveyor_contract_start: Scalars['String'];
  conveyor_is_trained: Scalars['Boolean'];
};

export type ConveyorItemsUpdate = {
  conveyor_firstname?: Maybe<Scalars['String']>;
  conveyor_lastname?: Maybe<Scalars['String']>;
  /**
   * conveyor_email: String
   * conveyor_username: String
   * conveyor_password: String
   */
  conveyor_phone_number?: Maybe<Scalars['String']>;
  conveyor_address?: Maybe<AddressCreationInput>;
  conveyor_profile_picture?: Maybe<Scalars['String']>;
  conveyor_id_card?: Maybe<Scalars['String']>;
  conveyor_id_card_type?: Maybe<Card_Type>;
  conveyor_criminal_record?: Maybe<Scalars['String']>;
  conveyor_proof_of_address?: Maybe<Scalars['String']>;
  conveyor_emergency_contact_firstname?: Maybe<Scalars['String']>;
  conveyor_emergency_contact_lastname?: Maybe<Scalars['String']>;
  conveyor_emergency_contact_phone_number?: Maybe<Scalars['String']>;
  conveyor_emergency_contact_relationship?: Maybe<Contact_Relation_Ship>;
  conveyor_payment_mode?: Maybe<Scalars['String']>;
  conveyor_contract_end?: Maybe<Scalars['String']>;
  conveyor_is_trained?: Maybe<Scalars['Boolean']>;
};

/** UPDATECONVEYOR INPUT */
export type ConveyorUpdateInput = {
  id: Scalars['ID'];
  conveyor: ConveyorItemsUpdate;
};

/** UPDATECONVEYOR RESPONSE */
export type ConveyorUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataConveyorUpdatedResponse>;
};

export type ConveyorsFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
};

/** ALLCONVEYORS RESPONSE */
export type ConveyorsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataConveyorsResponse>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type CountriesFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CountriesPagination>;
};

export type CountriesPagination = {
  countries?: Maybe<Array<Maybe<Country>>>;
  currentPage?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  countTotal?: Maybe<Scalars['Int']>;
};

export type Country = {
  _id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type CountryCreationInput = {
  country: CountryInput;
};

export type CountryCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Country>;
};

export type CountryInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type Course = {
  /** Identtify element  */
  _id?: Maybe<Scalars['ID']>;
  /** Is deleted */
  isDeleted: Scalars['Boolean'];
  /** Created at */
  createdAt: Scalars['String'];
  /** Updated at */
  updatedAt: Scalars['String'];
  /** User who created the record */
  createdBy: EditedBy;
  /** User who changed the record */
  editedBy: EditedBy;
  /** Course uid */
  uid: Scalars['String'];
  /** Course Start Date */
  startDate?: Maybe<Scalars['String']>;
  /** Course End Date */
  endDate?: Maybe<Scalars['String']>;
  /** course status */
  status: CourseStatus;
  /** Course decline reason */
  reason?: Maybe<Scalars['String']>;
  /** Course client type */
  isIndividual?: Maybe<Scalars['Boolean']>;
  /** Driver assigned to the course */
  driver?: Maybe<Driver>;
  /** Course clients */
  client?: Maybe<Client>;
  /** Course individuals clients */
  individualClient?: Maybe<Individualsclient>;
  countries?: Maybe<Array<Country>>;
  /** Course actions! */
  actions: Array<Action>;
  /** Course execution Date */
  executionDate?: Maybe<Scalars['String']>;
  /** Course execution Time */
  executionTime?: Maybe<Scalars['String']>;
  /** vehicle */
  vehicleType?: Maybe<VehicleType>;
  /** Course activities! */
  activities?: Maybe<Array<Maybe<Activity>>>;
  /** Course additionnal information */
  additionalInformation?: Maybe<Scalars['String']>;
  /** Conveyor assigned to the course */
  conveyorId?: Maybe<Conveyor>;
  conveyor?: Maybe<Conveyor>;
};

export type CourseBadge = {
  count?: Maybe<Scalars['Int']>;
};

export type CourseFetchInput = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  status?: Maybe<Array<CourseStatus>>;
  client?: Maybe<Scalars['String']>;
  papserId?: Maybe<Scalars['String']>;
  fromDate?: Maybe<Scalars['String']>;
  toDate?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
  countryCodes?: Maybe<Array<Scalars['String']>>;
  clientType?: Maybe<ClientType>;
  address?: Maybe<Scalars['String']>;
};

export type CourseRecap = {
  message?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Float']>;
  data: RecapData;
};

/** Status of the course! */
export enum CourseStatus {
  Default = 'DEFAULT',
  Assigned = 'ASSIGNED',
  OnGoing = 'ON_GOING',
  NotStarted = 'NOT_STARTED',
  Done = 'DONE'
}

export type CourseToExportInput = {
  clientId?: Maybe<Scalars['ID']>;
  countryCodes?: Maybe<Array<Scalars['String']>>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  clientType?: Maybe<ClientType>;
};

export type CreateCourseInput = {
  /** Course client ID! */
  clientId?: Maybe<Scalars['String']>;
  /** Course client type */
  isIndividual?: Maybe<Scalars['Boolean']>;
  /** Course individual client! */
  individualClientId?: Maybe<Scalars['String']>;
  /** Course actions! */
  actions: Array<UpdateActionInput>;
  /** Course additionnal information! */
  additionalInformation?: Maybe<Scalars['String']>;
};

export type CreateDriverInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int'];
};

export type CreateIndividualClientInput = {
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  secondPhoneNumber?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  countries: Array<CountryInput>;
};

export type CreateMissionInput = {
  uid?: Maybe<Scalars['String']>;
};

export type CreateProgramInput = {
  iconUrl: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  advantages: Array<AdvantageInput>;
};

export type CreateProgramResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Program>;
};

export type CreateRequestResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Client>;
};

/** NEW RUNSHEET MISSION CREATION V2 INPUT */
export type CreateRunsheetMissionV2Input = {
  tasks: Array<Scalars['ID']>;
  tourData?: Maybe<Array<Maybe<TourDataInput>>>;
};

export type CreateRunsheetMissionV2Response = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Runsheet>;
};

export type CreateServiceRespone = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Service>;
};

export type CreateTasksMissionTourQueries = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
};

export type CreateTasksMissionTourResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<TasksMissionTourResponse>;
};

export type CreatedBy = {
  user_id?: Maybe<Scalars['ID']>;
  user?: Maybe<UserCreatedBy>;
  source?: Maybe<Scalars['String']>;
};

export type CurrentClientDataResponse = {
  client?: Maybe<Client>;
};

/** current client RESPONSE */
export type CurrentClientResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CurrentClientDataResponse>;
};

/** client company user account RESPONSE */
export type CurrentCompanyUserAccountResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CurrentCompanyUserDataResponse>;
};

export type CurrentCompanyUserDataResponse = {
  user?: Maybe<CompanyUser>;
};

export type CurrentOpsUserResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<OneDataCurrentOpsUserResponse>;
};

export type DataAddUserResponse = {
  user?: Maybe<UserStaff>;
};

export type DataAllGiftsFetchResponse = {
  gifts?: Maybe<Array<Maybe<Gift>>>;
};

export type DataAuthenticateOtpResponse = {
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserPapser>;
};

export type DataAuthenticationOpsResponse = {
  account?: Maybe<UserStaff>;
  jwtToken?: Maybe<JwtTokenResponse>;
};

export type DataBillingAccountsResponse = {
  billingAccounts?: Maybe<Array<Maybe<BillingAccount>>>;
};

export type DataClientCheckResponse = {
  canCreateClient?: Maybe<Scalars['Boolean']>;
};

export type DataClientsFetchResponse = {
  clients?: Maybe<Array<Maybe<Client>>>;
};

export type DataConveyorCreatedResponse = {
  conveyorCreated?: Maybe<Conveyor>;
};

export type DataConveyorUpdatedResponse = {
  conveyorUpdated?: Maybe<Conveyor>;
};

export type DataConveyorsResponse = {
  conveyors?: Maybe<Array<Maybe<Conveyor>>>;
};

export type DataDeleteUserResponse = {
  user?: Maybe<UserStaff>;
};

export type DataDeliverySlotsReponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<DeliverySlots>>>;
};

export type DataDriverCreatedResponse = {
  driverCreated?: Maybe<Driver>;
};

export type DataDriverUpdatedResponse = {
  driverUpdated?: Maybe<Driver>;
};

export type DataDriversResponse = {
  drivers?: Maybe<Array<Maybe<Driver>>>;
};

export type DataOneClientCreationResponse = {
  clientCreated?: Maybe<Client>;
};

export type DataOneClientDeleteResponse = {
  clientDeleted?: Maybe<Client>;
};

export type DataOneClientFetchResponse = {
  client?: Maybe<Client>;
};

export type DataOneClientUpdateAddressResponse = {
  clientUpdatedAddress?: Maybe<Client>;
};

export type DataOneClientUpdateResponse = {
  clientUpdated?: Maybe<Client>;
};

export type DataOneConveyorResponse = {
  conveyor?: Maybe<Conveyor>;
};

export type DataOneDriverResponse = {
  driver?: Maybe<Driver>;
};

export type DataOneGiftFetchResponse = {
  gift?: Maybe<Gift>;
};

export type DataOneOptionsContractResponse = {
  optionsContract?: Maybe<OptionsContract>;
};

export type DataOnePartnerResponse = {
  partner?: Maybe<Partner>;
};

export type DataOneVehicleResponse = {
  vehicle?: Maybe<Vehicle>;
};

/** ADD OPTIONS_CONTRACT RESPONSE */
export type DataOptionsContractCreationResponse = {
  optionsContractCreated?: Maybe<OptionsContract>;
};

export type DataOptionsContractFetchResponse = {
  optionsContracts?: Maybe<Array<Maybe<OptionsContract>>>;
};

export type DataParcelsReceptionAtRelayPointResponse = {
  parcelsReceived?: Maybe<Array<Maybe<Parcel>>>;
  parcelsNotReceived?: Maybe<Array<Maybe<Parcel>>>;
};

export type DataPartnerCreatedResponse = {
  partnerCreated?: Maybe<Partner>;
};

export type DataPartnerDeletedResponse = {
  partnerDeleted?: Maybe<Partner>;
};

export type DataPartnerUpdatedResponse = {
  partnerUpdated?: Maybe<Partner>;
};

export type DataPartnersResponse = {
  partners?: Maybe<Array<Maybe<Partner>>>;
};

export type DataSendCodeOtpResponse = {
  code: Scalars['String'];
};

export type DataTemplateStopsUpdateInput = {
  _id?: Maybe<Scalars['ID']>;
  action?: Maybe<EActionType>;
  address?: Maybe<AddressCreationInput>;
  itemsToPick?: Maybe<Array<Maybe<ItemsTemplateStopsInput>>>;
  itemsToDelivered?: Maybe<Array<Maybe<ItemsTemplateStopsInput>>>;
};

export type DataUpdateUserResponse = {
  user?: Maybe<UserStaff>;
};

export type DataUserPapserUpdateResponse = {
  userUpdated?: Maybe<UserPapser>;
};

export type DataUserStaffResponse = {
  users?: Maybe<Array<Maybe<UserStaff>>>;
};

export type DataValidateOpsResponse = {
  user?: Maybe<UserStaff>;
};

export type DataVehicleCreationResponse = {
  vehicleCreated?: Maybe<Vehicle>;
};

export type DataVehicleUpdatedResponse = {
  vehicleUpdated?: Maybe<Vehicle>;
};

export type DataVehiclesResponse = {
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
};

export type DataVerifyAccountOpsResponse = {
  account?: Maybe<UserStaff>;
  token?: Maybe<Scalars['String']>;
};


export type DeactivateAccountInput = {
  clientId: Scalars['ID'];
  deactivationReason: Scalars['String'];
};

export type DeactivateAccountResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['ID']>;
};

export type DeclineTaskTransferRequestInput = {
  requestId: Scalars['ID'];
};

export type DeleteClientRefInput = {
  id: Scalars['ID'];
};

export type DeleteInput = {
  id: Scalars['ID'];
};

/** DELETECONVEYORS INPUT */
export type DeleteMultipleConveyor = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** DELETEDRIVERS INPUT */
export type DeleteMultipleDriver = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** DELETEPARTNERS INPUT */
export type DeleteMultiplePartnerInput = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** DELETE VEHICLES INPUT */
export type DeleteMultipleVehicleInput = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DeleteProgramResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
};

export type DeleteResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type DeleteRoleInput = {
  id: Scalars['ID'];
};

export type DeleteRoleResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Role>;
};

export type DeleteServiceRespone = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Service>;
};

/** DELETETASK RESPONSE */
export type DeleteTaskResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Task>;
};

export type DeleteUserInput = {
  userID: Scalars['ID'];
};

export type DeleteUserResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataAddUserResponse>;
};

/** client address RESPONSE */
export type DeletedClientRefAddressResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type DeliveriesTransitInput = {
  taskId: Scalars['ID'];
  hubId: Scalars['ID'];
};

export type DeliverySlots = {
  Matin?: Maybe<PickupDelivery>;
  Soir?: Maybe<PickupDelivery>;
  AllDay?: Maybe<Slots>;
};

export enum DeniedSmsType {
  DeliverySms = 'DELIVERY_SMS',
  RelayReceivedOrderSms = 'RELAY_RECEIVED_ORDER_SMS',
  RelayCancelOrderSms = 'RELAY_CANCEL_ORDER_SMS'
}

export type DetailsAddress = {
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  place_id?: Maybe<Scalars['String']>;
  source_type?: Maybe<Scalars['String']>;
};

export type DetailsAddressQueries = {
  placeIDs: Array<Maybe<Scalars['String']>>;
};

export type DetailsAddressResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<DetailsAddress>>>;
};

export type DetailsRecapByPapserDataResponse = {
  items?: Maybe<Array<Maybe<DetailsRecapByPapserItemsDataResponse>>>;
  subtasks?: Maybe<Array<Maybe<SubTask>>>;
  activities?: Maybe<Array<Maybe<Activity>>>;
  amount_to_collect_total?: Maybe<Scalars['Int']>;
};

/** DETAILSRECAPBYPAPSER INPUT */
export type DetailsRecapByPapserFetchParams = {
  papserID: Scalars['ID'];
};

export type DetailsRecapByPapserFetchQueries = {
  date?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<SubTaskType>>>;
  lang?: Maybe<Lang>;
};

/** DETAILSRECAPBYPAPSER RESPONSE */
export type DetailsRecapByPapserItemsDataResponse = {
  receiver?: Maybe<Receiver>;
  parcel_successful?: Maybe<Array<Maybe<Parcel>>>;
  parcel_failed?: Maybe<Array<Maybe<Parcel>>>;
  parcel_cancelled?: Maybe<Array<Maybe<Parcel>>>;
  client?: Maybe<Client>;
  amount_to_collect?: Maybe<Scalars['Int']>;
};

export type DetailsRecapByPapserResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DetailsRecapByPapserDataResponse>;
};

export type DisableStopUpdateInput = {
  templateStopIds: Array<Scalars['ID']>;
  isDisabled: Scalars['Boolean'];
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
};

export type DisableStopsInput = {
  uid?: Maybe<Scalars['String']>;
  stops: Array<Maybe<Scalars['ID']>>;
  reccurrenceType: EReccurenceType;
  reccurenceOptions: ReccurenceOptionsInput;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type DisableStopsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export type Dispatcher = {
  numberOfDispatcher?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
};

export type DispatcherInput = {
  numberOfDispatcher?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
};

export type Driver = {
  _id?: Maybe<Scalars['ID']>;
  driver_UID?: Maybe<Scalars['String']>;
  driver_firstname?: Maybe<Scalars['String']>;
  driver_lastname?: Maybe<Scalars['String']>;
  driver_email?: Maybe<Scalars['String']>;
  driver_phone_number?: Maybe<Scalars['String']>;
  driver_username?: Maybe<Scalars['String']>;
  driver_password?: Maybe<Scalars['String']>;
  driver_address?: Maybe<Address>;
  driver_profile_picture?: Maybe<Scalars['String']>;
  driver_id_card?: Maybe<Scalars['String']>;
  driver_id_card_type?: Maybe<Card_Type>;
  driver_license?: Maybe<Scalars['String']>;
  driver_criminal_record?: Maybe<Scalars['String']>;
  driver_proof_of_address?: Maybe<Scalars['String']>;
  driver_emergency_contact_firstname?: Maybe<Scalars['String']>;
  driver_emergency_contact_lastname?: Maybe<Scalars['String']>;
  driver_emergency_contact_phone_number?: Maybe<Scalars['String']>;
  driver_emergency_contact_relationship?: Maybe<Contact_Relation_Ship>;
  driver_is_paid_by_paps?: Maybe<Scalars['Boolean']>;
  driver_payment_mode?: Maybe<Scalars['String']>;
  driver_contract_end?: Maybe<Scalars['String']>;
  driver_contract_start?: Maybe<Scalars['String']>;
  driver_is_trained?: Maybe<Scalars['Boolean']>;
  driver_license_type?: Maybe<Array<Maybe<License_Type>>>;
  driver_is_available?: Maybe<Scalars['Boolean']>;
  driver_created_at?: Maybe<Scalars['String']>;
  driver_updated_at?: Maybe<Scalars['String']>;
  driver_is_deleted?: Maybe<Scalars['Boolean']>;
  driver_created_by?: Maybe<Created_By>;
  driver_updated_by?: Maybe<Created_By>;
  driver_partner?: Maybe<Partner>;
  driver_vehicle?: Maybe<Vehicle>;
  blocked?: Maybe<Scalars['Boolean']>;
  isAvailableforMadTask?: Maybe<Scalars['Boolean']>;
  driver_insurance?: Maybe<Scalars['String']>;
  driver_resume?: Maybe<Scalars['String']>;
  driver_registration_card?: Maybe<Scalars['String']>;
  driver_activities?: Maybe<Array<Maybe<Activity>>>;
};

export type DriverAndPartnerFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<PapserType>>>;
};

export type DriverCheckInput = {
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
};

/** ADDDRIVER INPUT */
export type DriverCreationInput = {
  driver: DriverItemsCreation;
};

/** ADDDRIVER RESPONSE */
export type DriverCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataDriverCreatedResponse>;
};

export type DriverExistCheckResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DriverExistResponse>;
};

export type DriverExistResponse = {
  existDriver: Scalars['Boolean'];
};

export type DriverGetCodeQueries = {
  phoneNumber?: Maybe<Scalars['String']>;
};

export type DriverGetCodeResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<CodeOtp>;
};

export type DriverItemsCreation = {
  driver_firstname: Scalars['String'];
  driver_lastname: Scalars['String'];
  driver_email?: Maybe<Scalars['String']>;
  driver_phone_number: Scalars['String'];
  driver_username?: Maybe<Scalars['String']>;
  driver_password?: Maybe<Scalars['String']>;
  driver_address: AddressCreationInput;
  driver_profile_picture?: Maybe<Scalars['String']>;
  driver_id_card?: Maybe<Scalars['String']>;
  driver_id_card_type?: Maybe<Card_Type>;
  driver_license?: Maybe<Scalars['String']>;
  driver_criminal_record?: Maybe<Scalars['String']>;
  driver_proof_of_address?: Maybe<Scalars['String']>;
  driver_emergency_contact_firstname?: Maybe<Scalars['String']>;
  driver_emergency_contact_lastname?: Maybe<Scalars['String']>;
  driver_emergency_contact_phone_number?: Maybe<Scalars['String']>;
  driver_emergency_contact_relationship?: Maybe<Contact_Relation_Ship>;
  driver_is_paid_by_paps: Scalars['Boolean'];
  driver_payment_mode?: Maybe<Scalars['String']>;
  driver_contract_end?: Maybe<Scalars['String']>;
  driver_contract_start?: Maybe<Scalars['String']>;
  driver_is_trained: Scalars['Boolean'];
  driver_license_type: Array<License_Type>;
  driver_is_available: Scalars['Boolean'];
  driver_partner: Scalars['ID'];
  driver_insurance?: Maybe<Scalars['String']>;
  driver_resume?: Maybe<Scalars['String']>;
  driver_registration_card?: Maybe<Scalars['String']>;
};

export type DriverItemsUpdate = {
  driver_firstname?: Maybe<Scalars['String']>;
  driver_lastname?: Maybe<Scalars['String']>;
  /**
   * driver_email: String
   * driver_username: String
   * driver_password: String
   */
  driver_phone_number?: Maybe<Scalars['String']>;
  driver_address?: Maybe<AddressCreationInput>;
  driver_profile_picture?: Maybe<Scalars['String']>;
  driver_id_card?: Maybe<Scalars['String']>;
  driver_id_card_type?: Maybe<Card_Type>;
  driver_license?: Maybe<Scalars['String']>;
  driver_criminal_record?: Maybe<Scalars['String']>;
  driver_proof_of_address?: Maybe<Scalars['String']>;
  driver_emergency_contact_firstname?: Maybe<Scalars['String']>;
  driver_emergency_contact_lastname?: Maybe<Scalars['String']>;
  driver_emergency_contact_phone_number?: Maybe<Scalars['String']>;
  driver_emergency_contact_relationship?: Maybe<Contact_Relation_Ship>;
  driver_is_paid_by_paps?: Maybe<Scalars['Boolean']>;
  driver_payment_mode?: Maybe<Scalars['String']>;
  driver_contract_end?: Maybe<Scalars['String']>;
  driver_contract_start?: Maybe<Scalars['String']>;
  driver_is_trained?: Maybe<Scalars['Boolean']>;
  driver_license_type?: Maybe<Array<Maybe<License_Type>>>;
  driver_is_available?: Maybe<Scalars['Boolean']>;
  driver_insurance?: Maybe<Scalars['String']>;
  driver_resume?: Maybe<Scalars['String']>;
  driver_registration_card?: Maybe<Scalars['String']>;
};

/** UPDATEDRIVER INPUT */
export type DriverUpdateInput = {
  id: Scalars['ID'];
  driver: DriverItemsUpdate;
};

/** UPDATEDRIVER RESPONSE */
export type DriverUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataDriverUpdatedResponse>;
};

/** DRIVERSBYTYPEOFVEHICLETOPARTNER INPUT */
export type DriversBtovtpFecthParams = {
  partnerId: Scalars['ID'];
};

export type DriversBtovtpFecthQueries = {
  vehicle_type: Vehicle_Type;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
};

export type DriversFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
};

/** ALLDRIVERS RESPONSE */
export type DriversFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataDriversResponse>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export enum EActionType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  PickupDelivery = 'PICKUP_DELIVERY',
  Unknown = 'UNKNOWN'
}

export enum EAxisType {
  Default = 'DEFAULT',
  Redefinition = 'REDEFINITION'
}

export enum EDays {
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY'
}

export enum EHubFunction {
  TriCenter = 'TRI_CENTER',
  DispatchCenter = 'DISPATCH_CENTER',
  Warehouse = 'WAREHOUSE',
  RelayCenter = 'RELAY_CENTER'
}

export enum EHubType {
  Relay = 'RELAY',
  Warehouse = 'WAREHOUSE'
}

export enum EMissionType {
  Nt = 'NT',
  All = 'ALL',
  Pickup = 'PICKUP',
  Delivery = 'DELIVERY'
}

export enum EPlatform {
  Client = 'CLIENT',
  Ops = 'OPS',
  Papser = 'PAPSER'
}

export enum EProductType {
  Couriers = 'COURIERS',
  Fragile = 'FRAGILE',
  Food = 'FOOD',
  FreshProducts = 'FRESH_PRODUCTS',
  Other = 'OTHER'
}

export enum EReccurenceType {
  DoesNotRepeat = 'DOES_NOT_REPEAT',
  Everyday = 'EVERYDAY',
  Days = 'DAYS',
  Weeks = 'WEEKS',
  Months = 'MONTHS',
  Years = 'YEARS'
}

export enum ERequestStatus {
  Requested = 'REQUESTED',
  Accepted = 'ACCEPTED',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum ERequestType {
  Mad = 'MAD',
  Nt = 'NT',
  Tr = 'TR',
  Msg = 'MSG',
  Course = 'COURSE'
}

export enum EService {
  Nt = 'NT',
  Tr = 'TR',
  Mad = 'MAD',
  Msg = 'MSG',
  Course = 'Course'
}

export type EVehiclesInput = {
  vehicleType: EVehiculeType;
  numberOfVehicule: Scalars['Int'];
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
};

export enum EVehiculeType {
  Scooter = 'SCOOTER',
  MiniVan = 'MINI_VAN',
  Van = 'VAN',
  Tricycle = 'TRICYCLE',
  Camion = 'CAMION',
  Truck_3T = 'TRUCK_3T',
  Truck_5T = 'TRUCK_5T',
  Truck_7T = 'TRUCK_7T',
  Truck_8T = 'TRUCK_8T',
  Truck_9T = 'TRUCK_9T',
  Truck_10T = 'TRUCK_10T',
  Truck_12T = 'TRUCK_12T',
  Truck_15T = 'TRUCK_15T',
  Truck_20T = 'TRUCK_20T',
  Truck_25T = 'TRUCK_25T',
  Truck_30T = 'TRUCK_30T',
  Truck_35T = 'TRUCK_35T',
  Truck_50T = 'TRUCK_50T',
  RefrigeratedTruck_3T = 'REFRIGERATED_TRUCK_3T',
  RefrigeratedTruck_5T = 'REFRIGERATED_TRUCK_5T',
  RefrigeratedTruck_8T = 'REFRIGERATED_TRUCK_8T',
  RefrigeratedTruck_10T = 'REFRIGERATED_TRUCK_10T',
  RefrigeratedTruck_12T = 'REFRIGERATED_TRUCK_12T'
}

export type EditExecutionRunsheetInput = {
  id: Scalars['ID'];
  execution?: Maybe<ExecutionTimeInput>;
};

/** EDITDELIVERYRUNSHEET RESPONSE */
export type EditExecutionRunsheetResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Runsheet>;
};

export type EditMadSlotsInput = {
  uid?: Maybe<Scalars['String']>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type EditMadSlotsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Mission>>>;
};

export type EditNationalTransportInput = {
  uid: Scalars['String'];
  slots: Slot;
};

export type EditNationalTransportInputRespone = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Mission>;
};

export type EditedBy = {
  user_id?: Maybe<Scalars['ID']>;
  user?: Maybe<UserCreatedBy>;
  source?: Maybe<Scalars['String']>;
};

export type Email = {
  _id?: Maybe<Scalars['ID']>;
  toEmail?: Maybe<Scalars['String']>;
  toName?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<Scalars['String']>;
};

export type Event = {
  _id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  models?: Maybe<Array<Maybe<Model>>>;
};

export type EventData = {
  events?: Maybe<Array<Maybe<Event>>>;
  models?: Maybe<Scalars['String']>;
};

export type EventReturn = {
  data?: Maybe<EventData>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

/** UPDATEPICKUPTASK INPUT */
export type ExecutionTimeInput = {
  slot_start?: Maybe<Scalars['String']>;
  slot_end?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
};

export type ExpoTokenFetchParams = {
  id: Scalars['ID'];
};

export type ExpoTokenFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
};

export type ExportMissionInput = {
  clientId?: Maybe<Scalars['ID']>;
  countryCode?: Maybe<Array<Maybe<Scalars['String']>>>;
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  missionType: Array<Maybe<ERequestType>>;
};

export enum FidelityStatus {
  OnGoing = 'ON_GOING',
  Completed = 'COMPLETED'
}

export enum FilterByDateType {
  Execution = 'EXECUTION',
  Creation = 'CREATION',
  ExecutionAndCreation = 'EXECUTION_AND_CREATION',
  Delivery = 'DELIVERY',
  Reception = 'RECEPTION',
  Collection = 'COLLECTION'
}

export type FilterInput = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type ForgotPasswordOpsInput = {
  email?: Maybe<Scalars['String']>;
};

export type ForgotPasswordOpsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type GetAdvantageByProgramParams = {
  programId: Scalars['ID'];
};

export type GetAdvantageDemandByClientQueries = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  status?: Maybe<FidelityStatus>;
};

export type GetAdvantageDemandByClientResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  data: Array<Maybe<AdvantageDemand>>;
};

export type GetAdvantagesDetailsByProgramForClientParams = {
  programId: Scalars['ID'];
  clientId: Scalars['ID'];
};

export type GetAllServicesQueries = {
  page?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};

export type GetAllServicesResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Service>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  curentPage?: Maybe<Scalars['Int']>;
};

export type GetAxisBasedOnReccurrenceInput = {
  requestUid: Scalars['String'];
  configUID: Scalars['String'];
  reccurenceType: EReccurenceType;
  reccurenceOptions?: Maybe<ReccurenceOptionsInput>;
};

export type GetAxisBasedOnReccurrenceResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Axe>>>;
};

export type GetBadgeResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['Int']>;
};

export type GetBadgeStatusResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['Int']>;
};

export type GetConfigsQueries = {
  uid?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type GetConfigsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<RConfig>>>;
};

export type GetFidelityDemandParams = {
  clientId?: Maybe<Scalars['ID']>;
  status: FidelityStatus;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type GetFidelityDemandResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<AdvantageDemandResult>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  curentPage?: Maybe<Scalars['Int']>;
};

export type GetOtherParcelsToReceiveAtRelayDataResponse = {
  parcels?: Maybe<Array<Maybe<Parcel>>>;
  order?: Maybe<Order>;
};

export type GetOtherParcelsToReceiveAtRelayResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<GetOtherParcelsToReceiveAtRelayDataResponse>;
};

export type GetParcelCountByHubIdResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ParcelCountByHubId>>>;
};

export type GetTaskByMissionsInput = {
  missionUIDs?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Gift = {
  _id?: Maybe<Scalars['ID']>;
  uid?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  clients?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type GiftByClientParams = {
  id: Scalars['ID'];
};

export type GiftByClientResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneGiftFetchResponse>;
};

/** Add addMultipleGift INPUT INFO */
export type GiftMultipleCreationInput = {
  label?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  clients?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Handler = {
  numberOfHandler?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
};

export type HandlerInput = {
  numberOfHandler?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
};

export type Hub = {
  /** ID Hub */
  _id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<EHubType>>>;
  location?: Maybe<Address>;
  users?: Maybe<Array<Maybe<UserStaff>>>;
  country?: Maybe<Country>;
  openHour: Scalars['String'];
  endHour: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<CreatedBy>;
  updatedBy?: Maybe<EditedBy>;
  createdAt?: Maybe<Scalars['String']>;
};

export type HubCreationInput = {
  hub: HubInput;
};

export type HubCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Hub>;
};

export type HubDeletionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type HubFetchParams = {
  id?: Maybe<Scalars['String']>;
};

export type HubFetchQueries = {
  city: Scalars['String'];
};

export type HubFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Hub>;
};

export type HubInput = {
  name: Scalars['String'];
  types?: Maybe<Array<EHubType>>;
  location: AddressCreationInput;
  country: Scalars['ID'];
  openHour: Scalars['String'];
  endHour: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type HubUpdateInput = {
  hub: HubInput;
};

export type HubUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Hub>;
};

export type HubUsersUpdatedResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Hub>;
};

export type HubsFetchQueries = {
  q?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type HubsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Hub>>>;
};

export type IActionItem = {
  /** Item status! */
  status?: Maybe<ItemStatus>;
  /** Item code! */
  code: Scalars['String'];
  /** Item status! */
  description?: Maybe<Scalars['String']>;
  /** Item quantity! */
  quantity?: Maybe<Scalars['Float']>;
};

export type IContactInfo = {
  /** Action receiver firstname! */
  firstname: Scalars['String'];
  /** Action receiver lastname! */
  lastname: Scalars['String'];
  /** Action receiver email! */
  email?: Maybe<Scalars['String']>;
  /** Action receiver phone number! */
  phoneNumber: Scalars['String'];
  /** Action receiver second phone number! */
  secondPhoneNumber?: Maybe<Scalars['String']>;
  /** Action receiver address! */
  address: AddressInput;
};

export type IRemittanceInfo = {
  /** Contact of action remittance! */
  contact: ContactInput;
  /** Address of action remittance! */
  address: Address;
  /** Amount of action remittance! */
  amount?: Maybe<Scalars['Float']>;
  /** More info about action remittance! */
  additionnalInfo?: Maybe<Scalars['String']>;
  method: RemittanceMethod;
};

export type IndividualsClientsFetchInput = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type Individualsclient = {
  /** Identtify element  */
  _id?: Maybe<Scalars['ID']>;
  /** Is deleted */
  isDeleted: Scalars['Boolean'];
  /** Created at */
  createdAt: Scalars['String'];
  /** Updated at */
  updatedAt: Scalars['String'];
  /** User who created the record */
  createdBy: EditedBy;
  /** User who changed the record */
  editedBy: EditedBy;
  /** Individual client uid */
  uid: Scalars['String'];
  /** Individual client contact */
  contact: ContactInput;
  countries?: Maybe<Array<Country>>;
};

export type InputApproveOrDeclineRequest = {
  clientInput: AddClientInput;
  declineReason?: Maybe<Scalars['String']>;
  status: RequestClientStatus;
};

export type InputParcelsOrdersItems = {
  orderId: Scalars['ID'];
  parcelsId: Array<Scalars['ID']>;
};

export type InputParcelsReceptionAtRelay = {
  reasonUID?: Maybe<Scalars['String']>;
  parcelsReceivedAtHub: Array<InputParcelsOrdersItems>;
};

export type IntervateDateData = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type ItemInput = {
  /** Item code! */
  code: Scalars['String'];
  /** Item status! */
  description: Scalars['String'];
  /** Item quantity! */
  quantity: Scalars['Float'];
};

/** Status of the item! */
export enum ItemStatus {
  Default = 'Default',
  Done = 'Done',
  Failed = 'Failed'
}

export type Items = {
  product?: Maybe<ProductTemplateStop>;
  counter?: Maybe<Scalars['Int']>;
  _id?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type ItemsInput = {
  product?: Maybe<ProductTemplateStopInput>;
  counter?: Maybe<Scalars['Int']>;
};

export type ItemsTemplateStopsInput = {
  product?: Maybe<ProductTemplateStopInput>;
  counter?: Maybe<Scalars['Int']>;
};

/** job type */
export type Job = {
  /** ID JOB */
  _id?: Maybe<Scalars['ID']>;
  job_UID?: Maybe<Scalars['String']>;
  job_type?: Maybe<JobType>;
  job_address?: Maybe<Address>;
  job_time?: Maybe<Scalars['String']>;
  job_status?: Maybe<JobStatus>;
  job_vehicle_type?: Maybe<JobVehicleType>;
  job_date?: Maybe<Scalars['String']>;
  job_slot_start?: Maybe<Scalars['String']>;
  job_slot_end?: Maybe<Scalars['String']>;
  job_created_by?: Maybe<CreatedBy>;
  job_created_at?: Maybe<Scalars['String']>;
  job_last_edited_by?: Maybe<CreatedBy>;
  job_last_edited_at?: Maybe<Scalars['String']>;
  job_orders?: Maybe<Array<Maybe<Order>>>;
  job_client_UID?: Maybe<Scalars['ID']>;
  job_user_UID?: Maybe<Scalars['ID']>;
  job_client?: Maybe<Client>;
  job_task?: Maybe<Task>;
  job_activities?: Maybe<Array<Maybe<Activity>>>;
  isFromAPI?: Maybe<Scalars['Boolean']>;
};

/** JOBBYCLIENTFROMSUBTASK INPUT */
export type JobByClientFromSubtaskParams = {
  subtaskId: Scalars['ID'];
};

/** ADDJOB RESPONSE */
export type JobCreationDataResponse = {
  job?: Maybe<Job>;
  task?: Maybe<Task>;
};

export type JobCreationInput = {
  orders: Array<OrderCreationInput>;
  job: JobItemsInput;
  clientID: Scalars['ID'];
};

export type JobCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<JobCreationDataResponse>;
};

/** ADDJOB INPUT */
export type JobItemsInput = {
  job_type: JobType;
  job_address?: Maybe<AddressCreationInput>;
  job_date: Scalars['String'];
  job_slot_start?: Maybe<Scalars['String']>;
  job_slot_end?: Maybe<Scalars['String']>;
  job_time?: Maybe<Scalars['String']>;
  job_vehicle_type?: Maybe<JobVehicleType>;
};

/** UPDATEJOB RESPONSE */
export type JobPickupUpdateDataResponse = {
  job?: Maybe<Job>;
};

/** UPDATEJOB INPUT */
export type JobPickupUpdateInput = {
  id: Scalars['ID'];
  orders: Array<OrderCreationInput>;
  clientID: Scalars['ID'];
};

export type JobPickupUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<JobPickupUpdateDataResponse>;
};

export enum JobStatus {
  Pending = 'PENDING',
  Done = 'DONE',
  Picked = 'PICKED'
}

export enum JobType {
  Pickup = 'PICKUP',
  Dropoff = 'DROPOFF',
  FromStock = 'FROM_STOCK'
}

export enum JobVehicleType {
  Scooter = 'SCOOTER',
  Tricycle = 'TRICYCLE',
  MiniVan = 'MINI_VAN',
  Van = 'VAN',
  Camion = 'CAMION'
}

/** ALLJOBSBYCLIENT INPUT */
export type JobsByClientFetchParams = {
  clientID: Scalars['ID'];
};

export type JobsByClientFetchQueries = {
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<JobStatus>>>;
  type?: Maybe<Array<Maybe<JobType>>>;
  page?: Maybe<Scalars['Int']>;
};

/** ALLJOBS INPUT */
export type JobsFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<JobStatus>>>;
  type?: Maybe<Array<Maybe<JobType>>>;
  page?: Maybe<Scalars['Int']>;
};

/** ALLJOBS RESPONSE */
export type JobsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Job>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type JwtTokenResponse = {
  value?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['String']>;
};

export enum License_Type {
  Car = 'CAR',
  Motorcycle = 'MOTORCYCLE',
  BigLoad = 'BIG_LOAD'
}

export enum Lang {
  Fr = 'FR',
  En = 'EN'
}

/** drivers licence types! */
export enum LicenceType {
  Car = 'Car',
  Motorcycle = 'Motorcycle',
  BigLoad = 'BigLoad'
}

export type Location = {
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type LocationInput = {
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type LogoutOpsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

/** PARCELSBYIDS INPUT */
export type ManyParcelFetchQueries = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** PARCELSBYIDS RESPONSE */
export type ManyParcelFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Parcel>>>;
};

export type Mission = {
  _id?: Maybe<Scalars['ID']>;
  uid?: Maybe<Scalars['String']>;
  request?: Maybe<Request>;
  requestId?: Maybe<Scalars['ID']>;
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['ID']>;
  status?: Maybe<MissionStatusType>;
  cancel?: Maybe<Scalars['Boolean']>;
  raison?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  type?: Maybe<ERequestType>;
  canceled?: Maybe<Scalars['Boolean']>;
  vehicleType?: Maybe<EVehiculeType>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  productType?: Maybe<Array<Maybe<EProductType>>>;
  additionnalInfos?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  executionDate?: Maybe<Scalars['String']>;
  stops?: Maybe<Array<Maybe<Stop>>>;
  axes?: Maybe<Array<Maybe<Axe>>>;
  tasks?: Maybe<Array<Maybe<TaskMission>>>;
  createdBy?: Maybe<CreatedBy>;
  editedBy?: Maybe<EditedBy>;
  createdAt?: Maybe<Scalars['String']>;
  editedAt?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  vehicles?: Maybe<Array<Maybe<Vehicles>>>;
  runsheet?: Maybe<Runsheet>;
  weKnowWhatToDo?: Maybe<Scalars['Boolean']>;
};

export type MissionBasedOnConfigQueries = {
  requestId?: Maybe<Scalars['ID']>;
  configUID?: Maybe<Scalars['String']>;
};

export type MissionBasedOnConfigResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Mission>;
};

export type MissionCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Mission>>>;
};

export type MissionElligibiltyParams = {
  requestId: Scalars['ID'];
};

export type MissionElligibiltyResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type MissionExportNt = {
  mission?: Maybe<Mission>;
  runsheet?: Maybe<Runsheet>;
};

export type MissionExportResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<MissionExportNt>>>;
};

export type MissionFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  type: ERequestType;
  clientId?: Maybe<Scalars['ID']>;
  status?: Maybe<Array<MissionStatusType>>;
  executionDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Mission Fetch RESPONSE */
export type MissionFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Mission>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export enum MissionStatusType {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Done = 'DONE',
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED'
}

export type MissionsForRunsheetBadgeQueries = {
  groupStatus: Array<Maybe<MissionsForRunsheetBagde>>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
};

export type MissionsForRunsheetBagde = {
  status: EMissionType;
  key: Scalars['String'];
};

export type Model = {
  _id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Module = {
  _id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  created_by?: Maybe<RoleModuleCreatedOrUpdatedBy>;
  created_at?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<RoleModuleCreatedOrUpdatedBy>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
};

export type ModuleCreationInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type ModulesFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Module>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  createCourse: Course;
  deleteCourse: Course;
  assignCourse: Array<Course>;
  unAssignCourse: Course;
  updateCourse: Course;
  startOrFinishCourse: Course;
  startAction: Action;
  deleteAction: Action;
  createIndividualClient: Individualsclient;
  updateIndividualClient: Individualsclient;
  createDriver: Driver;
  updateDriver?: Maybe<DriverUpdateResponse>;
  removeDriver: Driver;
  addRefAddress: RefAddress;
  updateRefAddress: RefAddress;
  addOptionsContract?: Maybe<OptionsContractCreationResponse>;
  clientAuthenticate?: Maybe<ClientAuthentificationResponse>;
  clientLogout?: Maybe<ClientLogoutResponse>;
  clientConnectionWithGoogle?: Maybe<ClientAuthentificationResponse>;
  clientRefreshToken?: Maybe<ClientAccountRefreshTokenResponse>;
  clientRevokeToken?: Maybe<ClientAccountRevokeTokenResponse>;
  clientVerifyAccount?: Maybe<ClientAccountVerifyAccountResponse>;
  clientForgotPassword?: Maybe<ClientAccountForgetPasswordResponse>;
  clientValidateResetToken?: Maybe<ClientAccountValidResetTokenResponse>;
  clientValidateAccount?: Maybe<ClientAccountValidateAccountResponse>;
  clientResetPassword?: Maybe<ClientResetPasswordResponse>;
  clientChangePassword?: Maybe<ClientChangePasswordResponse>;
  deactivateAccount?: Maybe<DeactivateAccountResponse>;
  activateAccount?: Maybe<ActivateAccountResponse>;
  addJob?: Maybe<JobCreationResponse>;
  updateJobPickup?: Maybe<JobPickupUpdateResponse>;
  addOrder?: Maybe<OrderCreationResponse>;
  deleteOrder?: Maybe<DeleteResponse>;
  deleteManyOrders?: Maybe<DeleteResponse>;
  updateOrder?: Maybe<OrderCreationResponse>;
  sendOtpCodeToReceiverFromRelay?: Maybe<SendOtpCodeToReceiverFromRelayResponse>;
  validatePickUpByReceiver?: Maybe<ValidatePickUpByReceiverResponse>;
  cancelOrderFromRelay?: Maybe<CancelOrderFromRelayResponse>;
  confirmParcelReception?: Maybe<ConfirmParcelReceptionResponse>;
  setOrderOutOfStock?: Maybe<OrderCreationResponse>;
  updateReceiver?: Maybe<ReceiverUpdatingResponse>;
  addReceiver?: Maybe<ReceiverCreatingResponse>;
  deleteReceiver?: Maybe<ReceiverDeletingResponse>;
  receivingParcels?: Maybe<ParcelReceivingResponse>;
  updateParcel?: Maybe<ParcelUpdatingResponse>;
  setParcelNotReceived?: Maybe<ParcelNotReceivedResponse>;
  updateParcelDeliveryDate?: Maybe<ParcelUpdateDeliveryDateResponse>;
  updateParcelStatus?: Maybe<ParcelUpdatingResponse>;
  updateParcelTag?: Maybe<ParcelUpdatingResponse>;
  deleteParcel?: Maybe<ParcelDeleteResponse>;
  deleteManyParcels?: Maybe<ParcelDeleteResponse>;
  setOutOfStockParcel?: Maybe<ParcelUpdatingResponse>;
  parcelsReceptionAtRelayPoint?: Maybe<ParcelsReceptionAtRelayPointResponse>;
  openParcelsActionForRelay?: Maybe<OpenParcelsActionForRelayResponse>;
  addRunsheet?: Maybe<RunsheetCreationResponse>;
  addRunsheetMission?: Maybe<RunsheetCreationResponse>;
  addRunsheetReturn?: Maybe<RunsheetReturnCreationResponse>;
  assignRunsheet?: Maybe<RunsheetAssignationResponse>;
  assignRunsheetV2?: Maybe<RunsheetAssignationResponse>;
  unassignRunsheet?: Maybe<UnassignRunsheetResponse>;
  collectRunsheetMoney?: Maybe<RunsheetMoneyCollectionResponse>;
  reconcileRunsheet?: Maybe<RunsheetReconciliationResponse>;
  partiallyReconcileRunsheet?: Maybe<RunsheetPartialReconciliationResponse>;
  validateRunsheetReturn?: Maybe<RunsheetReturnValidationResponse>;
  updateOrdersInRunsheet?: Maybe<UpdateOrdersInRunsheetResponse>;
  editDeliveryRunsheet?: Maybe<EditExecutionRunsheetResponse>;
  manuallyCollectRunsheetMoney?: Maybe<RunsheetManualMoneyCollectionResponse>;
  updateRunsheetStatus?: Maybe<RunsheetStatusEditionResponse>;
  deleteRunsheetStatus?: Maybe<RunsheetStatusDeletionResponse>;
  createHubReturnRunsheet?: Maybe<RunsheetCreationResponse>;
  createRunshhetMissionV2?: Maybe<CreateRunsheetMissionV2Response>;
  runsheetProcessing?: Maybe<RunsheetProcessingResponse>;
  unassignRunsheetV2?: Maybe<RunsheetUnassignmentV2Response>;
  reassignRunsheetV2?: Maybe<RunsheetReassignmentV2Response>;
  updateRunsheetV2?: Maybe<RunsheetUpdateResponse>;
  addMultipleReasons?: Maybe<ReasonCreationResponse>;
  updateMultipleReasons?: Maybe<ReasonCreationResponse>;
  addMultipleReasonGroups?: Maybe<ReasonGroupCreationResponse>;
  assignMultipleTask?: Maybe<AssignMultipleTaskResponse>;
  updateDateDeliverySubtaskAfterRescheduling?: Maybe<UpdateDateDeliverySubtaskAfterReschedulingResponse>;
  updateMultipleDateDeliverySubtaskAfterRescheduling?: Maybe<UpdateMultipleDateDeliverySubtaskAfterReschedulingResponse>;
  deleteTask?: Maybe<DeleteTaskResponse>;
  unassignTask?: Maybe<UnassignTaskResponse>;
  updatePickupTask?: Maybe<PickupTaskUpdateResponse>;
  addTaskTransferRequestFromPapser?: Maybe<TaskTransferRequestResponse>;
  addTaskTransferRequestFromOps?: Maybe<TaskTransferRequestResponse>;
  taskTransferProcessing?: Maybe<TaskTransferProcessingResponse>;
  declineTaskTransferRequest?: Maybe<TaskTransferProcessingResponse>;
  validateTaskTransferRequest?: Maybe<TaskTransferProcessingResponse>;
  startOrFinishTask?: Maybe<StartOrFinishTaskResponse>;
  reportTaskIssue?: Maybe<ReportIssueResponse>;
  reportPapserIssue?: Maybe<ReportPapserIssueResponse>;
  subtaskProcessing?: Maybe<SubtaskDeliveryValidationResponse>;
  subtaskPickupValidation?: Maybe<SubtaskPickupValidationResponse>;
  subtaskRescheduling?: Maybe<SubtaskReschedulingResponse>;
  subtaskReschedulingByClient?: Maybe<SubtaskReschedulingByClientResponse>;
  sendCodeDeliveryReception?: Maybe<SendCodeDeliveryReceptionResponse>;
  subtaskDeliveryValidation?: Maybe<SubtaskDeliveryValidationResponse>;
  subtaskDeliveryReturnValidation?: Maybe<SubtaskDeliveryReturnValidationResponse>;
  deleteSubtaskPickupFromClient?: Maybe<DeleteResponse>;
  dropParcelsAtWareHouse?: Maybe<DropParcelsAtWareHouseResponse>;
  addCompanyUser?: Maybe<CompanyUserCreationResponse>;
  updateCompanyUser?: Maybe<CompanyUserUpdateResponse>;
  deleteCompanyUser?: Maybe<CompanyUserDeleteResponse>;
  addClient?: Maybe<ClientCreationResponse>;
  checkClient?: Maybe<ClientCheckResponse>;
  updateClient?: Maybe<ClientUpdateResponse>;
  updateClientAddress?: Maybe<ClientUpdateAddressResponse>;
  createClientRequest?: Maybe<CreateRequestResponse>;
  approveOrDeclineRequest?: Maybe<ApproveOrDeclineRequestResponse>;
  addClientRefAddress?: Maybe<ClientRefAddressResponse>;
  updateClientRefAddress?: Maybe<ClientRefAddressResponse>;
  deleteClientRefAddress?: Maybe<DeletedClientRefAddressResponse>;
  addConveyor?: Maybe<ConveyorCreationResponse>;
  updateConveyor?: Maybe<ConveyorUpdateResponse>;
  deleteMultipleConveyors?: Maybe<DeleteResponse>;
  blockConveyor?: Maybe<BlockConveyorResponse>;
  addDriverToPartner?: Maybe<DriverCreationResponse>;
  deleteDriver?: Maybe<DeleteResponse>;
  deleteMultipleDrivers?: Maybe<DeleteResponse>;
  blockOrUnblockDriver?: Maybe<BlockOrUnblockDriverResponse>;
  addVehicle?: Maybe<VehicleCreationResponse>;
  updateVehicle?: Maybe<VehicleUpdateResponse>;
  deleteVehicle?: Maybe<VehicleDeletionResponse>;
  deleteMultipleVehicles?: Maybe<DeleteResponse>;
  addPartner?: Maybe<PartnerCreationResponse>;
  updatePartner?: Maybe<PartnerUpdateResponse>;
  deletePartner?: Maybe<PartnerDeleteResponse>;
  deleteMultiplePartners?: Maybe<DeleteResponse>;
  addBillingAccount?: Maybe<AddBillingAccountsResponse>;
  sendCodeOTP?: Maybe<SendCodeOtpResponse>;
  authenticateOTP?: Maybe<AuthenticateOtpResponse>;
  updatePapser?: Maybe<UserPapserUpdateResponse>;
  addUser?: Maybe<AddUserResponse>;
  updateUser?: Maybe<UpdateUserResponse>;
  deleteUser?: Maybe<DeleteUserResponse>;
  authenticateOps?: Maybe<AuthenticationOpsResponse>;
  authenticateGoogleOps?: Maybe<AuthenticationOpsResponse>;
  logoutOps?: Maybe<LogoutOpsResponse>;
  resetPasswordOps?: Maybe<ResetPasswordOpsResponse>;
  changePasswordOps?: Maybe<ChangePasswordOpsResponse>;
  validateAccountOps?: Maybe<ValidateAccountOpsResponse>;
  forgotPasswordOps?: Maybe<ForgotPasswordOpsResponse>;
  verifyAccountOps?: Maybe<VerifyAccountOpsResponse>;
  addModule?: Maybe<AddModuleResponse>;
  addPermission?: Maybe<AddPermissionResponse>;
  addRole?: Maybe<AddRoleResponse>;
  updateRole?: Maybe<UpdateRoleResponse>;
  deleteRole?: Maybe<DeleteRoleResponse>;
  updatePermission?: Maybe<UpdatePermissionResponse>;
  createTemplate: TemplateReturn;
  updateTemplate: TemplateUpdateReturn;
  deleteTemplate: TemplateDeleteReturn;
  updateNotificationViewer: NotificationSetViewerResponse;
  addCategory?: Maybe<CategoryCreationResponse>;
  addProduct?: Maybe<ProductCreationResponse>;
  updateProduct?: Maybe<ProductUpdateResponse>;
  deleteProduct?: Maybe<ProductDeleteResponse>;
  uploadProducts?: Maybe<ProductsUploadResponse>;
  addRequest?: Maybe<RequestCreationResponse>;
  updateRequest?: Maybe<RequestUpdateResponse>;
  acceptRequest?: Maybe<RequestAcceptResponse>;
  approveRequest?: Maybe<RequestApproveResponse>;
  declineRequest?: Maybe<RequestDeclineResponse>;
  createMission?: Maybe<MissionCreationResponse>;
  newEventRequest?: Maybe<RequestNewEventResponse>;
  archiveRequest?: Maybe<RequestArchiveResponse>;
  reloadRequest?: Maybe<RequestReloadResponse>;
  disableStops?: Maybe<DisableStopsResponse>;
  createMissionTourRequest?: Maybe<RequestCreationResponse>;
  disableStopsUpdate?: Maybe<StopDisableUpdateResponse>;
  axeSlotUpdate?: Maybe<AxeUpdateResponse>;
  redefinedTemplateAxe?: Maybe<TemplateAxeRedefineResponse>;
  whatToDoUpdate?: Maybe<StopActionUpdateResponse>;
  editNationalTransportSlot?: Maybe<EditNationalTransportInputRespone>;
  editMadSlots?: Maybe<EditMadSlotsResponse>;
  splitTasksNtTransit?: Maybe<SplitTasksNtTransitResponse>;
  createTasksMissionTour?: Maybe<CreateTasksMissionTourResponse>;
  renameAxe?: Maybe<RenameAxeResponse>;
  addPaymentMethod?: Maybe<PaymentMethodCreationResponse>;
  addMultipleGift?: Maybe<AddMultipleGiftResponse>;
  assignGift?: Maybe<AssignGiftResponse>;
  addHub?: Maybe<HubCreationResponse>;
  addCountry?: Maybe<CountryCreationResponse>;
  addUsersIntoHub?: Maybe<HubUsersUpdatedResponse>;
  removeUsersIntoHub?: Maybe<HubUsersUpdatedResponse>;
  updateHub?: Maybe<HubUpdateResponse>;
  deleteHub?: Maybe<HubDeletionResponse>;
  addRemittance?: Maybe<RemittanceCreationResponse>;
  updateRemittance?: Maybe<RemittanceCreationResponse>;
  confirmRemittance?: Maybe<RemittanceCreationResponse>;
  removeRemittanceParcels?: Maybe<RemittanceCreationResponse>;
  deleteRemittance?: Maybe<RemittanceDeletingResponse>;
  createService?: Maybe<CreateServiceRespone>;
  updateService?: Maybe<UpdateServiceRespone>;
  deleteService?: Maybe<DeleteServiceRespone>;
  createProgram: CreateProgramResponse;
  updateProgram: UpdateProgramResponse;
  subscribeProgram: SubscribeProgramResponse;
  unsubscribeProgram: UnsubscribeProgramResponse;
  updateSubscribeProgram: UpdateSubscribeProgramResponse;
  deleteProgram: DeleteProgramResponse;
  sendMail?: Maybe<SendMailCreationResponse>;
  updateAdvantage: UpdateAdvantageResponse;
  useAdvantage: UseAdvantageResponse;
  confirmDemand?: Maybe<ConfirmDemandResponse>;
};


export type MutationCreateCourseArgs = {
  courseInput: CreateCourseInput;
};


export type MutationDeleteCourseArgs = {
  id: Scalars['ID'];
};


export type MutationAssignCourseArgs = {
  input: AssignCourseInput;
};


export type MutationUnAssignCourseArgs = {
  input: AssignCourseInput;
};


export type MutationUpdateCourseArgs = {
  input: UpdateCourseInput;
};


export type MutationStartOrFinishCourseArgs = {
  input: StartCourseInput;
};


export type MutationStartActionArgs = {
  input: StartActionInput;
};


export type MutationDeleteActionArgs = {
  id: Scalars['ID'];
};


export type MutationCreateIndividualClientArgs = {
  input: CreateIndividualClientInput;
};


export type MutationUpdateIndividualClientArgs = {
  id: Scalars['ID'];
  input: CreateIndividualClientInput;
};


export type MutationCreateDriverArgs = {
  createDriverInput: CreateDriverInput;
};


export type MutationUpdateDriverArgs = {
  input: DriverUpdateInput;
};


export type MutationRemoveDriverArgs = {
  id: Scalars['Int'];
};


export type MutationAddRefAddressArgs = {
  input: AddIndividualClientAddressInput;
};


export type MutationUpdateRefAddressArgs = {
  id: Scalars['ID'];
  input: UpdateIndividualClientAddressInput;
};


export type MutationAddOptionsContractArgs = {
  input?: Maybe<OptionsContractCreateInput>;
};


export type MutationClientAuthenticateArgs = {
  input: ClientAuthenticateInput;
};


export type MutationClientConnectionWithGoogleArgs = {
  input: ClientGoogleLoginInput;
};


export type MutationClientRefreshTokenArgs = {
  input: ClientAccountRefreshTokenInput;
};


export type MutationClientRevokeTokenArgs = {
  input: ClientAccountRevokeTokenInput;
};


export type MutationClientVerifyAccountArgs = {
  input: ClientAccountVerifyAccount;
};


export type MutationClientForgotPasswordArgs = {
  input: ClientAccountForgetPasswordInput;
};


export type MutationClientValidateResetTokenArgs = {
  input: ClientAccountValidateResetTokenInput;
};


export type MutationClientValidateAccountArgs = {
  input: ClientAccountValidateAccountInput;
};


export type MutationClientResetPasswordArgs = {
  input: ClientResetPasswordInput;
};


export type MutationClientChangePasswordArgs = {
  input: ClientChangePasswordInput;
};


export type MutationDeactivateAccountArgs = {
  input: DeactivateAccountInput;
};


export type MutationActivateAccountArgs = {
  input: ActivateAccountInput;
};


export type MutationAddJobArgs = {
  input: JobCreationInput;
};


export type MutationUpdateJobPickupArgs = {
  input: JobPickupUpdateInput;
};


export type MutationAddOrderArgs = {
  input?: Maybe<OrderCreationInput>;
};


export type MutationDeleteOrderArgs = {
  input: DeleteInput;
};


export type MutationDeleteManyOrdersArgs = {
  orderIds: Array<Maybe<Scalars['ID']>>;
};


export type MutationUpdateOrderArgs = {
  input: OrderUpdateQueryInput;
};


export type MutationSendOtpCodeToReceiverFromRelayArgs = {
  orderId: Scalars['String'];
};


export type MutationValidatePickUpByReceiverArgs = {
  orderId: Scalars['String'];
  codeOTP: Scalars['String'];
};


export type MutationCancelOrderFromRelayArgs = {
  orderId: Scalars['String'];
  reasonUID: Scalars['String'];
};


export type MutationConfirmParcelReceptionArgs = {
  orderId: Scalars['ID'];
};


export type MutationSetOrderOutOfStockArgs = {
  orderId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  isOutOfStock: Scalars['Boolean'];
};


export type MutationUpdateReceiverArgs = {
  input: ReceiverUpdatingInput;
};


export type MutationAddReceiverArgs = {
  input: ReceiverAddInput;
};


export type MutationDeleteReceiverArgs = {
  input: ReceiverDeleteInput;
};


export type MutationReceivingParcelsArgs = {
  input: ParcelReceivingInput;
};


export type MutationUpdateParcelArgs = {
  input: ParcelUpdateInput;
};


export type MutationSetParcelNotReceivedArgs = {
  input: ParcelNotReceivedInput;
};


export type MutationUpdateParcelDeliveryDateArgs = {
  input: ParcelUpdateDeliveryDateInput;
};


export type MutationUpdateParcelStatusArgs = {
  input: ParcelStatusUpdatingInput;
};


export type MutationUpdateParcelTagArgs = {
  input: ParcelTagUpdatingInput;
};


export type MutationDeleteParcelArgs = {
  parcelID: Scalars['ID'];
};


export type MutationDeleteManyParcelsArgs = {
  parcelIds: Array<Maybe<Scalars['ID']>>;
};


export type MutationSetOutOfStockParcelArgs = {
  parcelId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  isOutOfStock: Scalars['Boolean'];
};


export type MutationParcelsReceptionAtRelayPointArgs = {
  input: InputParcelsReceptionAtRelay;
};


export type MutationOpenParcelsActionForRelayArgs = {
  hubCode: Scalars['String'];
};


export type MutationAddRunsheetArgs = {
  input: RunsheetCreationInput;
};


export type MutationAddRunsheetMissionArgs = {
  input: RunsheetMissionCreationInput;
};


export type MutationAddRunsheetReturnArgs = {
  input: RunsheetReturnCreationInput;
};


export type MutationAssignRunsheetArgs = {
  input: RunsheetAssignationInput;
};


export type MutationAssignRunsheetV2Args = {
  input: RunsheetAssignationInput;
};


export type MutationUnassignRunsheetArgs = {
  runsheetID: Scalars['ID'];
};


export type MutationCollectRunsheetMoneyArgs = {
  input: RunsheetMoneyCollectionInput;
};


export type MutationReconcileRunsheetArgs = {
  input: RunsheetReconciliationInput;
};


export type MutationPartiallyReconcileRunsheetArgs = {
  input: RunsheetPartialReconciliationInput;
};


export type MutationValidateRunsheetReturnArgs = {
  input: RunsheetReturnValidationInput;
};


export type MutationUpdateOrdersInRunsheetArgs = {
  input?: Maybe<UpdateOrdersInRunsheetInput>;
};


export type MutationEditDeliveryRunsheetArgs = {
  input: EditExecutionRunsheetInput;
};


export type MutationManuallyCollectRunsheetMoneyArgs = {
  input: RunsheetManualMoneyCollectionInput;
};


export type MutationUpdateRunsheetStatusArgs = {
  runsheetId: Scalars['ID'];
  runsheetStatus: RunsheetStatus;
};


export type MutationDeleteRunsheetStatusArgs = {
  runsheetID: Scalars['ID'];
};


export type MutationCreateHubReturnRunsheetArgs = {
  parcelsId: Array<Scalars['ID']>;
};


export type MutationCreateRunshhetMissionV2Args = {
  input: CreateRunsheetMissionV2Input;
};


export type MutationRunsheetProcessingArgs = {
  input: RunsheetProcessingInput;
};


export type MutationUnassignRunsheetV2Args = {
  runsheetId: Scalars['ID'];
};


export type MutationReassignRunsheetV2Args = {
  runsheetId: Scalars['ID'];
  reassignInput: ReassignInput;
};


export type MutationUpdateRunsheetV2Args = {
  runsheetId: Scalars['ID'];
  updateInput: RunsheetMissionUpdateInput;
};


export type MutationAddMultipleReasonsArgs = {
  input: ReasonMultipleCreationInput;
};


export type MutationUpdateMultipleReasonsArgs = {
  input: ReasonMultipleUpdatingInput;
};


export type MutationAddMultipleReasonGroupsArgs = {
  input?: Maybe<ReasonGroupMultipleCreationInput>;
};


export type MutationAssignMultipleTaskArgs = {
  input: AssignMultipleTaskInput;
};


export type MutationUpdateDateDeliverySubtaskAfterReschedulingArgs = {
  input: UpdateDateDeliverySubtaskAfterReschedulingInput;
};


export type MutationUpdateMultipleDateDeliverySubtaskAfterReschedulingArgs = {
  input: UpdateMultipleDateDeliverySubtaskAfterReschedulingInput;
};


export type MutationDeleteTaskArgs = {
  taskID?: Maybe<Scalars['ID']>;
};


export type MutationUnassignTaskArgs = {
  taskID: Scalars['ID'];
};


export type MutationUpdatePickupTaskArgs = {
  input: PickupTaskUpdateInput;
};


export type MutationAddTaskTransferRequestFromPapserArgs = {
  input: TaskTransferRequestFromPapserInput;
};


export type MutationAddTaskTransferRequestFromOpsArgs = {
  input: TaskTransferRequestFromOpsInput;
};


export type MutationTaskTransferProcessingArgs = {
  input: TaskTransferProcessingInput;
};


export type MutationDeclineTaskTransferRequestArgs = {
  input: DeclineTaskTransferRequestInput;
};


export type MutationValidateTaskTransferRequestArgs = {
  input: ValidateTaskTransferRequestInput;
};


export type MutationStartOrFinishTaskArgs = {
  input: StartOrFinishTaskInput;
};


export type MutationReportTaskIssueArgs = {
  input: ReportIssueInput;
};


export type MutationReportPapserIssueArgs = {
  input: ReportPapserIssueInput;
};


export type MutationSubtaskProcessingArgs = {
  input: SubtaskProcessingInput;
};


export type MutationSubtaskPickupValidationArgs = {
  input: SubtaskPickupValidationInput;
};


export type MutationSubtaskReschedulingArgs = {
  input: SubtaskReschedulingInput;
};


export type MutationSubtaskReschedulingByClientArgs = {
  input: SubtaskReschedulingByClientInput;
};


export type MutationSendCodeDeliveryReceptionArgs = {
  input: SendCodeDeliveryReceptionInput;
};


export type MutationSubtaskDeliveryValidationArgs = {
  input: SubtaskDeliveryValidationInput;
};


export type MutationSubtaskDeliveryReturnValidationArgs = {
  input: SubtaskDeliveryReturnValidationInput;
};


export type MutationDeleteSubtaskPickupFromClientArgs = {
  input: DeleteInput;
};


export type MutationDropParcelsAtWareHouseArgs = {
  subtaskId: Scalars['ID'];
};


export type MutationAddCompanyUserArgs = {
  input?: Maybe<CompanyUserCreateInput>;
};


export type MutationUpdateCompanyUserArgs = {
  input?: Maybe<CompanyUserUpdateInput>;
};


export type MutationDeleteCompanyUserArgs = {
  input: CompanyUserDeleteInput;
};


export type MutationAddClientArgs = {
  input: ClientCreationInput;
};


export type MutationCheckClientArgs = {
  input: ClientCheckInput;
};


export type MutationUpdateClientArgs = {
  input: ClientUpdateInput;
};


export type MutationUpdateClientAddressArgs = {
  input: ClientUpdateAddressInput;
};


export type MutationCreateClientRequestArgs = {
  input: AddClientRequestInput;
};


export type MutationApproveOrDeclineRequestArgs = {
  params: ParamsApproveOrDeclineRequest;
  input: InputApproveOrDeclineRequest;
};


export type MutationAddClientRefAddressArgs = {
  input: ClientRefAddressInput;
};


export type MutationUpdateClientRefAddressArgs = {
  input: UpdateClientRefAddressInput;
};


export type MutationDeleteClientRefAddressArgs = {
  input: DeleteClientRefInput;
};


export type MutationAddConveyorArgs = {
  input: ConveyorCreationInput;
};


export type MutationUpdateConveyorArgs = {
  input: ConveyorUpdateInput;
};


export type MutationDeleteMultipleConveyorsArgs = {
  input: DeleteMultipleConveyor;
};


export type MutationBlockConveyorArgs = {
  input: BlockConveyorInput;
};


export type MutationAddDriverToPartnerArgs = {
  input: DriverCreationInput;
};


export type MutationDeleteDriverArgs = {
  input: DeleteInput;
};


export type MutationDeleteMultipleDriversArgs = {
  input: DeleteMultipleDriver;
};


export type MutationBlockOrUnblockDriverArgs = {
  input: BlockOrUnblockDriverInput;
};


export type MutationAddVehicleArgs = {
  input: VehicleCreationInput;
};


export type MutationUpdateVehicleArgs = {
  input?: Maybe<VehicleUpdateInput>;
};


export type MutationDeleteVehicleArgs = {
  input: VehicleDeletionInput;
};


export type MutationDeleteMultipleVehiclesArgs = {
  input: DeleteMultipleVehicleInput;
};


export type MutationAddPartnerArgs = {
  input: PartnerCreationInput;
};


export type MutationUpdatePartnerArgs = {
  input: PartnerUpdateInput;
};


export type MutationDeletePartnerArgs = {
  input: PartnerDeleteInput;
};


export type MutationDeleteMultiplePartnersArgs = {
  input: DeleteMultiplePartnerInput;
};


export type MutationAddBillingAccountArgs = {
  input: AddBillingAccountInput;
};


export type MutationSendCodeOtpArgs = {
  input: SendCodeOtpInput;
};


export type MutationAuthenticateOtpArgs = {
  input: AuthenticateOtpInput;
};


export type MutationUpdatePapserArgs = {
  input: UserPapserUpdateInput;
};


export type MutationAddUserArgs = {
  input: AddUserInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationAuthenticateOpsArgs = {
  input: AuthenticationOpsInput;
};


export type MutationAuthenticateGoogleOpsArgs = {
  input: AuthenticateGoogleOpsInput;
};


export type MutationResetPasswordOpsArgs = {
  input: ResetPasswordOpsInput;
};


export type MutationChangePasswordOpsArgs = {
  input: ChangePasswordOpsInput;
};


export type MutationValidateAccountOpsArgs = {
  input: ValidateAccountOpsInput;
};


export type MutationForgotPasswordOpsArgs = {
  input: ForgotPasswordOpsInput;
};


export type MutationVerifyAccountOpsArgs = {
  input: VerifyAccountOpsInput;
};


export type MutationAddModuleArgs = {
  input: AddModuleInput;
};


export type MutationAddPermissionArgs = {
  input: AddPermissionInput;
};


export type MutationAddRoleArgs = {
  input: AddRoleInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationUpdatePermissionArgs = {
  input: UpdatePermissionInput;
};


export type MutationCreateTemplateArgs = {
  template: TemplateInput;
};


export type MutationUpdateTemplateArgs = {
  id: Scalars['ID'];
  template: TemplateInput;
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateNotificationViewerArgs = {
  viewer: Scalars['ID'];
  viewerPlatform: Scalars['ID'];
  platform: EPlatform;
  service?: Maybe<EService>;
};


export type MutationAddCategoryArgs = {
  input: CategoryCreationInput;
};


export type MutationAddProductArgs = {
  input: ProductCreationInput;
};


export type MutationUpdateProductArgs = {
  input: ProductUpdateInput;
};


export type MutationDeleteProductArgs = {
  input: ProductDeleteInput;
};


export type MutationUploadProductsArgs = {
  input: ProductsUploadInput;
};


export type MutationAddRequestArgs = {
  input: RequestCreationInput;
};


export type MutationUpdateRequestArgs = {
  input: RequestUpdateInput;
};


export type MutationAcceptRequestArgs = {
  input: RequestAcceptInput;
};


export type MutationApproveRequestArgs = {
  input: RequestApproveInput;
};


export type MutationDeclineRequestArgs = {
  input: RequestDeclineInput;
};


export type MutationCreateMissionArgs = {
  input: CreateMissionInput;
};


export type MutationNewEventRequestArgs = {
  input: RequestNewEventInput;
};


export type MutationArchiveRequestArgs = {
  input: RequestArchiveInput;
};


export type MutationReloadRequestArgs = {
  input: RequestReloadInput;
};


export type MutationDisableStopsArgs = {
  input: DisableStopsInput;
};


export type MutationCreateMissionTourRequestArgs = {
  input: CreateMissionInput;
};


export type MutationDisableStopsUpdateArgs = {
  input: DisableStopUpdateInput;
};


export type MutationAxeSlotUpdateArgs = {
  input: AxeUpdatedInput;
};


export type MutationRedefinedTemplateAxeArgs = {
  input: TemplateAxeRedefineInput;
};


export type MutationWhatToDoUpdateArgs = {
  input: TemplateStopActionUpdateInput;
};


export type MutationEditNationalTransportSlotArgs = {
  input: EditNationalTransportInput;
};


export type MutationEditMadSlotsArgs = {
  input: EditMadSlotsInput;
};


export type MutationSplitTasksNtTransitArgs = {
  queries: SplitTasksNtTransitQueries;
  input: SplitTasksNtTransitInput;
};


export type MutationCreateTasksMissionTourArgs = {
  queries: CreateTasksMissionTourQueries;
};


export type MutationRenameAxeArgs = {
  input: RenameAxesInput;
};


export type MutationAddPaymentMethodArgs = {
  input: PaymentMethodCreationInput;
};


export type MutationAddMultipleGiftArgs = {
  input: AddMultipleGiftInput;
};


export type MutationAssignGiftArgs = {
  input: AssignGiftInput;
};


export type MutationAddHubArgs = {
  input: HubCreationInput;
};


export type MutationAddCountryArgs = {
  input: CountryCreationInput;
};


export type MutationAddUsersIntoHubArgs = {
  usersToAdd: Array<Scalars['ID']>;
  hubId: Scalars['ID'];
  isAdmin?: Maybe<Scalars['Boolean']>;
};


export type MutationRemoveUsersIntoHubArgs = {
  usersToRemove: Array<Scalars['ID']>;
  hubId: Scalars['ID'];
};


export type MutationUpdateHubArgs = {
  hubId: Scalars['ID'];
  input?: Maybe<HubUpdateInput>;
};


export type MutationDeleteHubArgs = {
  hubId: Scalars['ID'];
};


export type MutationAddRemittanceArgs = {
  input: RemittanceCreationInput;
};


export type MutationUpdateRemittanceArgs = {
  input: RemittanceUpdatingInput;
};


export type MutationConfirmRemittanceArgs = {
  input: RemittanceConfirmInput;
};


export type MutationRemoveRemittanceParcelsArgs = {
  input: RemittanceParcelsUpdatingInput;
};


export type MutationDeleteRemittanceArgs = {
  input: RemittanceDeleteInput;
};


export type MutationCreateServiceArgs = {
  input: ServiceInput;
};


export type MutationUpdateServiceArgs = {
  input: UpdateServiceInput;
};


export type MutationDeleteServiceArgs = {
  id: Scalars['ID'];
};


export type MutationCreateProgramArgs = {
  input: CreateProgramInput;
};


export type MutationUpdateProgramArgs = {
  input: UpdateProgramParams;
};


export type MutationSubscribeProgramArgs = {
  input: SubscribeProgramInput;
};


export type MutationUnsubscribeProgramArgs = {
  input: UnsubscribeProgramInput;
};


export type MutationUpdateSubscribeProgramArgs = {
  input: UpdateSubscribeProgramInput;
};


export type MutationDeleteProgramArgs = {
  id: Scalars['ID'];
};


export type MutationSendMailArgs = {
  input: SendMailCreationInput;
};


export type MutationUpdateAdvantageArgs = {
  input: UpdateAdvantageParams;
};


export type MutationUseAdvantageArgs = {
  input: UseAdvantageInput;
};


export type MutationConfirmDemandArgs = {
  input?: Maybe<ConfirmDemandInput>;
};

export type Notification = {
  content?: Maybe<Scalars['String']>;
  broadcast?: Maybe<Scalars['Boolean']>;
  platform?: Maybe<Array<Maybe<EPlatform>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  link?: Maybe<Scalars['String']>;
  viewersClient?: Maybe<Array<Maybe<Scalars['ID']>>>;
  viewersOps?: Maybe<Array<Maybe<Scalars['ID']>>>;
  viewersPapser?: Maybe<Array<Maybe<Scalars['ID']>>>;
  readBy?: Maybe<Array<Maybe<Scalars['ID']>>>;
  template?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  service?: Maybe<EService>;
};

export type NotificationBadgeResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type NotificationFetchResponse = {
  data?: Maybe<Array<Maybe<Notification>>>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type NotificationFilter = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};

export type NotificationResponse = {
  data?: Maybe<Notification>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type NotificationSetViewerResponse = {
  data?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

/** CLIENTBYID INPUT */
export type OneClientFetchParams = {
  id: Scalars['ID'];
};

/** CLIENTBYID RESPONSE */
export type OneClientFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneClientFetchResponse>;
};

/** CONVEYORBYID INPUT */
export type OneConveyorFetchParams = {
  id: Scalars['ID'];
};

/** CONVEYORBYID RESPONSE */
export type OneConveyorFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneConveyorResponse>;
};

export type OneDataCurrentOpsUserResponse = {
  user?: Maybe<UserStaff>;
};

export type OneDataUserStaffResponse = {
  user?: Maybe<UserStaff>;
};

export type OneDriverFetchParams = {
  id: Scalars['ID'];
};

/** DRIVERBYID RESPONSE */
export type OneDriverFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneDriverResponse>;
};

/** JOBBYIDBYCLIENT INPUT */
export type OneJobByClientFetchParams = {
  id: Scalars['ID'];
  clientID: Scalars['ID'];
};

/** JOBBYID INPUT */
export type OneJobFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

/** JOBBYID RESPONSE */
export type OneJobFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Job>;
};

export type OneModuleFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

export type OneModuleFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Module>;
};

/** ORDERBYIDBYCLIENT INPUT */
export type OneOrderByClientFetchParams = {
  clientID: Scalars['ID'];
  id: Scalars['ID'];
};

/** ORDERBYID INPUT */
export type OneOrderFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

/** ORDERBYID RESPONSE */
export type OneOrderFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Order>;
};

/** PARCELBYIDBYCLIENT INPUT */
export type OneParcelByClientFetchParams = {
  clientID: Scalars['ID'];
  id: Scalars['ID'];
};

export type OneParcelByClientFetchQueries = {
  lang?: Maybe<Lang>;
};

/** PARCELBYID INPUT */
export type OneParcelFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

export type OneParcelFetchQueries = {
  lang?: Maybe<Lang>;
};

/** PARCELBYID RESPONSE */
export type OneParcelFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Parcel>;
};

export type OneParcelWithCodeFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<OneParcelWithCodeResponse>;
};

export type OneParcelWithCodeResponse = {
  parcel?: Maybe<Parcel>;
  parcelDeliveryCode?: Maybe<Scalars['String']>;
};

export type OnePartnerFetchParams = {
  id: Scalars['ID'];
};

/** PARTNERBYID RESPONSE */
export type OnePartnerFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOnePartnerResponse>;
};

/** RECEIVERBYIDBYCLIENT INPUT */
export type OneReceiverByClientFetchParams = {
  clientID: Scalars['ID'];
  id: Scalars['ID'];
};

/** RECEIVERBYID INPUT */
export type OneReceiverFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

/** RECEIVERBYID RESPONSE */
export type OneReceiverFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Receiver>;
};

/** REMITTANCEBYID INPUT */
export type OneRemittanceFetchParams = {
  id: Scalars['ID'];
};

/** REQUESTBYID INPUT */
export type OneRequestFetchParams = {
  id: Scalars['ID'];
};

/** REQUESTBYID RESPONSE */
export type OneRequestFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export type OneRoleFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

export type OneRoleFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Module>;
};

/** RUNSHEETBYID INPUT */
export type OneRunsheetFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

/** RUNSHEETBYID RESPONSE */
export type OneRunsheetFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Runsheet>;
};

export type OneRunsheetsFetchQueries = {
  lang?: Maybe<Lang>;
};

/** SUBTASKBYIDBYCLIENT INPUT */
export type OneSubTaskByClientFetchParams = {
  clientID: Scalars['ID'];
  id: Scalars['ID'];
};

/** SUBTASKBYID INPUT */
export type OneSubTaskFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

/** SUBTASKBYID RESPONSE */
export type OneSubTaskFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<SubTask>;
};

/** TASKBYID INPUT */
export type OneTaskFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

/** TASKBYID RESPONSE */
export type OneTaskFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Task>;
};

export type OneUserStaffFetchParams = {
  id?: Maybe<Scalars['ID']>;
};

export type OneUserStaffFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<OneDataUserStaffResponse>;
};

/** VEHICLEBYID INPUT */
export type OneVehicleFetchParams = {
  id: Scalars['ID'];
};

/** VEHICLEBYID RESPONSE */
export type OneVehicleFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneVehicleResponse>;
};

export type OpenParcelsActionForRelayResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type OptionsContract = {
  _id?: Maybe<Scalars['ID']>;
  options_contract_libelle?: Maybe<Scalars['String']>;
  options_contract_clients?: Maybe<Array<Maybe<Client>>>;
  options_contract_created_by?: Maybe<Created_By>;
  options_contract_updated_by?: Maybe<Created_By>;
};

export type OptionsContractByIdFetchQueries = {
  id?: Maybe<Scalars['ID']>;
};

export type OptionsContractByIdFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOneOptionsContractResponse>;
};

export type OptionsContractCreateInput = {
  optionsContract?: Maybe<OptionsContractCreateItems>;
};

/** ADD OPTIONS_CONTRACT INPUT */
export type OptionsContractCreateItems = {
  options_contract_libelle: Scalars['String'];
};

export type OptionsContractCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOptionsContractCreationResponse>;
};

/** INPUT */
export type OptionsContractFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

/** RESPONSE */
export type OptionsContractFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataOptionsContractFetchResponse>;
};

export type Order = {
  _id?: Maybe<Scalars['ID']>;
  order_UID?: Maybe<Scalars['String']>;
  order_status?: Maybe<OrderStatus>;
  order_date?: Maybe<Scalars['String']>;
  order_time?: Maybe<Scalars['String']>;
  order_validation_signature?: Maybe<Scalars['String']>;
  order_created_by?: Maybe<OrderCreatedBy>;
  order_created_at?: Maybe<Scalars['String']>;
  order_last_edited_by?: Maybe<Scalars['String']>;
  order_last_edited_at?: Maybe<Scalars['String']>;
  order_parcels?: Maybe<Array<Maybe<Parcel>>>;
  order_job?: Maybe<Job>;
  order_receiver?: Maybe<Receiver>;
  order_runsheet?: Maybe<Runsheet>;
  order_client_UID?: Maybe<Scalars['ID']>;
  order_client?: Maybe<Client>;
  order_user_UID?: Maybe<Scalars['ID']>;
  order_activities?: Maybe<Array<Maybe<Activity>>>;
  size?: Maybe<OrderSize>;
  relay?: Maybe<Hub>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isThroughRelay?: Maybe<Scalars['Boolean']>;
  isRelayActionOpened?: Maybe<Scalars['Boolean']>;
  expirationDateOnceAtHub?: Maybe<Scalars['String']>;
  droppedAtWareHouse?: Maybe<Scalars['Boolean']>;
  service?: Maybe<PapsService>;
  deliveryAddress?: Maybe<Address>;
  isFromAPI?: Maybe<Scalars['Boolean']>;
};

export type OrderBadgeInput = {
  key: Scalars['String'];
  value: Array<Maybe<OrderStatus>>;
};

export type OrderBadgesByStatusQueries = {
  groupStatus: Array<Maybe<OrderBadgeInput>>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  hub?: Maybe<Scalars['String']>;
};

export type OrderCreatedBy = {
  user_id?: Maybe<Scalars['ID']>;
  source?: Maybe<Source>;
};

/** ADDJOB INPUT */
export type OrderCreationInput = {
  order_UID?: Maybe<Scalars['String']>;
  relay?: Maybe<Scalars['String']>;
  receiver: ReceiverCreationInput;
  parcels: Array<ParcelCreationInput>;
};

/** ADDJOB RESPONSE */
export type OrderCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Order>;
};

export enum OrderSize {
  S = 'S',
  M = 'M',
  L = 'L',
  Xl = 'XL',
  D = 'D',
  Xxl = 'XXL'
}

export enum OrderStatus {
  Lost = 'LOST',
  ToPick = 'TO_PICK',
  Picked = 'PICKED',
  ToReceive = 'TO_RECEIVE',
  NotCollected = 'NOT_COLLECTED',
  AwaitingDelivery = 'AWAITING_DELIVERY',
  PartiallyReceived = 'PARTIALLY_RECEIVED',
  NotReceived = 'NOT_RECEIVED',
  ToBeAssigned = 'TO_BE_ASSIGNED',
  HrToBeAssigned = 'HR_TO_BE_ASSIGNED',
  ToHandOver = 'TO_HAND_OVER',
  RToHandOver = 'R_TO_HAND_OVER',
  HrToHandOver = 'HR_TO_HAND_OVER',
  Delivered = 'DELIVERED',
  OnDelivery = 'ON_DELIVERY',
  PartiallyCompleted = 'PARTIALLY_COMPLETED',
  Completed = 'COMPLETED',
  ToReturn = 'TO_RETURN',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Successful = 'SUCCESSFUL',
  Returned = 'RETURNED',
  MoneyToCollect = 'MONEY_TO_COLLECT',
  HandedOver = 'HANDED_OVER',
  RHandedOver = 'R_HANDED_OVER',
  HrHandedOver = 'HR_HANDED_OVER',
  ToPrepare = 'TO_PREPARE',
  InRelay = 'IN_RELAY',
  CancelledAtRelay = 'CANCELLED_AT_RELAY',
  FailedAtRelay = 'FAILED_AT_RELAY',
  DeliveredAtRelay = 'DELIVERED_AT_RELAY',
  HrToReturn = 'HR_TO_RETURN',
  OutOfStock = 'OUT_OF_STOCK',
  Dropped = 'DROPPED',
  HrDropped = 'HR_DROPPED',
  HrOnReturn = 'HR_ON_RETURN',
  PickFailed = 'PICK_FAILED',
  RToBeAssigned = 'R_TO_BE_ASSIGNED',
  OnReturn = 'ON_RETURN',
  SentBack = 'SENT_BACK',
  NotReturned = 'NOT_RETURNED'
}

export type OrderUpdateInput = {
  order_date?: Maybe<Scalars['String']>;
  order_time?: Maybe<Scalars['String']>;
  receiver: ReceiverUpdatePickupInput;
  parcels?: Maybe<Array<ParcelUpdateBodyInput>>;
};

export type OrderUpdateQueryInput = {
  id: Scalars['ID'];
  order?: Maybe<OrderUpdateInput>;
  receiver?: Maybe<ReceiverUpdateInput>;
  changeReceiver?: Maybe<ReceiverUpdateInput>;
  newParcels?: Maybe<Array<Maybe<ParcelUpdateBodyInput>>>;
  parcelsToUpdate?: Maybe<Array<Maybe<ParcelToUpdateInput>>>;
  parcelsIdsToDelete?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type OrdersByClientFetchParams = {
  clientID: Scalars['ID'];
};

/** ALLORDERSBYCLIENT INPUT */
export type OrdersByClientFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<OrderStatus>>>;
  page?: Maybe<Scalars['Int']>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

/** ALLORDERS INPUT */
export type OrdersFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<OrderStatus>>>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
  hub?: Maybe<Scalars['String']>;
};

/** ALLORDERS RESPONSE */
export type OrdersFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Order>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export enum Payment_Frequency {
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Daily = 'DAILY'
}

export enum Payment_Mode {
  MobileMoney = 'MOBILE_MONEY',
  Cash = 'CASH',
  Course = 'COURSE',
  BankTransfer = 'BANK_TRANSFER',
  Check = 'CHECK'
}

export enum Profile_User {
  Admin = 'ADMIN',
  Simple = 'SIMPLE'
}

export enum PType {
  Driver = 'Driver',
  Conveyor = 'Conveyor'
}

export type PaginatedCourse = {
  countTotal?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<Course>>>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PaginatedIndividualsClients = {
  countTotal?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<Individualsclient>>>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PaginatedRefAddress = {
  countTotal?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<RefAddress>>>;
  totalPages?: Maybe<Scalars['Int']>;
};

export enum PapsService {
  Nt = 'NT',
  Tr = 'TR',
  Mad = 'MAD',
  Msg = 'MSG',
  Course = 'Course'
}

export type PapserType = {
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  licenceType?: Maybe<Array<Maybe<License_Type>>>;
  type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  partnerCompanyName?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
};

export type ParamsApproveOrDeclineRequest = {
  clientId: Scalars['String'];
};

export type Parcel = {
  _id?: Maybe<Scalars['ID']>;
  parcel_UID?: Maybe<Scalars['String']>;
  parcel_description?: Maybe<Scalars['String']>;
  parcel_size?: Maybe<ParcelSize>;
  parcel_value?: Maybe<Scalars['Int']>;
  parcel_amount_to_collect?: Maybe<Scalars['Int']>;
  parcel_client_reference?: Maybe<Scalars['String']>;
  parcel_status?: Maybe<ParcelStatus>;
  parcel_cash_status?: Maybe<ParcelCashStatus>;
  parcel_return?: Maybe<Scalars['Boolean']>;
  parcel_return_raison?: Maybe<Scalars['String']>;
  parcel_attempts?: Maybe<Scalars['Int']>;
  parcel_attempts_real?: Maybe<Scalars['Int']>;
  parcel_delivery_date?: Maybe<Scalars['String']>;
  parcel_delivery_slot_start?: Maybe<Scalars['String']>;
  parcel_delivery_slot_end?: Maybe<Scalars['String']>;
  parcel_additional_info?: Maybe<Scalars['String']>;
  parcel_cash_collection_date?: Maybe<Scalars['String']>;
  parcel_client_UID?: Maybe<Scalars['ID']>;
  parcel_client?: Maybe<Client>;
  parcel_reason?: Maybe<Reason>;
  reason_UID?: Maybe<Scalars['String']>;
  parcel_remittance_due_date?: Maybe<Scalars['String']>;
  parcel_remittance_created_at?: Maybe<Scalars['String']>;
  parcel_remittance?: Maybe<Remittance>;
  parcel_user_UID?: Maybe<Scalars['ID']>;
  parcel_created_by?: Maybe<ParcelCreatedBy>;
  parcel_created_at?: Maybe<Scalars['String']>;
  parcel_last_edited_by?: Maybe<Scalars['String']>;
  parcel_last_edited_at?: Maybe<Scalars['String']>;
  parcel_order?: Maybe<Order>;
  parcel_runsheet?: Maybe<Runsheet>;
  parcel_activities?: Maybe<Array<Maybe<Activity>>>;
  parcel_subtasks?: Maybe<Array<Maybe<SubTask>>>;
  amountCollected?: Maybe<Scalars['Int']>;
  countries?: Maybe<Array<Maybe<Country>>>;
  tag?: Maybe<ParcelTag>;
  proof_of_delivery?: Maybe<Scalars['String']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  relay?: Maybe<Hub>;
  isThroughRelay?: Maybe<Scalars['Boolean']>;
  isRelayActionOpened?: Maybe<Scalars['Boolean']>;
  expirationDateOnceAtHub?: Maybe<Scalars['String']>;
  pickupAddress?: Maybe<Address>;
  pickupMoreInfo?: Maybe<PickupMoreInfoType>;
  droppedAtWareHouse?: Maybe<Scalars['Boolean']>;
  service?: Maybe<PapsService>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isFromAPI?: Maybe<Scalars['Boolean']>;
};

export type ParcelBadgeInput = {
  key: Scalars['String'];
  value: Array<Maybe<ParcelStatus>>;
};

export type ParcelBadgesByStatusQueries = {
  groupStatus: Array<Maybe<ParcelBadgeInput>>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  hub?: Maybe<Scalars['String']>;
};

export enum ParcelCashStatus {
  No = 'NO',
  Yes = 'YES',
  InHouse = 'IN_HOUSE',
  OnGoing = 'ON_GOING',
  Confirmed = 'CONFIRMED'
}

export type ParcelCountByHubId = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type ParcelCreatedBy = {
  user_id?: Maybe<Scalars['ID']>;
  source?: Maybe<Source>;
};

export type ParcelCreationInput = {
  parcel_UID?: Maybe<Scalars['String']>;
  parcel_description: Scalars['String'];
  parcel_size: ParcelSize;
  parcel_value: Scalars['Int'];
  parcel_amount_to_collect: Scalars['Int'];
  parcel_client_reference?: Maybe<Scalars['String']>;
  amountCollected?: Maybe<Scalars['Int']>;
  parcel_additional_info?: Maybe<Scalars['String']>;
  tag?: Maybe<ParcelTag>;
  pickupAddress?: Maybe<AddressCreationInput>;
  pickupMoreInfo?: Maybe<PickupMoreInfoInput>;
};

/** DELETEPARCEL RESPONSE */
export type ParcelDeleteResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type ParcelExportFilter = {
  parcelStatus?: Maybe<Array<Maybe<ParcelStatus>>>;
  parcelSize?: Maybe<Array<Maybe<ParcelSize>>>;
  clientId: Scalars['ID'];
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  service?: Maybe<Array<Maybe<PapsService>>>;
};

export type ParcelFilter = {
  statusParcel?: Maybe<Scalars['String']>;
  client?: Maybe<Scalars['ID']>;
  date_start?: Maybe<Scalars['String']>;
  date_end?: Maybe<Scalars['String']>;
  dateType?: Maybe<FilterByDateType>;
  slots?: Maybe<Scalars['String']>;
};

export type ParcelNotReceivedInput = {
  parcelID: Scalars['ID'];
};

export type ParcelNotReceivedResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Parcel>;
};

export enum ParcelRecapStatus {
  AllCashCollected = 'ALL_CASH_COLLECTED',
  CollectedByPapser = 'COLLECTED_BY_PAPSER',
  CollectedByCashier = 'COLLECTED_BY_CASHIER',
  YetToCollect = 'YET_TO_COLLECT',
  FailedToCollect = 'FAILED_TO_COLLECT',
  RemittanceInHouse = 'REMITTANCE_IN_HOUSE',
  RemittanceOnGoing = 'REMITTANCE_ON_GOING',
  RemittanceConfirmed = 'REMITTANCE_CONFIRMED',
  NotReceived = 'NOT_RECEIVED'
}

/** RECEIVINGPARCELS RESPONSE */
export type ParcelReceivingDataResponse = {
  job?: Maybe<Array<Maybe<Job>>>;
  orders_received?: Maybe<Array<Maybe<Order>>>;
  orders_partially_received?: Maybe<Array<Maybe<Order>>>;
  parcels_received?: Maybe<Array<Maybe<Parcel>>>;
  parcels_not_received?: Maybe<Array<Maybe<Parcel>>>;
};

export type ParcelReceivingInput = {
  items: Array<ParcelReceivingItemsInput>;
};

/** RECEIVINGPARCELS INPUT */
export type ParcelReceivingItemsInput = {
  orderID: Scalars['ID'];
  parcelsID: Array<Scalars['ID']>;
  orderSize?: Maybe<OrderSize>;
};

export type ParcelReceivingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<ParcelReceivingDataResponse>;
};

export enum ParcelSize {
  S = 'S',
  M = 'M',
  L = 'L',
  Xl = 'XL',
  Xxl = 'XXL',
  D = 'D'
}

export enum ParcelStatus {
  ToPick = 'TO_PICK',
  Picked = 'PICKED',
  PickFailed = 'PICK_FAILED',
  AwaitingDelivery = 'AWAITING_DELIVERY',
  ToHandOver = 'TO_HAND_OVER',
  RToHandOver = 'R_TO_HAND_OVER',
  HrToHandOver = 'HR_TO_HAND_OVER',
  ToBeAssigned = 'TO_BE_ASSIGNED',
  RToBeAssigned = 'R_TO_BE_ASSIGNED',
  HrToBeAssigned = 'HR_TO_BE_ASSIGNED',
  Received = 'RECEIVED',
  Dispatched = 'DISPATCHED',
  OnDelivery = 'ON_DELIVERY',
  Successful = 'SUCCESSFUL',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  ToReceive = 'TO_RECEIVE',
  NotReceived = 'NOT_RECEIVED',
  NotCollected = 'NOT_COLLECTED',
  Archived = 'ARCHIVED',
  ToReturn = 'TO_RETURN',
  OnReturn = 'ON_RETURN',
  Returned = 'RETURNED',
  NotReturned = 'NOT_RETURNED',
  Delivered = 'DELIVERED',
  SentBack = 'SENT_BACK',
  MoneyToCollect = 'MONEY_TO_COLLECT',
  HandedOver = 'HANDED_OVER',
  RHandedOver = 'R_HANDED_OVER',
  HrHandedOver = 'HR_HANDED_OVER',
  Lost = 'LOST',
  ToPrepare = 'TO_PREPARE',
  InRelay = 'IN_RELAY',
  CancelledAtRelay = 'CANCELLED_AT_RELAY',
  FailedAtRelay = 'FAILED_AT_RELAY',
  DeliveredAtRelay = 'DELIVERED_AT_RELAY',
  HrToReturn = 'HR_TO_RETURN',
  OutOfStock = 'OUT_OF_STOCK',
  Dropped = 'DROPPED',
  HrDropped = 'HR_DROPPED',
  HrOnReturn = 'HR_ON_RETURN'
}

/** UPDATE PARCEL STATUS INPUT */
export type ParcelStatusUpdatingInput = {
  id: Scalars['ID'];
  status: ValidUpdatingStatus;
  reasonId: Scalars['String'];
};

export enum ParcelTag {
  Lost = 'LOST',
  Damaged = 'DAMAGED',
  Missing = 'MISSING',
  WrongArticle = 'WRONG_ARTICLE',
  NonConform = 'NON_CONFORM',
  Default = 'DEFAULT',
  ErrorPaps = 'ERROR_PAPS',
  ErrorClient = 'ERROR_CLIENT'
}

/** UPDATE PARCEL TAG INPUT */
export type ParcelTagUpdatingInput = {
  id: Scalars['ID'];
  tag: ParcelTag;
};

export type ParcelTagUpdatingInputArg = {
  input: ParcelTagUpdatingInput;
};

export type ParcelToUpdateInput = {
  id: Scalars['ID'];
  parcel: ParcelUpdateBodyInput;
};

/** PARCEL MODULE MUTATIONS */
export type ParcelUpdateBodyInput = {
  parcel_UID?: Maybe<Scalars['String']>;
  parcel_description: Scalars['String'];
  parcel_size: ParcelSize;
  parcel_value: Scalars['Int'];
  parcel_amount_to_collect: Scalars['Int'];
  parcel_client_reference?: Maybe<Scalars['String']>;
  amountCollected?: Maybe<Scalars['Int']>;
  parcel_additional_info?: Maybe<Scalars['String']>;
  tag?: Maybe<ParcelTag>;
};

export type ParcelUpdateDeliveryDateInput = {
  parcels?: Maybe<Array<Maybe<Scalars['ID']>>>;
  date?: Maybe<Scalars['String']>;
  slot_start?: Maybe<Scalars['String']>;
  slot_end?: Maybe<Scalars['String']>;
};

export type ParcelUpdateDeliveryDateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type ParcelUpdateInput = {
  parcelID: Scalars['ID'];
  parcel: ParcelUpdateBodyInput;
};

/** UPDATEPARCEL RESPONSE */
export type ParcelUpdatingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Parcel>;
};

export type ParcelsByClientFetchParams = {
  clientID: Scalars['ID'];
};

/** ALLPARCELSBYCLIENT INPUT */
export type ParcelsByClientFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<ParcelStatus>>>;
  page?: Maybe<Scalars['Int']>;
  lang?: Maybe<Lang>;
  search?: Maybe<Scalars['String']>;
};

/** RECAPCASHPARCELS INPUT */
export type ParcelsCashRecapFetchQueries = {
  date_type?: Maybe<FilterByDateType>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['ID']>;
  receiver_id?: Maybe<Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  status?: Maybe<Array<Maybe<ParcelRecapStatus>>>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ParcelsCashRecapFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ParcelsCashRecapResponse>>>;
};

export type ParcelsCashRecapResponse = {
  status?: Maybe<ParcelRecapStatus>;
  count?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Int']>;
  parcels?: Maybe<Array<Maybe<Parcel>>>;
};

export type ParcelsExport = {
  parcel_UID?: Maybe<Scalars['String']>;
  receiver_fullname?: Maybe<Scalars['String']>;
  receiver_phone_number?: Maybe<Scalars['String']>;
  creation_date?: Maybe<Scalars['String']>;
  delivery_date?: Maybe<Scalars['String']>;
  status?: Maybe<ParcelStatus>;
  amount_to_collect?: Maybe<Scalars['Int']>;
  attemps?: Maybe<Scalars['Int']>;
  size?: Maybe<ParcelSize>;
  tag?: Maybe<ParcelTag>;
  updated_date?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  service?: Maybe<PapsService>;
};

export type ParcelsExportOpsResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['String']>;
};

export type ParcelsExportResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<ParcelsItems>;
};

/** ALLPARCELS INPUT */
export type ParcelsFetchQueries = {
  client_id?: Maybe<Scalars['ID']>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  status?: Maybe<Array<Maybe<ParcelStatus>>>;
  tags?: Maybe<Array<Maybe<ParcelTag>>>;
  page?: Maybe<Scalars['Int']>;
  lang?: Maybe<Lang>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
  filterByDateType?: Maybe<FilterByDateType>;
  slot_end?: Maybe<Scalars['String']>;
  slot_start?: Maybe<Scalars['String']>;
  hub?: Maybe<Scalars['String']>;
  service?: Maybe<Array<Maybe<ERequestType>>>;
};

/** ALLPARCELS RESPONSE */
export type ParcelsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Parcel>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type ParcelsItems = {
  parcelsCount?: Maybe<Scalars['Int']>;
  parcels?: Maybe<Array<Maybe<ParcelsExport>>>;
};

export type ParcelsReceptionAtRelayPointResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataParcelsReceptionAtRelayPointResponse>;
};

export type ParnerExistResponse = {
  existPartner: Scalars['Boolean'];
};

export type Partner = {
  _id?: Maybe<Scalars['ID']>;
  partner_UID?: Maybe<Scalars['String']>;
  partner_company_name?: Maybe<Scalars['String']>;
  partner_phone_number?: Maybe<Scalars['String']>;
  partner_email?: Maybe<Scalars['String']>;
  partner_address?: Maybe<Address>;
  partner_trade_register?: Maybe<Scalars['String']>;
  partner_ninea_url?: Maybe<Scalars['String']>;
  partner_ninea_number?: Maybe<Scalars['String']>;
  partner_contact_firstname?: Maybe<Scalars['String']>;
  partner_contact_lastname?: Maybe<Scalars['String']>;
  partner_contact_phone_number?: Maybe<Scalars['String']>;
  partner_contact_email?: Maybe<Scalars['String']>;
  partner_contract_is_signed?: Maybe<Scalars['Boolean']>;
  partner_contract_start_date?: Maybe<Scalars['String']>;
  partner_contract_end_date?: Maybe<Scalars['String']>;
  partner_drivers?: Maybe<Array<Maybe<Driver>>>;
  partner_vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  partner_created_at?: Maybe<Scalars['String']>;
  partner_created_by?: Maybe<Created_By>;
  partner_updated_by?: Maybe<Created_By>;
};

export type PartnerCheckInput = {
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
};

/** ADDPARTNER INPUT */
export type PartnerCreationInput = {
  partner: PartnerItemsCreation;
};

/** ADDPARTNER RESPONSE */
export type PartnerCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataPartnerCreatedResponse>;
};

export type PartnerDeleteInput = {
  id: Scalars['ID'];
};

export type PartnerDeleteResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataPartnerDeletedResponse>;
};

export type PartnerExistCheckResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<ParnerExistResponse>;
};

export type PartnerItemsCreation = {
  partner_company_name: Scalars['String'];
  partner_phone_number: Scalars['String'];
  partner_email?: Maybe<Scalars['String']>;
  partner_address?: Maybe<AddressCreationInput>;
  partner_trade_register?: Maybe<Scalars['String']>;
  partner_ninea_url?: Maybe<Scalars['String']>;
  partner_ninea_number?: Maybe<Scalars['String']>;
  partner_contact_firstname: Scalars['String'];
  partner_contact_lastname: Scalars['String'];
  partner_contact_phone_number: Scalars['String'];
  partner_contact_email: Scalars['String'];
  partner_contract_is_signed: Scalars['Boolean'];
  partner_contract_start_date?: Maybe<Scalars['String']>;
  partner_contract_end_date?: Maybe<Scalars['String']>;
};

export type PartnerItemsUpdate = {
  partner_company_name?: Maybe<Scalars['String']>;
  partner_phone_number?: Maybe<Scalars['String']>;
  partner_email?: Maybe<Scalars['String']>;
  partner_address?: Maybe<AddressCreationInput>;
  partner_trade_register?: Maybe<Scalars['String']>;
  partner_ninea_url?: Maybe<Scalars['String']>;
  partner_ninea_number?: Maybe<Scalars['String']>;
  partner_contact_firstname?: Maybe<Scalars['String']>;
  partner_contact_lastname?: Maybe<Scalars['String']>;
  partner_contact_phone_number?: Maybe<Scalars['String']>;
  partner_contact_email?: Maybe<Scalars['String']>;
  partner_contract_is_signed?: Maybe<Scalars['Boolean']>;
  partner_contract_end_date?: Maybe<Scalars['String']>;
};

/** UPDATEPARTNER INPUT */
export type PartnerUpdateInput = {
  id: Scalars['ID'];
  partner: PartnerItemsUpdate;
};

/** UPDATEPARTNER RESPONSE */
export type PartnerUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataPartnerUpdatedResponse>;
};

export type PartnersFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
};

/** ALLPARTNERS RESPONSE */
export type PartnersFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataPartnersResponse>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

/** Client payment frequency! */
export enum PaymentFrequency {
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Daily = 'Daily'
}

export type PaymentMethod = {
  _id?: Maybe<Scalars['ID']>;
  uid?: Maybe<Scalars['String']>;
  libelle?: Maybe<Scalars['String']>;
  isDriver?: Maybe<Scalars['Boolean']>;
  isConveyor?: Maybe<Scalars['Boolean']>;
  countries?: Maybe<Array<Maybe<Country>>>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<Created_By>;
  editedBy?: Maybe<Created_By>;
};

export type PaymentMethodCreationInput = {
  paymentMethod: PaymentMethodItemsCreation;
};

export type PaymentMethodCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<PaymentMethod>;
};

export type PaymentMethodFetchQueries = {
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PaymentMethodFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<PaymentMethod>>>;
};

export type PaymentMethodItemsCreation = {
  libelle: Scalars['String'];
  isDriver: Scalars['Boolean'];
  isConveyor: Scalars['Boolean'];
  countries: Array<CountryInput>;
};

/** Client payment mode! */
export enum PaymentMode {
  Pending = 'Pending',
  Approved = 'Approved',
  Course = 'Course',
  BankTransfer = 'BankTransfer',
  Check = 'Check'
}

export type Permission = {
  _id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  created_by?: Maybe<RoleModuleCreatedOrUpdatedBy>;
  created_at?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<RoleModuleCreatedOrUpdatedBy>;
  roles?: Maybe<Array<Maybe<Role>>>;
  module?: Maybe<Module>;
  type?: Maybe<PermissionType>;
};

export type PermissionCreationInput = {
  name: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type: PermissionType;
};

export type PermissionInput = {
  label?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<PermissionType>;
};

export enum PermissionType {
  Warehouse = 'WAREHOUSE',
  Relay = 'RELAY'
}

export type PermissionsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Permission>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type PermissionsStaffFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
  type?: Maybe<PermissionType>;
};

export type PickupDelivery = {
  Pickup?: Maybe<Actor>;
  Delivery?: Maybe<Actor>;
};

export type PickupMoreInfoInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PickupMoreInfoType = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PickupTaskUpdateInput = {
  id: Scalars['ID'];
  execution?: Maybe<ExecutionTimeInput>;
  address?: Maybe<AddressCreationInput>;
};

/** UPDATEPICKUPTASK RESPONSE */
export type PickupTaskUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Task>;
};

/** PICKUPUPDATEVALIDATION INPUT */
export type PickupUpdateValidationParams = {
  subtaskId: Scalars['ID'];
};

export type Product = {
  _id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['ID']>;
  client?: Maybe<Client>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  category?: Maybe<Category>;
  reference?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  weight?: Maybe<Weight>;
  volume?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<CreatedBy>;
  updatedBy?: Maybe<CreatedBy>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ProductByCodeFetchParams = {
  code: Scalars['String'];
};

export type ProductByCodeFetchResponse = {
  statusCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Product>;
};

export type ProductCreationInput = {
  clientId: Scalars['ID'];
  product: ProductDataCreationInput;
};

export type ProductCreationResponse = {
  statusCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Product>;
};

export type ProductDataCreationInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  category: Scalars['String'];
  reference?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  weight: Weight;
  volume?: Maybe<Scalars['Int']>;
  value: Scalars['Int'];
};

export type ProductDataUpdateInput = {
  description?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  weight?: Maybe<Weight>;
  volume?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type ProductDeleteInput = {
  code: Scalars['String'];
};

export type ProductDeleteResponse = {
  statusCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type ProductTemplateStop = {
  _id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  category?: Maybe<CategoryProductTemplateStop>;
  reference?: Maybe<Scalars['String']>;
  refPickupDelivery?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  weight?: Maybe<Weight>;
  volume?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
  pickup?: Maybe<Scalars['Int']>;
  parcelId?: Maybe<Scalars['String']>;
  parcelUid?: Maybe<Scalars['String']>;
};

export type ProductTemplateStopInput = {
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  refPickupDelivery?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  weight?: Maybe<Weight>;
  volume?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
  pickup?: Maybe<Scalars['Int']>;
  _id?: Maybe<Scalars['ID']>;
  category?: Maybe<CategoryProductTemplateStopInput>;
};

export type ProductUpdateInput = {
  code: Scalars['String'];
  product: ProductDataUpdateInput;
};

export type ProductUpdateResponse = {
  statusCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Product>;
};

export type ProductsFetchDataResponse = {
  products?: Maybe<Array<Maybe<Product>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type ProductsFetchQueries = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  clientId: Scalars['ID'];
};

export type ProductsFetchResponse = {
  statusCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<ProductsFetchDataResponse>;
};

export type ProductsUploadInput = {
  clientId: Scalars['ID'];
  products?: Maybe<Array<ProductDataCreationInput>>;
};

export type ProductsUploadResponse = {
  statusCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Product>>>;
};

export type Program = {
  _id: Scalars['ID'];
  iconUrl: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  duration: Scalars['Float'];
  isActive?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['String']>;
};

export type ProgramByIdParams = {
  programId: Scalars['ID'];
};

export type ProgramFetchResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Program>;
};

export type ProgramsFetchQueries = {
  page?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};

export type Query = {
  course: Course;
  courses?: Maybe<PaginatedCourse>;
  courseRecap: CourseRecap;
  courseTasksToExport: Array<Course>;
  badges: CourseBadge;
  findAction: Action;
  actionsByIds: Array<Action>;
  individualClient: Individualsclient;
  individualClients?: Maybe<PaginatedIndividualsClients>;
  drivers: Array<Driver>;
  driver: Driver;
  individualClientRefAddress: RefAddress;
  individualClientRefAddresses?: Maybe<PaginatedRefAddress>;
  getAllOptionsContract?: Maybe<OptionsContractFetchResponse>;
  getOptionsContractById?: Maybe<OptionsContractByIdFetchResponse>;
  currentClient?: Maybe<CurrentClientResponse>;
  currentUserCompany?: Maybe<CurrentCompanyUserAccountResponse>;
  resendActivation?: Maybe<ResendActivationResponse>;
  getAccountsByClientId?: Maybe<GetAccountsByClientIdResponse>;
  allJobs?: Maybe<JobsFetchResponse>;
  jobById?: Maybe<OneJobFetchResponse>;
  allJobsByClient?: Maybe<JobsFetchResponse>;
  jobByIdByClient?: Maybe<OneJobFetchResponse>;
  pickupUpdateValidation?: Maybe<OneJobFetchResponse>;
  jobByClientFromSubtask?: Maybe<OneJobFetchResponse>;
  allOrders?: Maybe<OrdersFetchResponse>;
  orderById?: Maybe<OneOrderFetchResponse>;
  allOrdersByClient?: Maybe<OrdersFetchResponse>;
  orderByIdByClient?: Maybe<OneOrderFetchResponse>;
  orderBadgesByStatus?: Maybe<BadgesByStatusResponse>;
  getOrderToPickAtRelay?: Maybe<OneOrderFetchResponse>;
  allReceivers?: Maybe<ReceiversFetchResponse>;
  receiverById?: Maybe<OneReceiverFetchResponse>;
  allReceiversByClient?: Maybe<ReceiversFetchResponse>;
  receiverByIdByClient?: Maybe<OneReceiverFetchResponse>;
  allParcels?: Maybe<ParcelsFetchResponse>;
  allArchivedParcels?: Maybe<ParcelsFetchResponse>;
  parcelById?: Maybe<OneParcelWithCodeFetchResponse>;
  allParcelsByClient?: Maybe<ParcelsFetchResponse>;
  parcelByIdByClient?: Maybe<OneParcelFetchResponse>;
  parcelBadgesByStatus?: Maybe<BadgesByStatusResponse>;
  recapParcels?: Maybe<RecapParcelsFetchResponse>;
  opsRecapParcels?: Maybe<RecapParcelsFetchResponse>;
  checkParcelStatus?: Maybe<OneParcelFetchResponse>;
  parcelsExport: ParcelsExportResponse;
  parcelsExportOps: ParcelsExportOpsResponse;
  getOtherParcelsToReceiveAtRelay?: Maybe<GetOtherParcelsToReceiveAtRelayResponse>;
  getParcelCountByHubId?: Maybe<GetParcelCountByHubIdResponse>;
  allTasks?: Maybe<TasksFetchResponse>;
  getCashRecapParcels?: Maybe<ParcelsCashRecapFetchResponse>;
  parcelByIds?: Maybe<ManyParcelFetchResponse>;
  allRunsheets?: Maybe<RunsheetsFetchResponse>;
  runsheetById?: Maybe<OneRunsheetFetchResponse>;
  runsheetBadgesByStatus?: Maybe<BadgesByStatusResponse>;
  cashCollectionRecap?: Maybe<CashCollectionRecapResponse>;
  allReasons?: Maybe<ReasonsFetchResponse>;
  allReasonGroups?: Maybe<ReasonGroupsFetchResponse>;
  taskById?: Maybe<OneTaskFetchResponse>;
  tasksByPapser?: Maybe<TasksFetchResponse>;
  taskBadgesByStatus?: Maybe<BadgesByStatusResponse>;
  tasksToExport?: Maybe<TaskToExportResponse>;
  taskToExportClient?: Maybe<TaskToExportClientResponse>;
  nextPapserTaskTransferRequest?: Maybe<TaskTransferRequestResponse>;
  fetchTaskByMissions?: Maybe<TaskByMissionsResponse>;
  allSubTasks?: Maybe<SubTasksFetchResponse>;
  subTaskById?: Maybe<OneSubTaskFetchResponse>;
  allSubTasksByClient?: Maybe<SubTasksFetchResponse>;
  subTaskByClient?: Maybe<OneSubTaskFetchResponse>;
  allSubTasksByPapser?: Maybe<SubTasksFetchResponse>;
  recapByPapser?: Maybe<RecapByPapserResponse>;
  detailsRecapByTypeAndPapser?: Maybe<DetailsRecapByPapserResponse>;
  subtaskBadgesByStatus?: Maybe<BadgesByStatusResponse>;
  subtasksByTaskId?: Maybe<SubtasksByTaskResponse>;
  companyUserById?: Maybe<CompanyUserByIdFetchResponse>;
  companyUsersByClient?: Maybe<CompanyUserByClientFetchResponse>;
  allClients?: Maybe<ClientsFetchResponse>;
  clientById?: Maybe<OneClientFetchResponse>;
  deleteClient?: Maybe<ClientDeleteResponse>;
  getClientsByCompanyName?: Maybe<ClientsFetchResponse>;
  getBadgeStatus?: Maybe<GetBadgeStatusResponse>;
  allClientRefAddress?: Maybe<ClientRefAddressesResponse>;
  getClientRefAddressById?: Maybe<ClientRefAddressResponse>;
  allClientRefAddressByClientId?: Maybe<ClientRefAddressesResponse>;
  allConveyors?: Maybe<ConveyorsFetchResponse>;
  conveyorById?: Maybe<OneConveyorFetchResponse>;
  allConveyorsTrained?: Maybe<ConveyorsFetchResponse>;
  getConveyorHistory?: Maybe<Array<Maybe<Activity>>>;
  allDrivers?: Maybe<DriversFetchResponse>;
  driverById?: Maybe<OneDriverFetchResponse>;
  driversByTypeOfVehicleToPartner?: Maybe<DriversFetchResponse>;
  driverAndPartnerFetch?: Maybe<DriverAndPartnerFetchResponse>;
  isDriverAlreadyExist?: Maybe<DriverExistCheckResponse>;
  getCodeOtpDriver?: Maybe<DriverGetCodeResponse>;
  allVehicles?: Maybe<VehiclesFetchResponse>;
  vehicleById?: Maybe<OneVehicleFetchResponse>;
  isVehicleAlreadyExist?: Maybe<VehicleExistCheckResponse>;
  allPartners?: Maybe<PartnersFetchResponse>;
  partnerById?: Maybe<OnePartnerFetchResponse>;
  isPartnerAlreadyExist?: Maybe<PartnerExistCheckResponse>;
  allBillingAccounts?: Maybe<BillingAccountsFetchResponse>;
  expoTokenByDriverId?: Maybe<ExpoTokenFetchResponse>;
  allUsersStaff?: Maybe<UserStaffFetchResponse>;
  userStaffById?: Maybe<OneUserStaffFetchResponse>;
  usersAdminByHub?: Maybe<UserStaffFetchResponse>;
  currentOpsUser?: Maybe<CurrentOpsUserResponse>;
  allModules?: Maybe<ModulesFetchResponse>;
  allRoles?: Maybe<RolesFetchResponse>;
  allPermissions?: Maybe<PermissionsFetchResponse>;
  moduleById?: Maybe<OneModuleFetchResponse>;
  roleById?: Maybe<OneRoleFetchResponse>;
  allEvents: EventReturn;
  allTemplates: TemplateFetchResponse;
  templateById: TemplateReturn;
  notificationByViewerId: NotificationFetchResponse;
  countNotificationsByPlatform: NotificationBadgeResponse;
  allCategories?: Maybe<CategoriesFetchResponse>;
  categorieByCode?: Maybe<CategorieFetchResponse>;
  allProducts?: Maybe<ProductsFetchResponse>;
  productByCode?: Maybe<ProductByCodeFetchResponse>;
  allRequests?: Maybe<RequestsFetchResponse>;
  requestById?: Maybe<OneRequestFetchResponse>;
  allRequestsByClient?: Maybe<RequestsFetchResponse>;
  requestBadgesByStatus?: Maybe<BadgesByStatusResponse>;
  requestBadgesByType?: Maybe<BadgesByStatusResponse>;
  taskMissionByParcelUid?: Maybe<TaskByParcelFetchResponse>;
  tasksMissionByIds?: Maybe<TaskByIdsFetchResponse>;
  allMissionFetch?: Maybe<MissionFetchResponse>;
  getAllMissions?: Maybe<MissionFetchResponse>;
  getAllMissionsForRunsheetCreation?: Maybe<MissionFetchResponse>;
  getMissionForRunsheetCreationBadge?: Maybe<BadgesByStatusResponse>;
  fetchMissionBadgeByType?: Maybe<BadgesByStatusResponse>;
  axisBasedOnReccurrence?: Maybe<GetAxisBasedOnReccurrenceResponse>;
  getMissionBasedOnConfig?: Maybe<MissionBasedOnConfigResponse>;
  getConfigs?: Maybe<GetConfigsResponse>;
  getTasksMission?: Maybe<TasksMissionResponse>;
  taskMissionByRunsheet?: Maybe<TaskMissionByRunsheetResponse>;
  computeReccurence?: Maybe<RecurrenceDataResponse>;
  checkTrMissionElligibility?: Maybe<MissionElligibiltyResponse>;
  exportMissions?: Maybe<MissionExportResponse>;
  getDeliverySlots: DataDeliverySlotsReponse;
  allPaymentMethods?: Maybe<PaymentMethodFetchResponse>;
  allGifts?: Maybe<AllGiftsFetchResponse>;
  giftByClient?: Maybe<GiftByClientResponse>;
  detailsAddress?: Maybe<DetailsAddressResponse>;
  allHubs?: Maybe<HubsFetchResponse>;
  hubById?: Maybe<HubFetchResponse>;
  getAllHubsByCity?: Maybe<HubsFetchResponse>;
  allCountries?: Maybe<CountriesFetchResponse>;
  usersByHub?: Maybe<UsersStaffBelongToHubResponse>;
  allRemittances?: Maybe<RemittancesFetchResponse>;
  remittanceById?: Maybe<RemittanceByIdResponse>;
  getRemittancesRecap?: Maybe<RemittancesRecapResponse>;
  getAllServices: GetAllServicesResponse;
  getServicesBadge: GetBadgeResponse;
  getAllPrograms?: Maybe<AllProgramsFetchResponse>;
  getProgramById?: Maybe<ProgramFetchResponse>;
  getAllProgramByClient?: Maybe<AllProgramsFetchResponse>;
  getSubscriptionProgramClient: ProgramFetchResponse;
  getAdvantagesDetailsByProgramForClient: AdvantageResponse;
  getAdvantageByProgram: AdvantageResponse;
  getProgramsBadge: GetBadgeResponse;
  getFidelityClientHistory?: Maybe<Array<Maybe<Activity>>>;
  getAdvantageDemandByClient: GetAdvantageDemandByClientResponse;
  getFidelityDemand?: Maybe<GetFidelityDemandResponse>;
  getBadgeDemand: BadgesByStatusResponse;
};


export type QueryCourseArgs = {
  id: Scalars['ID'];
};


export type QueryCoursesArgs = {
  queries?: Maybe<CourseFetchInput>;
};


export type QueryCourseRecapArgs = {
  queries: RecapQueries;
};


export type QueryCourseTasksToExportArgs = {
  queries?: Maybe<CourseToExportInput>;
};


export type QueryBadgesArgs = {
  queries?: Maybe<BadgeInput>;
};


export type QueryFindActionArgs = {
  id: Scalars['ID'];
};


export type QueryActionsByIdsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryIndividualClientArgs = {
  id: Scalars['ID'];
};


export type QueryIndividualClientsArgs = {
  queries?: Maybe<IndividualsClientsFetchInput>;
};


export type QueryDriverArgs = {
  id: Scalars['Int'];
};


export type QueryIndividualClientRefAddressArgs = {
  id: Scalars['ID'];
};


export type QueryIndividualClientRefAddressesArgs = {
  queries?: Maybe<RefAddressFetchInput>;
};


export type QueryGetAllOptionsContractArgs = {
  input?: Maybe<OptionsContractFetchQueries>;
};


export type QueryGetOptionsContractByIdArgs = {
  input?: Maybe<OptionsContractByIdFetchQueries>;
};


export type QueryResendActivationArgs = {
  userID: Scalars['ID'];
  clientID: Scalars['ID'];
};


export type QueryGetAccountsByClientIdArgs = {
  clientID: Scalars['ID'];
  filter?: Maybe<FilterInput>;
};


export type QueryAllJobsArgs = {
  queries?: Maybe<JobsFetchQueries>;
};


export type QueryJobByIdArgs = {
  params: OneJobFetchParams;
};


export type QueryAllJobsByClientArgs = {
  params: JobsByClientFetchParams;
  queries?: Maybe<JobsByClientFetchQueries>;
};


export type QueryJobByIdByClientArgs = {
  params: OneJobByClientFetchParams;
};


export type QueryPickupUpdateValidationArgs = {
  params: PickupUpdateValidationParams;
};


export type QueryJobByClientFromSubtaskArgs = {
  params: JobByClientFromSubtaskParams;
};


export type QueryAllOrdersArgs = {
  queries?: Maybe<OrdersFetchQueries>;
};


export type QueryOrderByIdArgs = {
  params?: Maybe<OneOrderFetchParams>;
};


export type QueryAllOrdersByClientArgs = {
  params: OrdersByClientFetchParams;
  queries?: Maybe<OrdersByClientFetchQueries>;
};


export type QueryOrderByIdByClientArgs = {
  params?: Maybe<OneOrderByClientFetchParams>;
};


export type QueryOrderBadgesByStatusArgs = {
  queries: OrderBadgesByStatusQueries;
};


export type QueryGetOrderToPickAtRelayArgs = {
  orderUid: Scalars['String'];
};


export type QueryAllReceiversArgs = {
  queries?: Maybe<ReceiversFetchQueries>;
};


export type QueryReceiverByIdArgs = {
  params?: Maybe<OneReceiverFetchParams>;
};


export type QueryAllReceiversByClientArgs = {
  params: ReceiversByClientFetchParams;
  queries?: Maybe<ReceiversByClientFetchQueries>;
};


export type QueryReceiverByIdByClientArgs = {
  params?: Maybe<OneReceiverByClientFetchParams>;
};


export type QueryAllParcelsArgs = {
  queries?: Maybe<ParcelsFetchQueries>;
};


export type QueryAllArchivedParcelsArgs = {
  queries?: Maybe<ParcelsFetchQueries>;
};


export type QueryParcelByIdArgs = {
  params?: Maybe<OneParcelFetchParams>;
  queries?: Maybe<OneParcelFetchQueries>;
};


export type QueryAllParcelsByClientArgs = {
  params: ParcelsByClientFetchParams;
  queries?: Maybe<ParcelsByClientFetchQueries>;
};


export type QueryParcelByIdByClientArgs = {
  params?: Maybe<OneParcelByClientFetchParams>;
  queries?: Maybe<OneParcelByClientFetchQueries>;
};


export type QueryParcelBadgesByStatusArgs = {
  queries: ParcelBadgesByStatusQueries;
};


export type QueryRecapParcelsArgs = {
  params: RecapParcelsFetchParams;
  queries?: Maybe<RecapParcelsFetchQueries>;
};


export type QueryOpsRecapParcelsArgs = {
  queries?: Maybe<RecapParcelsFetchQueries>;
};


export type QueryCheckParcelStatusArgs = {
  queries: CheckParelStatusFetchQueries;
};


export type QueryParcelsExportArgs = {
  filter: ParcelExportFilter;
};


export type QueryParcelsExportOpsArgs = {
  filter: ParcelFilter;
};


export type QueryGetOtherParcelsToReceiveAtRelayArgs = {
  parcelUid?: Maybe<Scalars['String']>;
};


export type QueryGetParcelCountByHubIdArgs = {
  hubId: Scalars['String'];
};


export type QueryAllTasksArgs = {
  queries?: Maybe<TasksFetchQueries>;
};


export type QueryGetCashRecapParcelsArgs = {
  queries?: Maybe<ParcelsCashRecapFetchQueries>;
};


export type QueryParcelByIdsArgs = {
  queries?: Maybe<ManyParcelFetchQueries>;
};


export type QueryAllRunsheetsArgs = {
  queries?: Maybe<RunsheetsFetchQueries>;
};


export type QueryRunsheetByIdArgs = {
  params?: Maybe<OneRunsheetFetchParams>;
  queries?: Maybe<OneRunsheetsFetchQueries>;
};


export type QueryRunsheetBadgesByStatusArgs = {
  queries: RunsheetBadgesByStatusQueries;
};


export type QueryCashCollectionRecapArgs = {
  queries?: Maybe<CashCollectionRecapQueries>;
};


export type QueryAllReasonsArgs = {
  queries?: Maybe<ReasonsFetchQueries>;
};


export type QueryAllReasonGroupsArgs = {
  queries?: Maybe<ReasonGroupsFetchQueries>;
};


export type QueryTaskByIdArgs = {
  params: OneTaskFetchParams;
};


export type QueryTasksByPapserArgs = {
  params: TasksByPapserFetchParams;
  queries?: Maybe<TasksByPapserFetchQueries>;
};


export type QueryTaskBadgesByStatusArgs = {
  queries: TaskBadgesByStatusQueries;
};


export type QueryTasksToExportArgs = {
  queries: TaskToExportInput;
};


export type QueryTaskToExportClientArgs = {
  queries: TaskToExportClientInput;
};


export type QueryNextPapserTaskTransferRequestArgs = {
  params: TasksByPapserFetchParams;
  queries?: Maybe<TransferRequestFetchQueries>;
};


export type QueryFetchTaskByMissionsArgs = {
  input: GetTaskByMissionsInput;
};


export type QueryAllSubTasksArgs = {
  queries?: Maybe<SubTasksFetchQueries>;
};


export type QuerySubTaskByIdArgs = {
  params: OneSubTaskFetchParams;
};


export type QueryAllSubTasksByClientArgs = {
  params: SubTasksByClientFetchParams;
  queries?: Maybe<SubTasksFetchQueries>;
};


export type QuerySubTaskByClientArgs = {
  params?: Maybe<OneSubTaskByClientFetchParams>;
};


export type QueryAllSubTasksByPapserArgs = {
  params: SubTasksByPapserFetchParams;
  queries?: Maybe<SubTasksFetchQueries>;
};


export type QueryRecapByPapserArgs = {
  params: RecapByPapserFetchParams;
  queries?: Maybe<RecapByPapserFetchQueries>;
};


export type QueryDetailsRecapByTypeAndPapserArgs = {
  params: DetailsRecapByPapserFetchParams;
  queries?: Maybe<DetailsRecapByPapserFetchQueries>;
};


export type QuerySubtaskBadgesByStatusArgs = {
  queries: SubTaskBadgesByStatusQueries;
};


export type QuerySubtasksByTaskIdArgs = {
  params: SubtasksByTaskParams;
  queries?: Maybe<SubtasksByTaskQueries>;
};


export type QueryCompanyUserByIdArgs = {
  params?: Maybe<CompanyUserByIdFetchParams>;
};


export type QueryCompanyUsersByClientArgs = {
  params?: Maybe<CompanyUserByClientFetchParams>;
  queries?: Maybe<CompanyUserByClientFetchQueries>;
};


export type QueryAllClientsArgs = {
  queries?: Maybe<ClientsFetchQueries>;
};


export type QueryClientByIdArgs = {
  params: OneClientFetchParams;
};


export type QueryDeleteClientArgs = {
  params: ClientDeleteParams;
};


export type QueryGetClientsByCompanyNameArgs = {
  companyName: Scalars['String'];
};


export type QueryGetBadgeStatusArgs = {
  status: RequestClientStatus;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryGetClientRefAddressByIdArgs = {
  params: ClientAddressRefParams;
};


export type QueryAllClientRefAddressByClientIdArgs = {
  params: ClientIdParams;
};


export type QueryAllConveyorsArgs = {
  queries?: Maybe<ConveyorsFetchQueries>;
};


export type QueryConveyorByIdArgs = {
  params?: Maybe<OneConveyorFetchParams>;
};


export type QueryAllConveyorsTrainedArgs = {
  queries?: Maybe<ConveyorsFetchQueries>;
};


export type QueryGetConveyorHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryAllDriversArgs = {
  queries?: Maybe<DriversFetchQueries>;
};


export type QueryDriverByIdArgs = {
  params?: Maybe<OneDriverFetchParams>;
};


export type QueryDriversByTypeOfVehicleToPartnerArgs = {
  params: DriversBtovtpFecthParams;
  queries: DriversBtovtpFecthQueries;
};


export type QueryIsDriverAlreadyExistArgs = {
  input?: Maybe<DriverCheckInput>;
};


export type QueryGetCodeOtpDriverArgs = {
  queries?: Maybe<DriverGetCodeQueries>;
};


export type QueryAllVehiclesArgs = {
  queries?: Maybe<VehiclesFetchQueries>;
};


export type QueryVehicleByIdArgs = {
  params: OneVehicleFetchParams;
};


export type QueryIsVehicleAlreadyExistArgs = {
  input: VehicleCheckInput;
};


export type QueryAllPartnersArgs = {
  queries?: Maybe<PartnersFetchQueries>;
};


export type QueryPartnerByIdArgs = {
  params?: Maybe<OnePartnerFetchParams>;
};


export type QueryIsPartnerAlreadyExistArgs = {
  input: PartnerCheckInput;
};


export type QueryAllBillingAccountsArgs = {
  queries?: Maybe<BillingAccountQueries>;
};


export type QueryExpoTokenByDriverIdArgs = {
  params?: Maybe<ExpoTokenFetchParams>;
};


export type QueryAllUsersStaffArgs = {
  queries?: Maybe<UserStaffFetchQueries>;
};


export type QueryUserStaffByIdArgs = {
  params: OneUserStaffFetchParams;
};


export type QueryUsersAdminByHubArgs = {
  params?: Maybe<UserStaffAdminHubParams>;
  queries?: Maybe<UserStaffAdminHubQuery>;
};


export type QueryAllRolesArgs = {
  queries?: Maybe<RolesStaffFetchQueries>;
};


export type QueryAllPermissionsArgs = {
  queries?: Maybe<PermissionsStaffFetchQueries>;
};


export type QueryModuleByIdArgs = {
  params?: Maybe<OneModuleFetchParams>;
};


export type QueryRoleByIdArgs = {
  params?: Maybe<OneRoleFetchParams>;
};


export type QueryAllTemplatesArgs = {
  queries?: Maybe<TemplatesFetchQueries>;
};


export type QueryTemplateByIdArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationByViewerIdArgs = {
  viewerID: Scalars['ID'];
  filter?: Maybe<NotificationFilter>;
  platform: EPlatform;
  service?: Maybe<EService>;
};


export type QueryCountNotificationsByPlatformArgs = {
  viewerId: Scalars['ID'];
  viewerPlatform: Scalars['ID'];
  platform: EPlatform;
  service?: Maybe<EService>;
};


export type QueryAllCategoriesArgs = {
  queries?: Maybe<CategoriesFetchQueries>;
};


export type QueryCategorieByCodeArgs = {
  params?: Maybe<CategorieByCodeFetchParams>;
};


export type QueryAllProductsArgs = {
  queries: ProductsFetchQueries;
};


export type QueryProductByCodeArgs = {
  params: ProductByCodeFetchParams;
};


export type QueryAllRequestsArgs = {
  queries?: Maybe<RequestsFetchQueries>;
};


export type QueryRequestByIdArgs = {
  params: OneRequestFetchParams;
};


export type QueryAllRequestsByClientArgs = {
  queries: RequestsByClientFetchQueries;
};


export type QueryRequestBadgesByStatusArgs = {
  queries: RequestBadgesByStatusQueries;
};


export type QueryRequestBadgesByTypeArgs = {
  queries: RequestBadgesByTypeQueries;
};


export type QueryTaskMissionByParcelUidArgs = {
  queries: TaskByParcelQueries;
};


export type QueryTasksMissionByIdsArgs = {
  queries: TasksByIdsQueries;
};


export type QueryAllMissionFetchArgs = {
  queries?: Maybe<MissionFetchQueries>;
};


export type QueryGetAllMissionsArgs = {
  queries?: Maybe<AllMissionFetchQueries>;
};


export type QueryGetAllMissionsForRunsheetCreationArgs = {
  queries?: Maybe<AllMissionForRunsheetCreationFetchQueries>;
};


export type QueryGetMissionForRunsheetCreationBadgeArgs = {
  queries: MissionsForRunsheetBadgeQueries;
};


export type QueryFetchMissionBadgeByTypeArgs = {
  queries: BadgeMissionsQueries;
};


export type QueryAxisBasedOnReccurrenceArgs = {
  input: GetAxisBasedOnReccurrenceInput;
};


export type QueryGetMissionBasedOnConfigArgs = {
  queries?: Maybe<MissionBasedOnConfigQueries>;
};


export type QueryGetConfigsArgs = {
  queries?: Maybe<GetConfigsQueries>;
};


export type QueryGetTasksMissionArgs = {
  queries: TasksMissionQueries;
};


export type QueryTaskMissionByRunsheetArgs = {
  params: TaskMissionByRunsheetParams;
};


export type QueryComputeReccurenceArgs = {
  input: ReccurenceDataInput;
};


export type QueryCheckTrMissionElligibilityArgs = {
  params: MissionElligibiltyParams;
};


export type QueryExportMissionsArgs = {
  queries: ExportMissionInput;
};


export type QueryAllPaymentMethodsArgs = {
  queries?: Maybe<PaymentMethodFetchQueries>;
};


export type QueryGiftByClientArgs = {
  params: GiftByClientParams;
};


export type QueryDetailsAddressArgs = {
  queries: DetailsAddressQueries;
};


export type QueryAllHubsArgs = {
  queries?: Maybe<HubsFetchQueries>;
};


export type QueryHubByIdArgs = {
  params: HubFetchParams;
};


export type QueryGetAllHubsByCityArgs = {
  queries?: Maybe<HubFetchQueries>;
};


export type QueryAllCountriesArgs = {
  queries?: Maybe<HubsFetchQueries>;
};


export type QueryUsersByHubArgs = {
  hubId: Scalars['ID'];
  queries?: Maybe<HubsFetchQueries>;
};


export type QueryAllRemittancesArgs = {
  queries?: Maybe<RemittancesFetchQueries>;
};


export type QueryRemittanceByIdArgs = {
  params?: Maybe<OneRemittanceFetchParams>;
};


export type QueryGetRemittancesRecapArgs = {
  queries?: Maybe<RemittancesFetchQueries>;
};


export type QueryGetAllServicesArgs = {
  queries?: Maybe<GetAllServicesQueries>;
};


export type QueryGetAllProgramsArgs = {
  queries?: Maybe<ProgramsFetchQueries>;
};


export type QueryGetProgramByIdArgs = {
  params: ProgramByIdParams;
};


export type QueryGetAllProgramByClientArgs = {
  params: AllProgramsByClientParams;
};


export type QueryGetSubscriptionProgramClientArgs = {
  id: Scalars['ID'];
};


export type QueryGetAdvantagesDetailsByProgramForClientArgs = {
  params: GetAdvantagesDetailsByProgramForClientParams;
};


export type QueryGetAdvantageByProgramArgs = {
  params: GetAdvantageByProgramParams;
};


export type QueryGetFidelityClientHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryGetAdvantageDemandByClientArgs = {
  id: Scalars['ID'];
  queries?: Maybe<GetAdvantageDemandByClientQueries>;
};


export type QueryGetFidelityDemandArgs = {
  queries?: Maybe<GetFidelityDemandParams>;
};

export type RConfig = {
  uid?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
};

export type Reason = {
  _id?: Maybe<Scalars['ID']>;
  reason_name?: Maybe<Scalars['String']>;
  reason_group_code?: Maybe<Scalars['String']>;
  reason_status?: Maybe<ReasonStatus>;
  reason_created_at?: Maybe<Scalars['String']>;
  reason_last_edited_at?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Translation>>>;
  reason_UID?: Maybe<Scalars['String']>;
  reason_group?: Maybe<ReasonGroup>;
};

export type ReasonCreationInput = {
  translations?: Maybe<Array<Maybe<TranslationInput>>>;
  reason_status?: Maybe<ReasonStatus>;
  reason_group_code: Scalars['String'];
};

export type ReasonCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Reason>>>;
};

export type ReasonGroup = {
  _id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ReasonGroupCreationInput = {
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ReasonGroupCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ReasonGroup>>>;
};

export type ReasonGroupMultipleCreationInput = {
  reasonGroups: Array<ReasonGroupCreationInput>;
};

export type ReasonGroupsFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
};

export type ReasonGroupsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ReasonGroup>>>;
};

export type ReasonMultipleCreationInput = {
  reasons: Array<ReasonCreationInput>;
};

export type ReasonMultipleUpdatingInput = {
  reasons: Array<ReasonUpdatingInput>;
};

export enum ReasonStatus {
  Failed = 'FAILED',
  Cancelled = 'CANCELLED',
  NotReturned = 'NOT_RETURNED',
  CancelledAtRelay = 'CANCELLED_AT_RELAY'
}

export type ReasonUpdating = {
  translations?: Maybe<Array<Maybe<TranslationInput>>>;
  reason_status?: Maybe<ReasonStatus>;
};

export type ReasonUpdatingInput = {
  id?: Maybe<Scalars['ID']>;
  reason?: Maybe<ReasonUpdating>;
};

export type ReasonsFetchQueries = {
  status?: Maybe<Array<Maybe<ReasonStatus>>>;
  lang?: Maybe<Array<Maybe<Lang>>>;
  groups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReasonsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Reason>>>;
};

export type ReassignInput = {
  vehicleId: Scalars['String'];
  driverId: Scalars['String'];
  vehicleType: EVehiculeType;
  conveyorId?: Maybe<Scalars['String']>;
  execution?: Maybe<ExecutionTimeInput>;
};

/** RECAPBYPAPSER RESPONSE */
export type RecapByPapserCountDataResponse = {
  done?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type RecapByPapserDataResponse = {
  pickup?: Maybe<RecapByPapserCountDataResponse>;
  delivery?: Maybe<RecapByPapserCountDataResponse>;
  mad?: Maybe<RecapByPapserCountDataResponse>;
  nt?: Maybe<RecapByPapserNtCountDataResponse>;
  tour?: Maybe<RecapByPapserNtCountDataResponse>;
};

/** RECAPBYPAPSER INPUT */
export type RecapByPapserFetchParams = {
  papserID: Scalars['ID'];
};

export type RecapByPapserFetchQueries = {
  date?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
};

export type RecapByPapserNtCountDataResponse = {
  done?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  subtasks?: Maybe<Array<Maybe<SubTask>>>;
};

export type RecapByPapserResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<RecapByPapserDataResponse>;
};

export type RecapData = {
  total?: Maybe<Scalars['Float']>;
  done?: Maybe<Scalars['Float']>;
  courses?: Maybe<Array<Course>>;
};

export type RecapDataResponse = {
  successful?: Maybe<RecapItemDataResponse>;
  inprogress?: Maybe<RecapItemDataResponse>;
  cancelled?: Maybe<RecapItemDataResponse>;
};

/** RECAP PARCELS RESPONSE */
export type RecapItemDataResponse = {
  amount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type RecapParcelsFetchParams = {
  clientID: Scalars['ID'];
};

/** RECAP PARCELS INPUT */
export type RecapParcelsFetchQueries = {
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RecapParcelsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<RecapDataResponse>;
};

export type ReccurenceData = {
  type?: Maybe<EReccurenceType>;
  options?: Maybe<ReccurenceOptionsInput>;
};

export type ReccurenceDataInput = {
  reccurence?: Maybe<ReccurenceData>;
  intervalDate?: Maybe<IntervateDateData>;
};

export type ReccurenceInfo = {
  quantity?: Maybe<Scalars['Int']>;
  dateRange?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReccurenceOptions = {
  each?: Maybe<Scalars['Int']>;
  days?: Maybe<Array<Maybe<EDays>>>;
  value?: Maybe<Scalars['Int']>;
};

export type ReccurenceOptionsInput = {
  each?: Maybe<Scalars['Int']>;
  days?: Maybe<Array<Maybe<EDays>>>;
  value?: Maybe<Scalars['Int']>;
};

export type Receiver = {
  _id?: Maybe<Scalars['String']>;
  receiver_firstname?: Maybe<Scalars['String']>;
  receiver_lastname?: Maybe<Scalars['String']>;
  receiver_phone_number?: Maybe<Scalars['String']>;
  receiver_email?: Maybe<Scalars['String']>;
  receiver_entreprise?: Maybe<Scalars['String']>;
  receiver_address?: Maybe<Address>;
  receiver_specification_address?: Maybe<Scalars['String']>;
  receiver_client_UID?: Maybe<Scalars['ID']>;
  receiver_client?: Maybe<Client>;
  receiver_created_by?: Maybe<Scalars['String']>;
  receiver_created_at?: Maybe<Scalars['String']>;
  receiver_last_edited_by?: Maybe<Scalars['String']>;
  receiver_last_edited_at?: Maybe<Scalars['String']>;
  receiver_UID?: Maybe<Scalars['String']>;
};

export type ReceiverAddInput = {
  receiver: ReveiverInput;
  clientID: Scalars['ID'];
};

/** RECEIVERCREATIONRESPONSE */
export type ReceiverCreatingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Receiver>;
};

/** RECEIVER MODULE MUTATIONS */
export type ReceiverCreationInput = {
  receiver_UID?: Maybe<Scalars['String']>;
  receiver_firstname: Scalars['String'];
  receiver_lastname: Scalars['String'];
  receiver_phone_number: Scalars['String'];
  receiver_email?: Maybe<Scalars['String']>;
  receiver_entreprise?: Maybe<Scalars['String']>;
  receiver_address: AddressCreationInput;
  receiver_specification_address?: Maybe<Scalars['String']>;
};

export type ReceiverDeleteInput = {
  id: Scalars['ID'];
};

/** RECEIVERDELETIONRESPONSE */
export type ReceiverDeletingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type ReceiverUpdateInput = {
  receiver_firstname?: Maybe<Scalars['String']>;
  receiver_lastname?: Maybe<Scalars['String']>;
  receiver_phone_number?: Maybe<Scalars['String']>;
  receiver_email?: Maybe<Scalars['String']>;
  receiver_entreprise?: Maybe<Scalars['String']>;
  receiver_address?: Maybe<AddressUpdateInput>;
  receiver_specification_address?: Maybe<Scalars['String']>;
};

export type ReceiverUpdatePickupInput = {
  receiver_UID?: Maybe<Scalars['ID']>;
  receiver_firstname: Scalars['String'];
  receiver_lastname: Scalars['String'];
  receiver_phone_number: Scalars['String'];
  receiver_email?: Maybe<Scalars['String']>;
  receiver_entreprise?: Maybe<Scalars['String']>;
  receiver_address: AddressCreationInput;
  receiver_specification_address?: Maybe<Scalars['String']>;
};

export type ReceiverUpdatingInput = {
  receiverID: Scalars['ID'];
  receiver?: Maybe<ReceiverUpdatingItemsInput>;
};

export type ReceiverUpdatingItemsInput = {
  receiver_firstname?: Maybe<Scalars['String']>;
  receiver_lastname?: Maybe<Scalars['String']>;
  receiver_phone_number?: Maybe<Scalars['String']>;
  receiver_email?: Maybe<Scalars['String']>;
  receiver_entreprise?: Maybe<Scalars['String']>;
  receiver_address?: Maybe<AddressCreationInput>;
  receiver_specification_address?: Maybe<Scalars['String']>;
};

export type ReceiverUpdatingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Receiver>;
};

export type ReceiversByClientFetchParams = {
  clientID: Scalars['ID'];
};

/** ALLRECEIVERSBYCLIENT INPUT */
export type ReceiversByClientFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['String']>;
};

/** ALLRECEIVERS INPUT */
export type ReceiversFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** ALLRECEIVERS RESPONSE */
export type ReceiversFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Receiver>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type RecurrenceDataResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<ReccurenceInfo>;
};

export type RefAddress = {
  /** Identtify element  */
  _id?: Maybe<Scalars['ID']>;
  /** Is deleted */
  isDeleted: Scalars['Boolean'];
  /** Created at */
  createdAt: Scalars['String'];
  /** Updated at */
  updatedAt: Scalars['String'];
  /** User who created the record */
  createdBy: EditedBy;
  /** User who changed the record */
  editedBy: EditedBy;
  /** Individual client uid */
  clientID: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  addressName?: Maybe<Scalars['String']>;
  address: Address;
};

export type RefAddressFetchInput = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  clientID?: Maybe<Scalars['ID']>;
};

export type Remittance = {
  /** ID Remittance */
  _id?: Maybe<Scalars['ID']>;
  clientUID?: Maybe<Scalars['ID']>;
  client?: Maybe<Client>;
  remittanceUID?: Maybe<Scalars['String']>;
  parcels?: Maybe<Array<Maybe<Parcel>>>;
  activities?: Maybe<Array<Maybe<Activity>>>;
  type?: Maybe<RemittanceType>;
  status?: Maybe<ParcelRecapStatus>;
  amountToRemit?: Maybe<Scalars['Int']>;
  additionalInfo?: Maybe<Scalars['String']>;
  isConfirm?: Maybe<Scalars['Boolean']>;
  isReceptionConfirmed?: Maybe<Scalars['Boolean']>;
  badge?: Maybe<RemittanceBadge>;
  declineReceptionReason?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  receiverPhone?: Maybe<Scalars['String']>;
  costs?: Maybe<Scalars['String']>;
  finalAmount?: Maybe<Scalars['Int']>;
  proof?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['String']>;
  confirmCreatedAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<RemittanceCreatedBy>;
  lastEditedBy?: Maybe<RemittanceCreatedBy>;
  minDate?: Maybe<Scalars['String']>;
  maxDate?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  wasConfirmed?: Maybe<Scalars['Boolean']>;
};

export enum RemittanceBadge {
  Default = 'DEFAULT',
  Received = 'RECEIVED',
  NotReceived = 'NOT_RECEIVED'
}

export type RemittanceByIdResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Remittance>;
};

export type RemittanceConfirmInput = {
  remittanceID: Scalars['ID'];
  remittance?: Maybe<ConfirmInput>;
};

export type RemittanceCreatedBy = {
  user_id?: Maybe<Scalars['ID']>;
  source?: Maybe<Source>;
};

export type RemittanceCreationInput = {
  clientID: Scalars['ID'];
  remittance: RemittanceInput;
  countries: Array<Maybe<CountryInput>>;
};

export type RemittanceCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Remittance>;
};

export type RemittanceDeleteInput = {
  id: Scalars['ID'];
};

export type RemittanceDeletingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Remittance>;
};

export type RemittanceInput = {
  amountToRemit: Scalars['Int'];
  parcels?: Maybe<Array<Maybe<Scalars['ID']>>>;
  type: RemittanceType;
  additionalInfo?: Maybe<Scalars['String']>;
  finalAmount?: Maybe<Scalars['Int']>;
  isConfirm?: Maybe<Scalars['Boolean']>;
  costs?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  receiverPhone?: Maybe<Scalars['String']>;
  proof?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Method of the remittance! */
export enum RemittanceMethod {
  MoneyToSent = 'MoneyToSent',
  MoneyToCashier = 'MoneyToCashier',
  MoneyToAddress = 'MoneyToAddress',
  MoneyToPaps = 'MoneyToPaps'
}

export type RemittanceParcelsInput = {
  parcels?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type RemittanceParcelsUpdatingInput = {
  id: Scalars['ID'];
  remittance: RemittanceParcelsInput;
};

export enum RemittanceType {
  MobileMoney = 'MOBILE_MONEY',
  Cash = 'CASH',
  Course = 'COURSE',
  BankTransfer = 'BANK_TRANSFER',
  Check = 'CHECK'
}

export type RemittanceUpdateInput = {
  parcels?: Maybe<Array<Maybe<Scalars['ID']>>>;
  amountToRemit?: Maybe<Scalars['Int']>;
};

export type RemittanceUpdatingInput = {
  id: Scalars['ID'];
  remittance: RemittanceUpdateInput;
};

export type RemittancesBadge = {
  status?: Maybe<ParcelRecapStatus>;
  amount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

/** ALLREMITTANCES INPUT */
export type RemittancesFetchQueries = {
  client_id?: Maybe<Scalars['ID']>;
  status?: Maybe<ParcelRecapStatus>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** ALLREMITTANCES RESPONSE */
export type RemittancesFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Remittance>>>;
};

export type RemittancesRecapData = {
  badges?: Maybe<Array<Maybe<RemittancesBadge>>>;
  remittances?: Maybe<Array<Maybe<Remittance>>>;
};

export type RemittancesRecapResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<RemittancesRecapData>;
};

export type RenameAxeResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Axe>;
};

export type RenameAxesInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ReportIssueInput = {
  taskID: Scalars['ID'];
  reasonId?: Maybe<Scalars['ID']>;
  otherReason?: Maybe<Scalars['String']>;
};

export type ReportIssueResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Task>;
};

export type ReportPapserIssueInput = {
  papserId: Scalars['ID'];
  reasonId?: Maybe<Scalars['ID']>;
  otherReason?: Maybe<Scalars['String']>;
};

export type ReportPapserIssueResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Task>>>;
};

export type Request = {
  _id?: Maybe<Scalars['ID']>;
  uid?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['ID']>;
  client?: Maybe<Client>;
  type?: Maybe<ERequestType>;
  status?: Maybe<ERequestStatus>;
  vehicles?: Maybe<Array<Maybe<Vehicles>>>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  productType?: Maybe<Array<Maybe<EProductType>>>;
  additionnalInfos?: Maybe<Scalars['String']>;
  reccurenceType?: Maybe<EReccurenceType>;
  reccurenceOptions?: Maybe<ReccurenceOptions>;
  price?: Maybe<Scalars['Float']>;
  pricingType?: Maybe<RequestPricing>;
  packagePricing?: Maybe<Scalars['Float']>;
  handler?: Maybe<Handler>;
  dispatcher?: Maybe<Dispatcher>;
  discount?: Maybe<Scalars['Int']>;
  templateStops?: Maybe<Array<Maybe<TemplateStop>>>;
  documents?: Maybe<Array<Maybe<RequestDocument>>>;
  view?: Maybe<ViewRequest>;
  createdBy?: Maybe<CreatedBy>;
  editedBy?: Maybe<EditedBy>;
  createdAt?: Maybe<Scalars['String']>;
  editedAt?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  request_activities?: Maybe<Array<Maybe<Activity>>>;
  templateAxes?: Maybe<Array<Maybe<TemplateAxe>>>;
  declineReason?: Maybe<Scalars['String']>;
  hasMissions?: Maybe<Scalars['Boolean']>;
  configs?: Maybe<Array<Maybe<RConfig>>>;
};

export type RequestAcceptInput = {
  id: Scalars['ID'];
};

export type RequestAcceptResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export type RequestApproveInput = {
  id: Scalars['ID'];
};

export type RequestApproveResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export type RequestArchiveInput = {
  id: Scalars['ID'];
};

export type RequestArchiveResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export type RequestBadgeInput = {
  key: Scalars['String'];
  value: Array<Maybe<ERequestStatus>>;
};

export type RequestBadgeTypeInput = {
  key: Scalars['String'];
  value: Array<Maybe<ERequestType>>;
};

export type RequestBadgesByStatusQueries = {
  groupStatus: Array<Maybe<RequestBadgeInput>>;
  type?: Maybe<ERequestType>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RequestBadgesByTypeQueries = {
  types: Array<Maybe<RequestBadgeTypeInput>>;
  hasMissions?: Maybe<Scalars['Boolean']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RequestClient = {
  _id?: Maybe<Scalars['ID']>;
  entreprise?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  requester?: Maybe<Requester>;
  activity?: Maybe<Scalars['String']>;
  status?: Maybe<RequestClientStatus>;
};

export enum RequestClientStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export type RequestCreationInput = {
  request: AddRequestInput;
};

export type RequestCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export type RequestDeclineInput = {
  id: Scalars['ID'];
  declineReason?: Maybe<Scalars['String']>;
};

export type RequestDeclineResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export type RequestDocument = {
  _id?: Maybe<Scalars['ID']>;
  libelle?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  request?: Maybe<Request>;
  createdBy?: Maybe<CreatedBy>;
  editedBy?: Maybe<EditedBy>;
  createdAt?: Maybe<Scalars['String']>;
  editedAt?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
};

export type RequestNewEventInput = {
  id: Scalars['ID'];
  platform: EPlatform;
};

export type RequestNewEventResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export enum RequestPricing {
  PerVehicle = 'PER_VEHICLE',
  PerAxe = 'PER_AXE',
  PerStop = 'PER_STOP',
  Forfait = 'FORFAIT'
}

export type RequestReloadInput = {
  id: Scalars['ID'];
};

export type RequestReloadResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export type RequestUpdateInput = {
  id: Scalars['ID'];
  request?: Maybe<UpdateRequestInput>;
};

export type RequestUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Request>;
};

export type Requester = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  entrepriseRole?: Maybe<Scalars['String']>;
};

export type RequestsByClientFetchQueries = {
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<ERequestStatus>>>;
  type?: Maybe<Array<Maybe<ERequestType>>>;
};

export type RequestsFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<ERequestStatus>>>;
  type?: Maybe<Array<Maybe<ERequestType>>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  searchText?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  productTypes?: Maybe<Array<Maybe<EProductType>>>;
  stopPlaceId?: Maybe<Scalars['String']>;
  hasMissions?: Maybe<Scalars['Boolean']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RequestsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Request>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type ResendActivationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Account>;
};

export type ResetPasswordOpsInput = {
  token: Scalars['String'];
  password: Scalars['String'];
};

export type ResetPasswordOpsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type ResetToken = {
  value?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['String']>;
};

export type ReveiverInput = {
  receiver_firstname: Scalars['String'];
  receiver_lastname: Scalars['String'];
  receiver_phone_number: Scalars['String'];
  receiver_email?: Maybe<Scalars['String']>;
  receiver_entreprise?: Maybe<Scalars['String']>;
  receiver_address: AddressCreationInput;
  receiver_specification_address?: Maybe<Scalars['String']>;
};

export type Role = {
  _id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  created_by?: Maybe<RoleModuleCreatedOrUpdatedBy>;
  created_at?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<RoleModuleCreatedOrUpdatedBy>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  users?: Maybe<Array<Maybe<UserStaff>>>;
  type?: Maybe<RoleType>;
};

export type RoleCreationInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: RoleType;
};

export type RoleModuleCreatedOrUpdatedBy = {
  user_id?: Maybe<Scalars['ID']>;
  user?: Maybe<UserStaff>;
  source?: Maybe<Scalars['String']>;
};

export enum RoleType {
  Warehouse = 'WAREHOUSE',
  Relay = 'RELAY'
}

export type RoleUpdatingInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: PermissionType;
  permissions: Array<Scalars['ID']>;
};

export type RolesFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Role>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type RolesStaffFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  type?: Maybe<RoleType>;
};

export type Runsheet = {
  _id?: Maybe<Scalars['ID']>;
  runsheet_UID?: Maybe<Scalars['String']>;
  runsheet_status?: Maybe<RunsheetStatus>;
  runsheet_vehicle_type?: Maybe<RunsheetVehicleType>;
  runsheet_amount_to_collect?: Maybe<Scalars['Int']>;
  runsheet_created_by?: Maybe<UserStaff>;
  runsheet_created_at?: Maybe<Scalars['String']>;
  runsheet_is_deleted?: Maybe<Scalars['Boolean']>;
  runsheet_return?: Maybe<Scalars['Boolean']>;
  runsheet_delivery_date?: Maybe<Scalars['String']>;
  runsheet_last_edited_by?: Maybe<Scalars['String']>;
  runsheet_last_edited_at?: Maybe<Scalars['String']>;
  runsheet_orders?: Maybe<Array<Maybe<Order>>>;
  runsheet_parcels?: Maybe<Array<Maybe<Parcel>>>;
  runsheet_activities?: Maybe<Array<Maybe<Activity>>>;
  runsheet_driver_UID?: Maybe<Scalars['ID']>;
  runsheet_driver?: Maybe<Driver>;
  runsheet_vehicle_UID?: Maybe<Scalars['ID']>;
  runsheet_vehicle?: Maybe<Vehicle>;
  runsheet_conveyor_UID?: Maybe<Scalars['ID']>;
  runsheet_conveyor?: Maybe<Conveyor>;
  countries?: Maybe<Array<Maybe<Country>>>;
  incident?: Maybe<Scalars['Boolean']>;
  task?: Maybe<Task>;
  runsheet_tasks?: Maybe<Array<Maybe<Scalars['String']>>>;
  drivers?: Maybe<Array<Maybe<Driver>>>;
  conveyors?: Maybe<Array<Maybe<Conveyor>>>;
};

/** ASSIGNRUNSHEET RESPONSE */
export type RunsheetAssignationDataResponse = {
  runsheet?: Maybe<Runsheet>;
  task?: Maybe<Task>;
};

export type RunsheetAssignationInput = {
  runsheetID: Scalars['ID'];
  papser: RunsheetAssignationPapserInput;
  toReturn?: Maybe<Scalars['Boolean']>;
  execution: ExecutionTimeInput;
};

/** ASSIGNRUNSHEET INPUT */
export type RunsheetAssignationPapserInput = {
  driverID: Scalars['ID'];
  vehicleID: Scalars['ID'];
  conveyorID?: Maybe<Scalars['ID']>;
  vehicle_type: RunsheetVehicleType;
};

export type RunsheetAssignationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<RunsheetAssignationDataResponse>;
};

export type RunsheetBadgeInput = {
  key: Scalars['String'];
  value: Array<Maybe<RunsheetStatus>>;
};

export type RunsheetBadgesByStatusQueries = {
  groupStatus: Array<Maybe<RunsheetBadgeInput>>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RunsheetCreationInput = {
  items: Array<RunsheetCreationItemsInput>;
};

/** ADDRUNSHEET INPUT */
export type RunsheetCreationItemsInput = {
  orderID: Scalars['ID'];
  parcelIDs: Array<Scalars['ID']>;
};

/** ADDRUNSHEET RESPONSE */
export type RunsheetCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Runsheet>;
};

/** MANUAL RUNSHEET MONEY COLLECTION  INPUT */
export type RunsheetManualMoneyCollectionInput = {
  runsheetId: Scalars['ID'];
  parcelIds: Array<Scalars['ID']>;
};

/** MANUAL RUNSHEET MONEY COLLECTION RESPONSE */
export type RunsheetManualMoneyCollectionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Runsheet>;
};

export type RunsheetMissionCreationInput = {
  items: Array<RunsheetMissionCreationItemsInput>;
};

/** ADDRUNSHEETMISSION INPUT */
export type RunsheetMissionCreationItemsInput = {
  uid: Scalars['String'];
  type: Scalars['String'];
  request: Scalars['ID'];
  executionDate: Scalars['String'];
  stops?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type RunsheetMissionUpdateInput = {
  tasks: Array<Scalars['String']>;
};

/** COLLECTRUNSHEETMONEY INPUT */
export type RunsheetMoneyCollectionInput = {
  runsheetID: Scalars['ID'];
};

/** COLLECTRUNSHEETMONEY RESPONSE */
export type RunsheetMoneyCollectionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Runsheet>;
};

/** PARTIALLY RECONCILE RUNSHEET INPUT */
export type RunsheetPartialReconciliationInput = {
  runsheetId: Scalars['ID'];
  parcelIds: Array<Scalars['ID']>;
};

/** PARTIALLY RECONCILE RUNSHEET RESPONSE */
export type RunsheetPartialReconciliationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Parcel>>>;
};

export type RunsheetProcessingDataResponse = {
  runsheet?: Maybe<Runsheet>;
};

export type RunsheetProcessingInput = {
  runsheetId: Scalars['ID'];
  items: RunsheetProcessingItemsInput;
};

export type RunsheetProcessingItemsInput = {
  toReceive: Array<Maybe<ParcelReceivingItemsInput>>;
  toReconcile: Array<Maybe<RunsheetReconciliationItemsInput>>;
};

export type RunsheetProcessingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<RunsheetProcessingDataResponse>;
};

/** Reassign Runsheet V2 */
export type RunsheetReassignmentV2Response = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

/** RECONCILERUNSHEET RESPONSE */
export type RunsheetReconciliationDataParcelsResponse = {
  parcelsCanceledReconciled?: Maybe<Array<Maybe<Parcel>>>;
  parcelsFailedReconciled?: Maybe<Array<Maybe<Parcel>>>;
  parcelsToReturn?: Maybe<Array<Maybe<Parcel>>>;
};

export type RunsheetReconciliationDataResponse = {
  runsheet?: Maybe<Runsheet>;
  parcels?: Maybe<RunsheetReconciliationDataParcelsResponse>;
};

export type RunsheetReconciliationInput = {
  runsheetID: Scalars['ID'];
  items: Array<RunsheetReconciliationItemsInput>;
};

export type RunsheetReconciliationItemsInput = {
  type: ParcelStatus;
  parcelIDs?: Maybe<Array<Maybe<RunsheetReconciliationItemsParcelIDsInput>>>;
  tag?: Maybe<ParcelTag>;
  proofOfDelivery?: Maybe<Scalars['String']>;
};

/** RECONCILERUNSHEET INPUT */
export type RunsheetReconciliationItemsParcelIDsInput = {
  id?: Maybe<Scalars['ID']>;
  motif?: Maybe<Scalars['String']>;
  reasonId?: Maybe<Scalars['ID']>;
  reschedulingInfo?: Maybe<ExecutionTimeInput>;
};

export type RunsheetReconciliationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<RunsheetReconciliationDataResponse>;
};

export type RunsheetReturnCreationInput = {
  items: Array<RunsheetReturnCreationItemsInput>;
};

/** ADDRUNSHEETRETURN INPUT */
export type RunsheetReturnCreationItemsInput = {
  parcelID: Scalars['ID'];
};

/** ADDRUNSHEETRETURN RESPONSE */
export type RunsheetReturnCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Runsheet>;
};

/** VALIDATERUNSHEETRETURN RESPONSE */
export type RunsheetReturnValidationDataResponse = {
  runsheet?: Maybe<Runsheet>;
  parcelToReturn?: Maybe<Array<Maybe<Parcel>>>;
};

export type RunsheetReturnValidationInput = {
  runsheetID: Scalars['ID'];
  parcelIDs: Array<RunsheetReturnValidationItemsInput>;
};

/** VALIDATERUNSHEETRETURN INPUT */
export type RunsheetReturnValidationItemsInput = {
  id: Scalars['ID'];
  motif?: Maybe<Scalars['String']>;
  reasonId?: Maybe<Scalars['ID']>;
};

export type RunsheetReturnValidationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<RunsheetReturnValidationDataResponse>;
};

export enum RunsheetStatus {
  ToBeAssigned = 'TO_BE_ASSIGNED',
  Assigned = 'ASSIGNED',
  OnGoing = 'ON_GOING',
  ToHandOver = 'TO_HAND_OVER',
  HrToHandOver = 'HR_TO_HAND_OVER',
  OnDelivery = 'ON_DELIVERY',
  Completed = 'COMPLETED',
  ToReconcile = 'TO_RECONCILE',
  MoneyToCollect = 'MONEY_TO_COLLECT',
  OnReturn = 'ON_RETURN',
  Returned = 'RETURNED',
  ToValidate = 'TO_VALIDATE',
  HandedOver = 'HANDED_OVER',
  HrHandedOver = 'HR_HANDED_OVER',
  HrToBeAssigned = 'HR_TO_BE_ASSIGNED',
  HrOnReturn = 'HR_ON_RETURN'
}

/** DELETERUNSHEETSTATUS RESPONSE */
export type RunsheetStatusDeletionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type RunsheetStatusEditionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Runsheet>;
};

/** Unassign Runsheet V2 */
export type RunsheetUnassignmentV2Response = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type RunsheetUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export enum RunsheetVehicleType {
  Scooter = 'SCOOTER',
  MiniVan = 'MINI_VAN',
  Van = 'VAN',
  Tricycle = 'TRICYCLE',
  Truck_3T = 'TRUCK_3T',
  Truck_5T = 'TRUCK_5T',
  Truck_7T = 'TRUCK_7T',
  Truck_8T = 'TRUCK_8T',
  Truck_9T = 'TRUCK_9T',
  Truck_10T = 'TRUCK_10T',
  Truck_12T = 'TRUCK_12T',
  Truck_15T = 'TRUCK_15T',
  Truck_20T = 'TRUCK_20T',
  Truck_25T = 'TRUCK_25T',
  Truck_30T = 'TRUCK_30T',
  Truck_35T = 'TRUCK_35T',
  Truck_50T = 'TRUCK_50T',
  RefrigeratedTruck_3T = 'REFRIGERATED_TRUCK_3T',
  RefrigeratedTruck_5T = 'REFRIGERATED_TRUCK_5T',
  RefrigeratedTruck_8T = 'REFRIGERATED_TRUCK_8T',
  RefrigeratedTruck_10T = 'REFRIGERATED_TRUCK_10T',
  RefrigeratedTruck_12T = 'REFRIGERATED_TRUCK_12T'
}

/** ALLRUNSHEETS INPUT */
export type RunsheetsFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<RunsheetStatus>>>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
  driver?: Maybe<Scalars['String']>;
  conveyor?: Maybe<Scalars['String']>;
  vehicleType?: Maybe<Array<Maybe<RunsheetVehicleType>>>;
  fromDate?: Maybe<Scalars['String']>;
  toDate?: Maybe<Scalars['String']>;
};

/** ALLRUNSHEETS RESPONSE */
export type RunsheetsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Runsheet>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type Sms = {
  _id?: Maybe<Scalars['ID']>;
  to?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<Scalars['String']>;
};

/** SENDCODEDELIVERYRECEPTION RESPONSE */
export type SendCodeDeliveryReceptionDataResponse = {
  code?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
};

/** SENDCODEDELIVERYRECEPTION INPUT */
export type SendCodeDeliveryReceptionInput = {
  subtaskID: Scalars['ID'];
};

export type SendCodeDeliveryReceptionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<SendCodeDeliveryReceptionDataResponse>;
};

export type SendCodeOtpInput = {
  phone_number?: Maybe<Scalars['String']>;
};

export type SendCodeOtpResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataSendCodeOtpResponse>;
};

export type SendMailCreationInput = {
  sendMail: SendMailInput;
};

/** SENDMAIL RESPONSE */
export type SendMailCreationResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Email>;
  code?: Maybe<Scalars['Int']>;
};

export type SendMailInput = {
  subject: Scalars['String'];
  toName: Scalars['String'];
  toEmail: Scalars['String'];
  withRedirection: Scalars['Boolean'];
  variables: VariableInput;
};

export type SendOtpCodeToReceiverFromRelayResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type Service = {
  _id: Scalars['ID'];
  label: Scalars['String'];
  description: Scalars['String'];
};

export type ServiceInput = {
  label: Scalars['String'];
  description: Scalars['String'];
};

export type Slot = {
  slotEnd: Scalars['String'];
  slotStart: Scalars['String'];
};

export type Slots = {
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
};

export enum Source {
  Client = 'CLIENT',
  Staff = 'STAFF',
  Partner = 'PARTNER'
}

export type SplitTasksNtTransitInput = {
  deliveriesTransit: Array<DeliveriesTransitInput>;
};

export type SplitTasksNtTransitQueries = {
  id: Scalars['ID'];
};

export type SplitTasksNtTransitResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<TaskMission>>>;
};

export type StartActionInput = {
  /** Course UID! */
  courseUID?: Maybe<Scalars['String']>;
  /** Action ID! */
  actionID: Scalars['String'];
};

export type StartOrFinishTaskInput = {
  taskID: Scalars['ID'];
  start: Scalars['Boolean'];
  eventType?: Maybe<ActivityTriggerActionEnum>;
};

export type StartOrFinishTaskResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Task>;
};

export type Stop = {
  _id?: Maybe<Scalars['ID']>;
  axe?: Maybe<Axe>;
  templateStop?: Maybe<TemplateStop>;
  status?: Maybe<MissionStatusType>;
  libelle?: Maybe<ERequestType>;
  action?: Maybe<EActionType>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  pickupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  address?: Maybe<Address>;
  items?: Maybe<Array<Maybe<Items>>>;
  createdBy?: Maybe<CreatedBy>;
  editedBy?: Maybe<EditedBy>;
  createdAt?: Maybe<Scalars['String']>;
  editedAt?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  refTemplateStop?: Maybe<Scalars['ID']>;
  pickupTemplateStopsRef?: Maybe<Array<Maybe<TemplateStop>>>;
  hub?: Maybe<Hub>;
  hubId?: Maybe<Scalars['ID']>;
  orderId?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Int']>;
};

export type StopActionItemInput = {
  templateStopId: Scalars['ID'];
  action: EActionType;
  pickupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  hubId?: Maybe<Scalars['ID']>;
};

export type StopActionUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ActionUpdatedItem>>>;
};

export type StopDisableUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<TemplateStopDisableUpdated>>>;
};

export type StopInput = {
  templateStop?: Maybe<TemplateStopInput>;
  status?: Maybe<MissionStatusType>;
  libelle?: Maybe<ERequestType>;
  action?: Maybe<EActionType>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  pickupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  address?: Maybe<AddressInput>;
  items?: Maybe<Array<Maybe<ItemsInput>>>;
  createdAt?: Maybe<Scalars['String']>;
  editedAt?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  refTemplateStop?: Maybe<Scalars['ID']>;
  pickupTemplateStopsRef?: Maybe<Array<Maybe<TemplateStopInput>>>;
  hubId?: Maybe<Scalars['ID']>;
  orderId?: Maybe<Scalars['ID']>;
};

export type SubTask = {
  _id?: Maybe<Scalars['ID']>;
  subtask_UID?: Maybe<Scalars['String']>;
  subtask_driver_UID?: Maybe<Scalars['String']>;
  subtask_driver?: Maybe<Driver>;
  subtask_vehicule_UID?: Maybe<Scalars['String']>;
  subtask_vehicule?: Maybe<Vehicle>;
  requested_vehicle_type?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtask_conveyor_UID?: Maybe<Scalars['String']>;
  subtask_conveyor?: Maybe<Conveyor>;
  subtask_status?: Maybe<SubTaskStatus>;
  subtask_type?: Maybe<SubTaskType>;
  subtask_address?: Maybe<Address>;
  subtask_for_paps?: Maybe<Scalars['Boolean']>;
  subtask_is_disable?: Maybe<Scalars['Boolean']>;
  subtask_operation_on_job?: Maybe<Job>;
  subtask_operation_on_order?: Maybe<Order>;
  subtask_operation_on_runsheet?: Maybe<Runsheet>;
  subtask_operation_on_parcel?: Maybe<Array<Maybe<Parcel>>>;
  subtask_client_UID?: Maybe<Scalars['ID']>;
  subtask_client?: Maybe<Client>;
  subtask_recipient_UID?: Maybe<Scalars['ID']>;
  subtask_recipient?: Maybe<Receiver>;
  subtask_execution_date?: Maybe<Scalars['String']>;
  subtask_execution_slot_start?: Maybe<Scalars['String']>;
  subtask_execution_slot_end?: Maybe<Scalars['String']>;
  subtask_created_at?: Maybe<Scalars['String']>;
  subtask_created_by?: Maybe<CreatedBy>;
  subtask_last_edited_by?: Maybe<EditedBy>;
  subtask_last_edited_at?: Maybe<Scalars['String']>;
  subtask_task?: Maybe<Task>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  subtask_signature?: Maybe<Scalars['String']>;
  isForRelay?: Maybe<Scalars['Boolean']>;
  isRelayActionOpened?: Maybe<Scalars['Boolean']>;
  service?: Maybe<PapsService>;
  originTaskId?: Maybe<Scalars['ID']>;
  originTask?: Maybe<TaskMissionWithClient>;
  pickedItems?: Maybe<Array<Maybe<TourItem>>>;
  deliveredItems?: Maybe<Array<Maybe<TourItem>>>;
  itemsToDelivered?: Maybe<Array<Maybe<TourItemWithPickupSubtask>>>;
  originPickupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  originRefStopId?: Maybe<Scalars['ID']>;
  createdFromTourSubtask?: Maybe<Scalars['Boolean']>;
};

export type SubTaskBadgeInput = {
  key: Scalars['String'];
  value: Array<Maybe<SubTaskStatus>>;
};

export type SubTaskBadgesByStatusQueries = {
  groupStatus: Array<Maybe<SubTaskBadgeInput>>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  dateFilter?: Maybe<Scalars['String']>;
};

export enum SubTaskStatus {
  Unassigned = 'UNASSIGNED',
  Assigned = 'ASSIGNED',
  Done = 'DONE',
  Cancelled = 'CANCELLED',
  ToReschedule = 'TO_RESCHEDULE'
}

export enum SubTaskType {
  Pickup = 'PICKUP',
  Unknown = 'UNKNOWN',
  PickupDelivery = 'PICKUP_DELIVERY',
  WarehouseReturn = 'WAREHOUSE_RETURN',
  Warehouse = 'WAREHOUSE',
  Delivery = 'DELIVERY',
  DeliveryReturn = 'DELIVERY_RETURN',
  MiseEnDispostion = 'MISE_EN_DISPOSTION'
}

/** ALLSUBTASKSBYCLIENT INPUT */
export type SubTasksByClientFetchParams = {
  clientID: Scalars['ID'];
};

/** ALLSUBTASKSBYPAPSER INPUT */
export type SubTasksByPapserFetchParams = {
  papserID: Scalars['ID'];
};

/** ALLSUBTASKS INPUT */
export type SubTasksFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<SubTaskStatus>>>;
  type?: Maybe<Array<Maybe<SubTaskType>>>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** ALLSUBTASKS RESPONSE */
export type SubTasksFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<SubTask>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type SubscribeProgramInput = {
  programId: Scalars['ID'];
  clientId: Scalars['ID'];
};

export type SubscribeProgramResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
};

export type Subscription = {
  newCourse: Course;
  assignCourse: Course;
  actionStarted: Action;
  clientDeactivation?: Maybe<Scalars['ID']>;
  jobs?: Maybe<Array<Maybe<Job>>>;
  orders?: Maybe<Array<Maybe<Order>>>;
  parcels?: Maybe<Array<Maybe<Parcel>>>;
  runsheets?: Maybe<Array<Maybe<Runsheet>>>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  requestAssigned?: Maybe<Array<Maybe<TaskTransferRequest>>>;
  requestApprovedOrDeclined?: Maybe<Array<Maybe<TaskTransferRequest>>>;
  subTaskCreated?: Maybe<Array<Maybe<SubTask>>>;
  subTasksAssigned?: Maybe<Array<Maybe<SubTask>>>;
  subtasks?: Maybe<Array<Maybe<SubTask>>>;
  subTaskHandedOver?: Maybe<Runsheet>;
  driverBlockedOrUnblocked?: Maybe<Driver>;
  notification?: Maybe<Notification>;
  requests?: Maybe<Array<Maybe<Request>>>;
};


export type SubscriptionAssignCourseArgs = {
  driver: Scalars['String'];
};


export type SubscriptionActionStartedArgs = {
  course: Scalars['String'];
};


export type SubscriptionClientDeactivationArgs = {
  clientId?: Maybe<Scalars['ID']>;
};


export type SubscriptionJobsArgs = {
  client_UID?: Maybe<Scalars['ID']>;
};


export type SubscriptionOrdersArgs = {
  client_UID?: Maybe<Scalars['ID']>;
};


export type SubscriptionParcelsArgs = {
  client_UID?: Maybe<Scalars['ID']>;
};


export type SubscriptionTasksArgs = {
  client_UID?: Maybe<Scalars['ID']>;
};


export type SubscriptionRequestAssignedArgs = {
  papserID: Scalars['ID'];
  date: Scalars['String'];
};


export type SubscriptionRequestApprovedOrDeclinedArgs = {
  papserID: Scalars['ID'];
};


export type SubscriptionSubTaskCreatedArgs = {
  clientID: Scalars['ID'];
};


export type SubscriptionSubTasksAssignedArgs = {
  papserID: Scalars['ID'];
  date: Scalars['String'];
};


export type SubscriptionSubtasksArgs = {
  clientUID?: Maybe<Scalars['ID']>;
};


export type SubscriptionSubTaskHandedOverArgs = {
  papserID: Scalars['ID'];
};


export type SubscriptionDriverBlockedOrUnblockedArgs = {
  papserID: Scalars['ID'];
};


export type SubscriptionNotificationArgs = {
  viewerClient?: Maybe<Scalars['ID']>;
  viewerOps?: Maybe<Scalars['ID']>;
};


export type SubscriptionRequestsArgs = {
  clientId?: Maybe<Scalars['ID']>;
};

export type SubscriptionAdvantageItem = {
  _id?: Maybe<Scalars['ID']>;
  programId: Scalars['ID'];
  clientId: Scalars['ID'];
  advantages: Array<Maybe<AdvantageSubscription>>;
  isActive?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
};

/** SUBTASKDELIVERYRETURNVALIDATION RESPONSE */
export type SubtaskDeliveryReturnValidationDataParcelsResponse = {
  returned?: Maybe<Array<Maybe<Parcel>>>;
  not_returned?: Maybe<Array<Maybe<Parcel>>>;
};

export type SubtaskDeliveryReturnValidationDataResponse = {
  subtask?: Maybe<SubTask>;
  task?: Maybe<Task>;
  runsheet?: Maybe<Runsheet>;
  parcels?: Maybe<SubtaskDeliveryReturnValidationDataParcelsResponse>;
};

export type SubtaskDeliveryReturnValidationInput = {
  subtaskID: Scalars['ID'];
  items?: Maybe<Array<Maybe<SubtaskDeliveryReturnValidationItemsInput>>>;
};

export type SubtaskDeliveryReturnValidationItemsInput = {
  type: ParcelStatus;
  parcelIDs: Array<SubtaskDeliveryReturnValidationItemsParcelsInput>;
};

/** SUBTASKDELIVERYRETURNVALIDATION INPUT */
export type SubtaskDeliveryReturnValidationItemsParcelsInput = {
  id: Scalars['ID'];
  motif?: Maybe<Scalars['String']>;
  dateSchedule?: Maybe<Scalars['String']>;
  slot_start?: Maybe<Scalars['String']>;
  slot_end?: Maybe<Scalars['String']>;
  reasonId?: Maybe<Scalars['ID']>;
};

export type SubtaskDeliveryReturnValidationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<SubtaskDeliveryReturnValidationDataResponse>;
};

/** SUBTASKDELIVERYVALIDATION RESPONSE */
export type SubtaskDeliveryValidationDataParcelsResponse = {
  successful?: Maybe<Array<Maybe<Parcel>>>;
  cancelled?: Maybe<Array<Maybe<Parcel>>>;
  failed?: Maybe<Array<Maybe<Parcel>>>;
};

export type SubtaskDeliveryValidationDataResponse = {
  subtask?: Maybe<SubTask>;
  task?: Maybe<Task>;
  runsheet?: Maybe<Runsheet>;
  order?: Maybe<Order>;
  parcels?: Maybe<SubtaskDeliveryValidationDataParcelsResponse>;
};

export type SubtaskDeliveryValidationInput = {
  subtaskID: Scalars['ID'];
  items: Array<SubtaskDeliveryValidationItemsInput>;
  orderID: Scalars['ID'];
  code?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
};

export type SubtaskDeliveryValidationItemsInput = {
  type?: Maybe<ParcelStatus>;
  parcelIDs?: Maybe<Array<Maybe<SubtaskDeliveryValidationItemsParcelsInput>>>;
};

/** SUBTASKDELIVERYVALIDATION INPUT */
export type SubtaskDeliveryValidationItemsParcelsInput = {
  id?: Maybe<Scalars['ID']>;
  motif?: Maybe<Scalars['String']>;
  dateSchedule?: Maybe<Scalars['String']>;
  slot_start?: Maybe<Scalars['String']>;
  slot_end?: Maybe<Scalars['String']>;
  reasonId?: Maybe<Scalars['ID']>;
};

export type SubtaskDeliveryValidationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<SubtaskDeliveryValidationDataResponse>;
};

export type SubtaskPickupValidationInput = {
  subtaskID: Scalars['ID'];
  items?: Maybe<Array<Maybe<SubtaskPickupValidationItemsInput>>>;
};

/** SUBTASKPICKUPVALIDATION INPUT */
export type SubtaskPickupValidationItemsInput = {
  orderID?: Maybe<Scalars['ID']>;
  parcelID?: Maybe<Scalars['ID']>;
};

/** SUBTASKPICKUPVALIDATION RESPONSE */
export type SubtaskPickupValidationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<SubTask>;
};

export type SubtaskProcessingInput = {
  subtaskId: Scalars['ID'];
  items: SubtaskProcessingItemsInput;
  confirmCode?: Maybe<Scalars['String']>;
};

export type SubtaskProcessingItemsDeliveredInput = {
  DELIVERED?: Maybe<Array<Maybe<SubtaskDeliveryValidationItemsParcelsInput>>>;
  CANCELLED?: Maybe<Array<Maybe<SubtaskDeliveryValidationItemsParcelsInput>>>;
  FAILED?: Maybe<Array<Maybe<SubtaskDeliveryValidationItemsParcelsInput>>>;
  SENT_BACK?: Maybe<Array<Maybe<SubtaskDeliveryValidationItemsParcelsInput>>>;
  NOT_RETURNED?: Maybe<Array<Maybe<SubtaskDeliveryValidationItemsParcelsInput>>>;
};

export type SubtaskProcessingItemsInput = {
  toPick?: Maybe<Array<Maybe<Scalars['ID']>>>;
  toDelivered?: Maybe<SubtaskProcessingItemsDeliveredInput>;
  tourData?: Maybe<TourSubTaskProcessingInput>;
};

export type SubtaskReschedulingByClientDataResponse = {
  subtask?: Maybe<SubTask>;
  parcels?: Maybe<Array<Maybe<Parcel>>>;
};

export type SubtaskReschedulingByClientInput = {
  subtaskID: Scalars['ID'];
  execution_date: Scalars['String'];
  execution_slot_start: Scalars['String'];
  execution_slot_end: Scalars['String'];
};

export type SubtaskReschedulingByClientResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<SubtaskReschedulingByClientDataResponse>;
};

/** SUBTASKRESCHEDULING INPUT */
export type SubtaskReschedulingInput = {
  subtaskID: Scalars['ID'];
};

/** SUBTASKRESCHEDULING RESPONSE */
export type SubtaskReschedulingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<SubTask>;
};

/** SUBTASK BY TASK ID */
export type SubtasksByTaskParams = {
  taskID?: Maybe<Scalars['ID']>;
};

export type SubtasksByTaskQueries = {
  papserID: Scalars['ID'];
};

export type SubtasksByTaskResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<SubTask>>>;
};

export type Task = {
  _id?: Maybe<Scalars['ID']>;
  task_UID?: Maybe<Scalars['String']>;
  task_driver_UID?: Maybe<Scalars['String']>;
  task_driver?: Maybe<Driver>;
  task_vehicule_UID?: Maybe<Scalars['String']>;
  task_vehicule?: Maybe<Vehicle>;
  task_conveyor_UID?: Maybe<Scalars['String']>;
  task_conveyor?: Maybe<Conveyor>;
  task_client_UID?: Maybe<Scalars['String']>;
  task_client?: Maybe<Client>;
  task_vehicle_type?: Maybe<TaskVehicleType>;
  requested_vehicle_type?: Maybe<TaskVehicleType>;
  task_status?: Maybe<TaskStatus>;
  task_type?: Maybe<TaskType>;
  task_operation_on_job?: Maybe<Job>;
  task_operation_on_runsheet?: Maybe<Runsheet>;
  task_execution_date?: Maybe<Scalars['String']>;
  task_execution_slot_start?: Maybe<Scalars['String']>;
  task_execution_slot_end?: Maybe<Scalars['String']>;
  task_created_at?: Maybe<Scalars['String']>;
  task_created_by?: Maybe<Scalars['String']>;
  task_last_edited_by?: Maybe<Scalars['String']>;
  task_last_edited_at?: Maybe<Scalars['String']>;
  task_subtasks?: Maybe<Array<Maybe<SubTask>>>;
  countries?: Maybe<Array<Maybe<Country>>>;
  toTransfer?: Maybe<Scalars['Boolean']>;
  transferRequest?: Maybe<Array<Maybe<TaskTransferRequest>>>;
  drivers?: Maybe<Array<Maybe<Driver>>>;
  conveyors?: Maybe<Array<Maybe<Conveyor>>>;
  requestId?: Maybe<Scalars['ID']>;
  request?: Maybe<Request>;
  missionUid?: Maybe<Scalars['String']>;
  activities?: Maybe<Array<Maybe<Activity>>>;
  taskIssueReason?: Maybe<Reason>;
  otherReason?: Maybe<Scalars['String']>;
  additionalInfos?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  weKnowWhatToDo?: Maybe<Scalars['Boolean']>;
};

export type TaskBadgeInput = {
  key: Scalars['String'];
  value: Array<Maybe<TaskStatus>>;
};

export type TaskBadgesByStatusQueries = {
  groupStatus: Array<Maybe<TaskBadgeInput>>;
  dateFilter?: Maybe<Scalars['String']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TaskByIdsFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<TaskMissionWithClient>>>;
};

export type TaskByMissionsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Task>>;
};

export type TaskByParcelFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<TaskMission>;
};

export type TaskByParcelQueries = {
  parcelUID: Scalars['String'];
};

export type TaskClientHistoryExport = {
  task_UID?: Maybe<Scalars['String']>;
  task_type?: Maybe<SubTaskType>;
  task_status?: Maybe<SubTaskStatus>;
  creationDate?: Maybe<Scalars['String']>;
  receiver_fullname?: Maybe<Scalars['String']>;
  receiver_phone_number?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  execution_date?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['String']>;
  parcels?: Maybe<Scalars['String']>;
  creation_date?: Maybe<Scalars['String']>;
  updated_date?: Maybe<Scalars['String']>;
};

export type TaskMission = {
  _id?: Maybe<Scalars['ID']>;
  type?: Maybe<ERequestType>;
  stops?: Maybe<Array<Maybe<Stop>>>;
  axe?: Maybe<Scalars['ID']>;
  status?: Maybe<TaskMissionStatus>;
  runsheetId?: Maybe<Scalars['ID']>;
  dragged?: Maybe<Scalars['Boolean']>;
  action?: Maybe<EActionType>;
  vehiculeType?: Maybe<EVehiculeType>;
  uid?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
  activities?: Maybe<Array<Maybe<Activity>>>;
  task_driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars['String']>;
  isReturn?: Maybe<Scalars['Boolean']>;
};

export type TaskMissionByRunsheetParams = {
  runsheetId: Scalars['ID'];
};

export type TaskMissionByRunsheetResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<TaskMission>>>;
};

export type TaskMissionRunsheet = {
  type?: Maybe<ERequestType>;
  stops?: Maybe<Array<Maybe<StopInput>>>;
  dragged?: Maybe<Scalars['Boolean']>;
};

export enum TaskMissionStatus {
  NotStarted = 'NOT_STARTED',
  ToBeAssigned = 'TO_BE_ASSIGNED',
  Assigned = 'ASSIGNED',
  Started = 'STARTED',
  Done = 'DONE',
  Unassigned = 'UNASSIGNED',
  Cancelled = 'CANCELLED',
  ToReschedule = 'TO_RESCHEDULE',
  OnGoing = 'ON_GOING',
  Paused = 'PAUSED',
  InProgress = 'IN_PROGRESS'
}

export type TaskMissionWithClient = {
  _id?: Maybe<Scalars['ID']>;
  type?: Maybe<ERequestType>;
  stops?: Maybe<Array<Maybe<Stop>>>;
  axe?: Maybe<Scalars['ID']>;
  status?: Maybe<TaskMissionStatus>;
  runsheetId?: Maybe<Scalars['ID']>;
  dragged?: Maybe<Scalars['Boolean']>;
  action?: Maybe<EActionType>;
  vehiculeType?: Maybe<EVehiculeType>;
  clientId?: Maybe<Scalars['ID']>;
  productType?: Maybe<Array<Maybe<EProductType>>>;
  isReturn?: Maybe<Scalars['Boolean']>;
};

export enum TaskStatus {
  Unassigned = 'UNASSIGNED',
  Assigned = 'ASSIGNED',
  Done = 'DONE',
  Cancelled = 'CANCELLED',
  ToReschedule = 'TO_RESCHEDULE',
  Started = 'STARTED',
  OnGoing = 'ON_GOING',
  Paused = 'PAUSED'
}

export type TaskToExport = {
  task_ID?: Maybe<Scalars['ID']>;
  task_UID?: Maybe<Scalars['String']>;
  task_type?: Maybe<TaskType>;
  task_status?: Maybe<TaskStatus>;
  subtask_type?: Maybe<SubTaskType>;
  subtask_status?: Maybe<SubTaskStatus>;
  parcel_UID?: Maybe<Scalars['String']>;
  parcel_size?: Maybe<ParcelSize>;
  parcel_attempts?: Maybe<Scalars['String']>;
  parcel_status?: Maybe<Scalars['String']>;
  parcel_amount_to_collect?: Maybe<Scalars['String']>;
  amountCollected?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
  requested_vehicle_type?: Maybe<Scalars['String']>;
  stops?: Maybe<Scalars['String']>;
  perStops?: Maybe<Array<Maybe<Stop>>>;
  product?: Maybe<Scalars['String']>;
  planned_execution_date?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['String']>;
  vehicle_license_plat?: Maybe<Scalars['String']>;
  partner_name?: Maybe<Scalars['String']>;
  execution_date?: Maybe<Scalars['String']>;
  driver_fullname?: Maybe<Scalars['String']>;
  driver_id?: Maybe<Scalars['String']>;
  driver_phone_number?: Maybe<Scalars['String']>;
  conveyor_id?: Maybe<Scalars['String']>;
  conveyor_fullname?: Maybe<Scalars['String']>;
  conveyor_phone_number?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['ID']>;
  client_fullname?: Maybe<Scalars['String']>;
  client_phone_number?: Maybe<Scalars['String']>;
  client_address?: Maybe<Scalars['String']>;
  client_city?: Maybe<Scalars['String']>;
  client_country?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  mad_address?: Maybe<Scalars['String']>;
  mad_city?: Maybe<Scalars['String']>;
  receiver_fullname?: Maybe<Scalars['String']>;
  receiver_phone_number?: Maybe<Scalars['String']>;
  delivery_date?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  order_size?: Maybe<OrderSize>;
  order_UID?: Maybe<Scalars['String']>;
  creation_date?: Maybe<Scalars['String']>;
  updated_date?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  dispatcher_number?: Maybe<Scalars['String']>;
  axe_name?: Maybe<Scalars['String']>;
  manufacturer_number?: Maybe<Scalars['String']>;
  mission_execution_date?: Maybe<Scalars['String']>;
  mission_slot?: Maybe<Scalars['String']>;
  starting_time?: Maybe<Scalars['String']>;
  ending_time?: Maybe<Scalars['String']>;
  stop?: Maybe<Scalars['String']>;
  additionalInfos?: Maybe<Scalars['String']>;
  pickup_stop?: Maybe<Scalars['String']>;
  delivery_stop?: Maybe<Scalars['String']>;
  product_to_pick?: Maybe<Scalars['String']>;
  quantity_to_pick?: Maybe<Scalars['String']>;
  product_to_deliver?: Maybe<Scalars['String']>;
  quantity_to_deliver?: Maybe<Scalars['String']>;
  pickup_address?: Maybe<Scalars['String']>;
  picked_product?: Maybe<Scalars['String']>;
  delivered_product?: Maybe<Scalars['String']>;
  parcel_tracking?: Maybe<Scalars['String']>;
  product_value?: Maybe<Scalars['String']>;
  mission_price?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  total_price_estimated?: Maybe<Scalars['String']>;
  additional_infos?: Maybe<Scalars['String']>;
  papser_pickup_date?: Maybe<Scalars['String']>;
  papser_delivery_date?: Maybe<Scalars['String']>;
  task_creation_date?: Maybe<Scalars['String']>;
  task_assignation_date?: Maybe<Scalars['String']>;
  task_signalement?: Maybe<Scalars['String']>;
};

export type TaskToExportClientData = {
  tasksCount: Scalars['Int'];
  tasks?: Maybe<Array<Maybe<TaskClientHistoryExport>>>;
};

export type TaskToExportClientInput = {
  clientId: Scalars['ID'];
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  taskType?: Maybe<Array<Maybe<SubTaskType>>>;
  taskStatus?: Maybe<Array<Maybe<SubTaskStatus>>>;
  papsService?: Maybe<PapsService>;
};

export type TaskToExportClientResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<TaskToExportClientData>;
};

export type TaskToExportData = {
  tasksCount: Scalars['Int'];
  tasks?: Maybe<Array<Maybe<TaskToExport>>>;
};

/** TASK TO EXPORT INPUT */
export type TaskToExportInput = {
  clientId?: Maybe<Scalars['ID']>;
  countryCode?: Maybe<Array<Maybe<Scalars['String']>>>;
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
  papsService: PapsService;
  perStop?: Maybe<Scalars['Boolean']>;
};

export type TaskToExportResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<TaskToExportData>;
};

export enum TaskTranferRequestOrigin {
  Papser = 'PAPSER',
  Ops = 'OPS'
}

export enum TaskTranferRequestStatus {
  Requested = 'REQUESTED',
  Accepted = 'ACCEPTED',
  Done = 'DONE',
  Cancelled = 'CANCELLED'
}

export type TaskTransferProcessingInput = {
  currentDriver: Scalars['ID'];
  nextDriver: Scalars['ID'];
  requestId: Scalars['ID'];
};

export type TaskTransferProcessingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<TaskTransferRequest>;
};

export type TaskTransferRequest = {
  _id?: Maybe<Scalars['ID']>;
  task?: Maybe<Task>;
  currentDriver?: Maybe<Driver>;
  currentConveyor?: Maybe<Conveyor>;
  nextDriver?: Maybe<Driver>;
  nextConveyor?: Maybe<Conveyor>;
  status?: Maybe<TaskTranferRequestStatus>;
  origin?: Maybe<TaskTranferRequestOrigin>;
  subtasks?: Maybe<Array<Maybe<SubTask>>>;
  createdAt?: Maybe<Scalars['String']>;
  doneAt?: Maybe<Scalars['String']>;
  lastEditedAt?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  countries?: Maybe<Array<Maybe<Country>>>;
  createdBy?: Maybe<TaskTransferRequestor>;
};

export type TaskTransferRequestFromOpsInput = {
  taskId: Scalars['ID'];
  subtaskIds: Array<Scalars['ID']>;
  nextDriver: Scalars['ID'];
  nextConveyor?: Maybe<Scalars['ID']>;
  reasonUID: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
};

export type TaskTransferRequestFromPapserInput = {
  currentDriver: Scalars['ID'];
  taskId: Scalars['ID'];
  subtaskIds: Array<Scalars['ID']>;
};

export type TaskTransferRequestResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<TaskTransferRequest>>>;
};

export type TaskTransferRequestor = UserStaff | Driver;

export enum TaskType {
  Parcel = 'PARCEL',
  ParcelReturn = 'PARCEL_RETURN',
  Job = 'JOB',
  Mad = 'MAD',
  Tour = 'TOUR',
  Nt = 'NT'
}

export enum TaskVehicleType {
  Scooter = 'SCOOTER',
  Tricycle = 'TRICYCLE',
  MiniVan = 'MINI_VAN',
  Van = 'VAN',
  Truck_3T = 'TRUCK_3T',
  Truck_5T = 'TRUCK_5T',
  Truck_7T = 'TRUCK_7T',
  Truck_8T = 'TRUCK_8T',
  Truck_9T = 'TRUCK_9T',
  Truck_10T = 'TRUCK_10T',
  Truck_12T = 'TRUCK_12T',
  Truck_15T = 'TRUCK_15T',
  Truck_20T = 'TRUCK_20T',
  Truck_25T = 'TRUCK_25T',
  Truck_30T = 'TRUCK_30T',
  Truck_35T = 'TRUCK_35T',
  Truck_50T = 'TRUCK_50T',
  RefrigeratedTruck_3T = 'REFRIGERATED_TRUCK_3T',
  RefrigeratedTruck_5T = 'REFRIGERATED_TRUCK_5T',
  RefrigeratedTruck_8T = 'REFRIGERATED_TRUCK_8T',
  RefrigeratedTruck_10T = 'REFRIGERATED_TRUCK_10T',
  RefrigeratedTruck_12T = 'REFRIGERATED_TRUCK_12T'
}

export type TasksByIdsQueries = {
  tasksIds: Array<Scalars['String']>;
};

/** ALLTASKSBYPAPSER PARAMS */
export type TasksByPapserFetchParams = {
  papserId: Scalars['ID'];
};

/** ALLTASKSBYPAPSER QUERIES */
export type TasksByPapserFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<TaskStatus>>>;
  type?: Maybe<Array<Maybe<TaskType>>>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** ALLTASKS INPUT */
export type TasksFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['String']>;
  dateTo?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<TaskStatus>>>;
  type?: Maybe<Array<Maybe<TaskType>>>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  papserType?: Maybe<PType>;
  idPapser?: Maybe<Scalars['String']>;
  idClient?: Maybe<Scalars['ID']>;
  idReceiver?: Maybe<Scalars['ID']>;
  place_id?: Maybe<Scalars['String']>;
};

/** ALLTASKS RESPONSE */
export type TasksFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Task>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type TasksMissionQueries = {
  id: Scalars['ID'];
};

export type TasksMissionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<TaskMission>>>;
};

export type TasksMissionTourResponse = {
  tasks?: Maybe<Array<Maybe<Task>>>;
  missions?: Maybe<Array<Maybe<Mission>>>;
};

export type Template = {
  _id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<Event>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  link?: Maybe<Scalars['String']>;
  platform?: Maybe<Array<Maybe<EPlatform>>>;
};

export type TemplateAxe = {
  _id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EAxisType>;
  templateStops?: Maybe<Array<Maybe<TemplateStop>>>;
  vehicles?: Maybe<Array<Maybe<Vehicles>>>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  reccurenceType?: Maybe<EReccurenceType>;
  reccurenceOptions?: Maybe<ReccurenceOptions>;
  price?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Int']>;
};

export type TemplateAxeInput = {
  name: Scalars['String'];
  templateStops: Array<Maybe<TemplateStopsInput>>;
  vehicles: Array<Maybe<EVehiclesInput>>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  reccurenceType?: Maybe<EReccurenceType>;
  reccurenceOptions?: Maybe<ReccurenceOptionsInput>;
  discount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};

export type TemplateAxeRedefineInput = {
  uid: Scalars['String'];
  templateAxes: Array<TemplateAxeInput>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
};

export type TemplateAxeRedefineResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<TemplateAxe>>>;
};

export type TemplateDeleteReturn = {
  data?: Maybe<Template>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type TemplateFetchResponse = {
  data?: Maybe<Array<Maybe<Template>>>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type TemplateInput = {
  message: Scalars['String'];
  events?: Maybe<Array<Scalars['ID']>>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  link?: Maybe<Scalars['String']>;
  platform?: Maybe<Array<Maybe<EPlatform>>>;
  service?: Maybe<Array<Maybe<EService>>>;
};

export type TemplateReturn = {
  data?: Maybe<Template>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type TemplateStop = {
  _id?: Maybe<Scalars['ID']>;
  libelle?: Maybe<ERequestType>;
  request?: Maybe<Scalars['ID']>;
  action?: Maybe<EActionType>;
  itemsToPick?: Maybe<Array<Maybe<Items>>>;
  itemsToDelivered?: Maybe<Array<Maybe<Items>>>;
  position?: Maybe<Scalars['Int']>;
  address?: Maybe<Address>;
  createdBy?: Maybe<CreatedBy>;
  editedBy?: Maybe<EditedBy>;
  createdAt?: Maybe<Scalars['String']>;
  editedAt?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  pickupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  hubId?: Maybe<Scalars['ID']>;
  isForRelay?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Int']>;
};

export type TemplateStopActionUpdateInput = {
  templateStops?: Maybe<Array<Maybe<StopActionItemInput>>>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
};

export type TemplateStopActionUpdated = {
  templateStops: Array<Maybe<ActionUpdatedItem>>;
};

export type TemplateStopCreation = {
  action?: Maybe<EActionType>;
  itemsToPick?: Maybe<Array<Maybe<TemsCreation>>>;
  itemsToDelivery?: Maybe<Array<Maybe<TemsCreation>>>;
  address?: Maybe<Address>;
};

export type TemplateStopDisableUpdated = {
  _id?: Maybe<Scalars['ID']>;
  templateStopId: Scalars['ID'];
  isDisabled: Scalars['Boolean'];
  dateRange?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TemplateStopInput = {
  libelle?: Maybe<ERequestType>;
  request?: Maybe<Scalars['ID']>;
  action?: Maybe<EActionType>;
  itemsToPick?: Maybe<Array<Maybe<ItemsInput>>>;
  itemsToDelivered?: Maybe<Array<Maybe<ItemsInput>>>;
  position?: Maybe<Scalars['Int']>;
  address?: Maybe<AddressInput>;
  createdAt?: Maybe<Scalars['String']>;
  editedAt?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
};

export enum TemplateStopUpdateType {
  Added = 'ADDED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type TemplateStopsInput = {
  action?: Maybe<EActionType>;
  address: AddressCreationInput;
  position?: Maybe<Scalars['Int']>;
  itemsToPick?: Maybe<Array<ItemsTemplateStopsInput>>;
  itemsToDelivered?: Maybe<Array<ItemsTemplateStopsInput>>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  hubId?: Maybe<Scalars['ID']>;
  pickupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  discount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};

export type TemplateStopsUpdateInput = {
  action: EActionType;
  address: AddressCreationInput;
  position: Scalars['Int'];
  itemsToPick?: Maybe<Array<ItemsTemplateStopsInput>>;
  itemsToDelivered?: Maybe<Array<ItemsTemplateStopsInput>>;
  discount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};

export type TemplateUpdateReturn = {
  data?: Maybe<Template>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type TemplatesFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type TemplatesReturn = {
  data?: Maybe<Array<Maybe<Template>>>;
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type TemsCreation = {
  product?: Maybe<Product>;
  counter?: Maybe<Scalars['Int']>;
  pickup?: Maybe<TemplateStopCreation>;
};

export type TourDataInput = {
  request: Scalars['ID'];
  axes: Array<AxeInput>;
  executionDate: Scalars['String'];
};

export type TourItem = {
  description?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type TourItemDeliveryPointsInput = {
  subtask: Scalars['ID'];
  items: Array<Maybe<TourItemInput>>;
};

export type TourItemInput = {
  description?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type TourItemWithPickupSubtask = {
  _id?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  pickup: Scalars['ID'];
};

export type TourSubTaskProcessingInput = {
  action?: Maybe<SubTaskType>;
  pickedItems?: Maybe<Array<Maybe<TourItemInput>>>;
  deliveredItems?: Maybe<Array<Maybe<TourItemInput>>>;
  deliveryPoints?: Maybe<Array<Maybe<TourItemDeliveryPointsInput>>>;
  subtaskToCreateAddress?: Maybe<AddressInput>;
  subtaskToCreate?: Maybe<Scalars['Boolean']>;
};

export type TransferRequestFetchQueries = {
  status?: Maybe<Array<Maybe<TaskTranferRequestStatus>>>;
  date?: Maybe<Scalars['String']>;
};

export type Translation = {
  lang?: Maybe<Lang>;
  text?: Maybe<Scalars['String']>;
};

export type TranslationInput = {
  lang?: Maybe<Lang>;
  text?: Maybe<Scalars['String']>;
};

/** UNASSIGN RUNSHEET RESPONSE */
export type UnassignRunsheetResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

/** UNASSIGN TASK RESPONSE */
export type UnassignTaskResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type UnsubscribeProgramInput = {
  programId: Scalars['ID'];
  clientId: Scalars['ID'];
};

export type UnsubscribeProgramResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
};

export type UpdateActionInput = {
  /** type of the action (pickup or delivery) */
  type?: Maybe<ActionType>;
  /** Course client ID! */
  clientId?: Maybe<Scalars['String']>;
  /** Course reference! */
  reference?: Maybe<Scalars['String']>;
  /** action address */
  address?: Maybe<Scalars['String']>;
  /** Action execution date! */
  executionDate?: Maybe<Scalars['String']>;
  /** Action execution time! */
  executionTime?: Maybe<Scalars['String']>;
  /** Action items */
  items?: Maybe<Array<ItemInput>>;
  /** Action remittance informations */
  remittance?: Maybe<RemittanceInput>;
  /** Action receiver */
  receiver?: Maybe<IContactInfo>;
  id?: Maybe<Scalars['ID']>;
};

export type UpdateAdvantageInput = {
  _id?: Maybe<Scalars['ID']>;
  service: Scalars['ID'];
  address: AddressInput;
  quantity: Scalars['Int'];
  maxAmount: Scalars['Float'];
  program: Scalars['ID'];
};

export type UpdateAdvantageParams = {
  id: Scalars['ID'];
  advantage: UpdateAdvantageInput;
};

export type UpdateAdvantageResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Advantage>;
};

export type UpdateAdvantageSubscriptionInput = {
  advantageId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type UpdateClientRefAddressInput = {
  clientAddress: UpdateClientAddressInput;
  id: Scalars['ID'];
};

export type UpdateCourseInput = {
  /** Course client ID! */
  clientId?: Maybe<Scalars['String']>;
  /** Course client type */
  isIndividual?: Maybe<Scalars['Boolean']>;
  /** Course individual client! */
  individualClientId?: Maybe<Scalars['String']>;
  /** Course actions! */
  actions?: Maybe<Array<UpdateActionInput>>;
  /** Course additionnal information! */
  additionalInformation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** UPDATEDATEDELIVERYSUBTASKAFTERRESCHEDULING RESPONSE */
export type UpdateDateDeliverySubtaskAfterReschedulingDataResponse = {
  subtask?: Maybe<SubTask>;
  choice?: Maybe<Scalars['String']>;
};

/** UPDATEDATEDELIVERYSUBTASKAFTERRESCHEDULING INPUT */
export type UpdateDateDeliverySubtaskAfterReschedulingInput = {
  subtaskID: Scalars['ID'];
  execution_date: Scalars['String'];
  execution_slot_start: Scalars['String'];
  execution_slot_end: Scalars['String'];
};

export type UpdateDateDeliverySubtaskAfterReschedulingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<UpdateDateDeliverySubtaskAfterReschedulingDataResponse>;
};

export type UpdateDriverInput = {
  /** Example field (placeholder) */
  exampleField?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
};

export type UpdateIndividualClientAddressInput = {
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressName?: Maybe<Scalars['String']>;
};

/** UPDATEMULTIPLEDATEDELIVERYSUBTASKAFTERRESCHEDULING INPUT */
export type UpdateMultipleDateDeliverySubtaskAfterReschedulingInput = {
  subtaskIDs: Array<Scalars['ID']>;
  execution_date: Scalars['String'];
  execution_slot_start: Scalars['String'];
  execution_slot_end: Scalars['String'];
};

/** UPDATEMULTIPLEDATEDELIVERYSUBTASKAFTERRESCHEDULING RESPONSE */
export type UpdateMultipleDateDeliverySubtaskAfterReschedulingResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<SubTask>>>;
};

export type UpdateOrdersInRunsheetDataResponse = {
  runsheet?: Maybe<Runsheet>;
  ordersAdded?: Maybe<Array<Maybe<Order>>>;
  orderDeleted?: Maybe<Order>;
  parcelsDeleted?: Maybe<Array<Maybe<Parcel>>>;
};

export type UpdateOrdersInRunsheetInput = {
  runsheetID: Scalars['ID'];
  ordersAdded?: Maybe<Array<UpdateOrdersInRunsheetOrderToAddInput>>;
  ordersDeleted?: Maybe<Array<UpdateOrdersInRunsheetOrderToAddInput>>;
  parcelsAdded?: Maybe<Array<Scalars['ID']>>;
  parcelsDeleted?: Maybe<Array<Scalars['ID']>>;
  toReturn?: Maybe<Scalars['Boolean']>;
};

export type UpdateOrdersInRunsheetOrderToAddInput = {
  orderID?: Maybe<Scalars['ID']>;
  parcelIDs?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UpdateOrdersInRunsheetResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<UpdateOrdersInRunsheetDataResponse>;
};

export type UpdatePermissionInput = {
  id: Scalars['ID'];
  permission?: Maybe<PermissionInput>;
};

export type UpdatePermissionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Permission>;
};

export type UpdateProgramInput = {
  iconUrl: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  advantages: Array<UpdateAdvantageInput>;
};

export type UpdateProgramParams = {
  programId: Scalars['ID'];
  program: UpdateProgramInput;
};

export type UpdateProgramResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<Program>;
};

export type UpdateRequestInput = {
  vehicles?: Maybe<Array<Maybe<EVehiclesInput>>>;
  templateStops?: Maybe<Array<Maybe<TemplateStopsUpdateInput>>>;
  startDate?: Maybe<Scalars['String']>;
  templateAxes?: Maybe<Array<Maybe<TemplateAxeInput>>>;
  endDate?: Maybe<Scalars['String']>;
  slotStart?: Maybe<Scalars['String']>;
  slotEnd?: Maybe<Scalars['String']>;
  address?: Maybe<AddressCreationInput>;
  productType?: Maybe<Array<Maybe<EProductType>>>;
  additionnalInfos?: Maybe<Scalars['String']>;
  reccurenceType?: Maybe<EReccurenceType>;
  reccurenceOptions?: Maybe<ReccurenceOptionsInput>;
  handler?: Maybe<HandlerInput>;
  dispatcher?: Maybe<DispatcherInput>;
  discount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  status?: Maybe<ERequestStatus>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  clientId?: Maybe<Scalars['String']>;
  pricingType?: Maybe<RequestPricing>;
  packagePrice?: Maybe<Scalars['Int']>;
};

export type UpdateRoleInput = {
  id: Scalars['ID'];
  role?: Maybe<RoleUpdatingInput>;
};

export type UpdateRoleResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Role>;
};

export type UpdateServiceInput = {
  id: Scalars['ID'];
  service: ServiceInput;
};

export type UpdateServiceRespone = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Service>;
};

export type UpdateSubscribeProgramInput = {
  programId: Scalars['ID'];
  clientId: Scalars['ID'];
  advantages: Array<UpdateAdvantageSubscriptionInput>;
};

export type UpdateSubscribeProgramResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
};

export type UpdateUserInfosInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  job?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  countries?: Maybe<Array<Maybe<CountryInput>>>;
  hub?: Maybe<Scalars['String']>;
  type?: Maybe<UserType>;
};

export type UpdateUserInput = {
  userID: Scalars['ID'];
  user: UpdateUserInfosInput;
};

export type UpdateUserResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataAddUserResponse>;
};

export type UseAdvantageInput = {
  clientId: Scalars['ID'];
  advantageId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
};

export type UseAdvantageResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  data?: Maybe<SubscriptionAdvantageItem>;
};

export type User = {
  _id?: Maybe<Scalars['ID']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
};

export type UserCreatedBy = {
  _id?: Maybe<Scalars['ID']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
};

export type UserInfosInput = {
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  email: Scalars['String'];
  phone_number?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  job?: Maybe<Scalars['String']>;
  hub?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  countries?: Maybe<Array<Maybe<CountryInput>>>;
  type?: Maybe<UserType>;
};

export type UserLoginInput = {
  email: Scalars['String'];
};

export type UserLoginOpsInput = {
  email: Scalars['String'];
};

export type UserPapser = {
  id?: Maybe<Scalars['ID']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  code_otp?: Maybe<CodeOtp>;
  verified?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  user_infos_conveyor?: Maybe<Conveyor>;
  user_infos_driver?: Maybe<Driver>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<Scalars['String']>;
  expo_push_token?: Maybe<Scalars['String']>;
};

export type UserPapserUpdateInput = {
  id: Scalars['ID'];
  user?: Maybe<UserPapserUpdateItemsInput>;
};

export type UserPapserUpdateItemsInput = {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  expo_push_token?: Maybe<Scalars['String']>;
};

export type UserPapserUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataUserPapserUpdateResponse>;
};

export type UserStaff = {
  _id?: Maybe<Scalars['ID']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Maybe<Country>>>;
  photo_profil?: Maybe<Scalars['String']>;
  job?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  verificationToken?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['String']>;
  resetToken?: Maybe<ResetToken>;
  passwordReset?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  hub?: Maybe<Hub>;
  created_by?: Maybe<UserStaffCreatedOrUpdatedBy>;
  created_at?: Maybe<Scalars['String']>;
  last_edited_at?: Maybe<Scalars['String']>;
  last_edited_by?: Maybe<UserStaffCreatedOrUpdatedBy>;
  type?: Maybe<UserType>;
};

export type UserStaffAdminHubParams = {
  hubId: Scalars['ID'];
};

export type UserStaffAdminHubQuery = {
  q?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type UserStaffCreatedOrUpdatedBy = {
  user_id?: Maybe<Scalars['ID']>;
  user?: Maybe<UserStaff>;
  source?: Maybe<Scalars['String']>;
};

export type UserStaffFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
  userType?: Maybe<UserType>;
  hub?: Maybe<Scalars['ID']>;
};

export type UserStaffFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataUserStaffResponse>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export enum UserType {
  Warehouse = 'WAREHOUSE',
  Relay = 'RELAY'
}

export type UsersPaginationResult = {
  users?: Maybe<Array<Maybe<UserStaff>>>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type UsersStaffBelongToHubResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<UsersPaginationResult>;
};

export enum Vehicle_Payment_Mode {
  Monthly = 'MONTHLY',
  PerRide = 'PER_RIDE',
  Daily = 'DAILY'
}

export enum Vehicle_State {
  Good = 'GOOD',
  Medium = 'MEDIUM',
  BrokenDown = 'BROKEN_DOWN'
}

export enum Vehicle_Type {
  Scooter = 'SCOOTER',
  MiniVan = 'MINI_VAN',
  Van = 'VAN',
  Tricycle = 'TRICYCLE',
  Truck_3T = 'TRUCK_3T',
  Truck_5T = 'TRUCK_5T',
  Truck_7T = 'TRUCK_7T',
  Truck_8T = 'TRUCK_8T',
  Truck_9T = 'TRUCK_9T',
  Truck_10T = 'TRUCK_10T',
  Truck_12T = 'TRUCK_12T',
  Truck_15T = 'TRUCK_15T',
  Truck_20T = 'TRUCK_20T',
  Truck_25T = 'TRUCK_25T',
  Truck_30T = 'TRUCK_30T',
  Truck_35T = 'TRUCK_35T',
  Truck_50T = 'TRUCK_50T',
  RefrigeratedTruck_3T = 'REFRIGERATED_TRUCK_3T',
  RefrigeratedTruck_5T = 'REFRIGERATED_TRUCK_5T',
  RefrigeratedTruck_8T = 'REFRIGERATED_TRUCK_8T',
  RefrigeratedTruck_10T = 'REFRIGERATED_TRUCK_10T',
  RefrigeratedTruck_12T = 'REFRIGERATED_TRUCK_12T'
}

export enum ValidUpdatingStatus {
  Failed = 'FAILED',
  Cancelled = 'CANCELLED',
  ToReturn = 'TO_RETURN',
  OnDelivery = 'ON_DELIVERY',
  ToHandOver = 'TO_HAND_OVER',
  ToBeAssigned = 'TO_BE_ASSIGNED',
  AwaitingDelivery = 'AWAITING_DELIVERY',
  HandedOver = 'HANDED_OVER',
  Lost = 'LOST'
}

export type ValidateAccountOpsInput = {
  token?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

export type ValidateAccountOpsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataValidateOpsResponse>;
};

export type ValidatePickUpByReceiverResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type ValidateTaskTransferRequestInput = {
  requestId: Scalars['ID'];
  subtaskIds: Array<Scalars['ID']>;
  nextDriver: Scalars['ID'];
  nextConveyor?: Maybe<Scalars['ID']>;
  reasonUID: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
};

/** SENDMAIL INPUT */
export type VariableInput = {
  title: Scalars['String'];
  firstname: Scalars['String'];
  message: Scalars['String'];
  button_name: Scalars['String'];
  button_link: Scalars['String'];
};

export type Vehicle = {
  _id?: Maybe<Scalars['ID']>;
  vehicle_UID?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Vehicle_Type>;
  vehicle_brand?: Maybe<Scalars['String']>;
  vehicle_model?: Maybe<Scalars['String']>;
  vehicle_volume?: Maybe<Scalars['Float']>;
  vehicle_weight?: Maybe<Scalars['Float']>;
  vehicle_depth?: Maybe<Scalars['Float']>;
  vehicle_width?: Maybe<Scalars['Float']>;
  vehicle_height?: Maybe<Scalars['Float']>;
  vehicle_fuel_efficiency?: Maybe<Scalars['Float']>;
  vehicle_license_plat?: Maybe<Scalars['String']>;
  vehicle_status?: Maybe<Vehicle_State>;
  vehicle_payment_mode?: Maybe<Vehicle_Payment_Mode>;
  vehicle_address?: Maybe<Address>;
  vehicle_registration_url?: Maybe<Scalars['String']>;
  vehicle_insurance_url?: Maybe<Scalars['String']>;
  vehicle_insurance_expiration_date?: Maybe<Scalars['String']>;
  vehicle_partner?: Maybe<Partner>;
  vehicle_driver?: Maybe<Driver>;
  vehicle_created_at?: Maybe<Scalars['String']>;
  vehicle_created_by?: Maybe<Scalars['String']>;
};

export type VehicleCheckInput = {
  vehicleRegistration: Scalars['String'];
};

/** ADDVEHICLE INPUT */
export type VehicleCreationInput = {
  vehicle: VehicleItemsInput;
};

/** ADDVEHICLE RESPONSE */
export type VehicleCreationResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataVehicleCreationResponse>;
};

/** DELETE VEHICLE INPUT */
export type VehicleDeletionInput = {
  id: Scalars['ID'];
};

/** DELETE VEHICLE RESPONSE */
export type VehicleDeletionResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
};

export type VehicleExistCheckResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<VehicleExistResponse>;
};

export type VehicleExistResponse = {
  checkIfExist: Scalars['Boolean'];
};

export type VehicleItemsInput = {
  vehicle_type: Vehicle_Type;
  vehicle_brand: Scalars['String'];
  vehicle_model: Scalars['String'];
  vehicle_volume?: Maybe<Scalars['Float']>;
  vehicle_weight?: Maybe<Scalars['Float']>;
  vehicle_depth?: Maybe<Scalars['Float']>;
  vehicle_width?: Maybe<Scalars['Float']>;
  vehicle_height?: Maybe<Scalars['Float']>;
  vehicle_fuel_efficiency?: Maybe<Scalars['Float']>;
  vehicle_license_plat: Scalars['String'];
  vehicle_status: Vehicle_State;
  vehicle_payment_mode: Vehicle_Payment_Mode;
  vehicle_address: AddressCreationInput;
  vehicle_registration_url: Scalars['String'];
  vehicle_insurance_url: Scalars['String'];
  vehicle_insurance_expiration_date: Scalars['String'];
  vehicle_partner: Scalars['ID'];
  vehicle_driver?: Maybe<Scalars['ID']>;
};

export type VehicleItemsUpdate = {
  vehicle_type?: Maybe<Vehicle_Type>;
  vehicle_brand?: Maybe<Scalars['String']>;
  vehicle_model?: Maybe<Scalars['String']>;
  vehicle_volume?: Maybe<Scalars['Float']>;
  vehicle_weight?: Maybe<Scalars['Float']>;
  vehicle_depth?: Maybe<Scalars['Float']>;
  vehicle_width?: Maybe<Scalars['Float']>;
  vehicle_height?: Maybe<Scalars['Float']>;
  vehicle_fuel_efficiency?: Maybe<Scalars['Float']>;
  vehicle_license_plat?: Maybe<Scalars['String']>;
  vehicle_status?: Maybe<Vehicle_State>;
  vehicle_payment_mode?: Maybe<Vehicle_Payment_Mode>;
  vehicle_address?: Maybe<AddressCreationInput>;
  vehicle_registration_url?: Maybe<Scalars['String']>;
  vehicle_insurance_url?: Maybe<Scalars['String']>;
  vehicle_insurance_expiration_date?: Maybe<Scalars['String']>;
  vehicle_partner?: Maybe<Scalars['ID']>;
  vehicle_driver?: Maybe<Scalars['ID']>;
};

/** UPDATEVEHICLE INPUT */
export type VehicleUpdateInput = {
  id: Scalars['ID'];
  vehicle: VehicleItemsUpdate;
};

/** UPDATEVEHICLE RESPONSE */
export type VehicleUpdateResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataVehicleUpdatedResponse>;
};

export type Vehicles = {
  vehicleType?: Maybe<EVehiculeType>;
  numberOfVehicule?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Int']>;
};

export type VehiclesFetchQueries = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  vehicle_type?: Maybe<Array<Maybe<Vehicle_Type>>>;
  status?: Maybe<Array<Maybe<Vehicle_State>>>;
  countryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchText?: Maybe<Scalars['String']>;
  licensePlat?: Maybe<Scalars['String']>;
};

/** ALLVEHICLES RESPONSE */
export type VehiclesFetchResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataVehiclesResponse>;
  countTotal?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
};

export type VehiclesInput = {
  vehicleType?: Maybe<EVehiculeType>;
  numberOfVehicule?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Int']>;
};

export type VerifyAccountOpsInput = {
  token?: Maybe<Scalars['String']>;
};

export type VerifyAccountOpsResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DataVerifyAccountOpsResponse>;
};

export type ViewRequest = {
  byClient?: Maybe<Scalars['Boolean']>;
  byOps?: Maybe<Scalars['Boolean']>;
};

export enum Weight {
  S = 'S',
  M = 'M',
  L = 'L',
  X = 'X',
  Xl = 'XL',
  Xxl = 'XXL'
}

/** Activity trigger action ! */
export enum ActivityTriggerAction {
  Creation = 'CREATION',
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED',
  Finished = 'FINISHED',
  Started = 'STARTED',
  Updated = 'UPDATED'
}

/** Activity trigger user type ! */
export enum ActivityTriggerUserType {
  Ops = 'OPS',
  Client = 'CLIENT',
  Papser = 'PAPSER',
  Conveyor = 'CONVEYOR'
}

export type CategorieByCodeFetchParams = {
  code?: Maybe<Scalars['String']>;
};

export type ClientAddressInput = {
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phone_number: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  address: AddressCreationInput;
  default: Scalars['Boolean'];
};

export type ConfirmParcelReceptionResponse = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['Int']>;
};

export type DropParcelsAtWareHouseDataResponse = {
  runsheet?: Maybe<Runsheet>;
};

export type DropParcelsAtWareHouseResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<DropParcelsAtWareHouseDataResponse>;
};

export type GetAccountsByClientIdResponse = {
  error?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Account>>>;
  countTotal?: Maybe<Scalars['Int']>;
  currentPage?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type RecapQueries = {
  /** Course assigned driver ID! */
  driver: Scalars['String'];
  /** Course execution date! */
  from: Scalars['String'];
  /** Course execution date! */
  to: Scalars['String'];
};

/** BLOCKDRIVER INPUT */
export type SendReasonAndClientInput = {
  clientID: Scalars['String'];
  reason: Scalars['String'];
};

export type StartCourseInput = {
  /** Course assigned papser ID! */
  papserId: Scalars['String'];
  /** Course UID! */
  courseUID: Scalars['String'];
  /** Course finished reason! */
  reason?: Maybe<Scalars['String']>;
  /** User type who start the course */
  userType?: Maybe<ActivityTriggerUserType>;
};

export type UpdateClientAddressInput = {
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  address?: Maybe<AddressCreationInput>;
  default?: Maybe<Scalars['Boolean']>;
};

/** Vehicle type ! */
export enum VehicleType {
  Scooter = 'SCOOTER',
  MiniVan = 'MINI_VAN',
  Van = 'VAN',
  Tricycle = 'TRICYCLE',
  Truck_3T = 'TRUCK_3T',
  Truck_5T = 'TRUCK_5T',
  Truck_7T = 'TRUCK_7T',
  Truck_8T = 'Truck_8T',
  Truck_9T = 'TRUCK_9T',
  Truck_10T = 'TRUCK_10T',
  Truck_12T = 'Truck_12T',
  Truck_15T = 'TRUCK_15T',
  Truck_20T = 'TRUCK_20T',
  Truck_25T = 'TRUCK_25T',
  Truck_30T = 'TRUCK_30T',
  Truck_35T = 'TRUCK_35T',
  Truck_50T = 'TRUCK_50T'
}
